$(document).ready(function () {
  $(document).on('input', 'input[id *= vin]', function () {
    filterInputVin(this);
  });

  $('#scroll-to-top').on('click', function () {
    $('html, body').animate({ scrollTop: 0 }, 500);
  });

  $(window).scroll(function () {
    if ($(document).scrollTop() > 0) {
      $('#scroll-to-top').fadeIn('slow');
    } else {
      $('#scroll-to-top').fadeOut('slow');
    }
  });

  let clickAddToPlanObject = (e) => {
    let $this = $(e.currentTarget),
      $modal = $('#modalAddToTrip');
    let addObject = {
      id: $this.data('object-id'),
      name: $this.data('object-name'),
      contract: $modal.find('#contractObject').val(),
      plan: $modal.find('#destinationTrip option:selected').val(),
    };

    $modal.find('#objectName').text(addObject.name);
    $modal.modal('show');
  },
    objectAddToTrip = () => {
      let $this = $('#objectAddLink'),
        $modal = $('#modalAddToTrip'),
        isAddDelivery = Number(
          $('#modalAddToTrip #isAddDelivery').prop('checked')
        );
      let addObject = {
        id: $this.data('object-id'),
        name: $this.data('object-name'),
        contract: $modal.find('#contractObject').val(),
        plan: $modal.find('#destinationTrip option:selected').val(),
        quantity: $modal.find('#quantityObject').val(),
      };
      let queryParams = decodeURIComponent(
        $.param({
          id: addObject.id,
          contract: addObject.contract,
          plan: addObject.plan,
          quantity: addObject.quantity,
          isAddDelivery: isAddDelivery,
        })
      );
      $.post(`/navis/load?${queryParams}`, (data) => {
        if (data.startsWith('Погружено на рейс!')) {
          location.reload();
        }
      });
    };

  $('#modalAddToTrip .modal-footer .btn-primary').click(() => {
    $('#modalAddToTrip').modal('hide');
    objectAddToTrip();
  });

  let clickBoundaryCar = (e) => {
    /*let $this = $(e.currentTarget);

        let boundaryObject = {
            id: $this.data('object-id')
        };

        let queryParams = decodeURIComponent($.param({
            id: boundaryObject.id
        }));

        var isOK = confirm("Отметить машину как ПОГРАНИЧНУЮ?");
        if(isOK == true) {
            $.post(`/navis/boundary?${queryParams}`,
                (data) => {
                    if (data === '-1') {
                        alert('Некорректный идентификатор объекта!');
                    }
                    if(data == '1') {
                        $(`#car_${boundaryObject.id}`).css("border-color", "red");
                        $(`#car_${boundaryObject.id}`).css("border-style", "ridge");
                        $this.hide();
                    }
                }
            );
        }*/
  };

  let clickPhotosCar = (e) => {
    let $this = $(e.currentTarget),
      $modal = $('#modalPhotos');

    let photosObject = {
      id: $this.data('object-id'),
      name: $this.data('object-name'),
      number: $this.data('object-number'),
    };

    let queryParams = decodeURIComponent(
      $.param({
        id: photosObject.id,
      })
    );

    $.post(`/files/photos?${queryParams}`, (data) => {
      if (data === '-1') {
        alert('No photos found!');
      } else {
        $modal.find('#photosList').html(data);
        $modal.modal('show');
        $('.owl-carousel').owlCarousel('destroy');
        $('.owl-carousel').owlCarousel({
          items: 1,
          margin: 10,
          autoHeight: true,
          autoWidth: true,
        });
      }
    });
  };

  $('#modalPhotos .modal-footer .btn-primary').click(() => {
    $('#modalPhotos').modal('hide');
  });

  $(document).on(
    'click',
    '.deliveryDriveToPortAdd_Navis_Cars',
    function (event) {
      event.preventDefault();
      let objectId = $(this).data('object_id'),
        planId = $(this).data('plan_id'),
        objectName = $(this).data('object_name'),
        objectVin = $(this).data('object_vin'),
        successAction = (response) => {
          let htmlIcon =
            '<i style="color:royalblue" class="fa fa-car standard-size-icon"' +
            ' aria-hidden="true" title="Добавлено в список на сгон"></i> ',
            htmlLink =
              "<a href='' class='removeDeliveryDriveToPort' data-object_id='" +
              objectId +
              "' data-plan_id='" +
              planId +
              "' data-object_name='" +
              objectName +
              "' data-object_vin='" +
              objectVin +
              "'>Снять с доставки</a>";

          $(`#dlv-${objectId}`).html(htmlLink);
          $(`#dlv-check-${objectId}`).prepend(htmlIcon);
        },
        isConfirm = confirm(
          'Вы уверены, что хотите создать заявку на сгон ' +
          objectName +
          ' ' +
          objectVin +
          '?'
        );

      if (isConfirm) {
        deliveryDriveToPortAdd(objectId, planId, successAction);
      }
    }
  );

  $(document).on(
    'click',
    '.deliveryDriveToPortAdd_Navis_Search',
    function (event) {
      event.preventDefault();
      let objectId = $(this).data('object_id'),
        planId = $(this).data('plan_id'),
        objectName = $(this).data('object_name'),
        objectVin = $(this).data('object_vin'),
        successAction = (response) => {
          $('#startSearch').trigger('click');
        },
        isConfirm = confirm(
          'Вы уверены, что хотите создать заявку на сгон ' +
          objectName +
          ' ' +
          objectVin +
          '?'
        );

      if (isConfirm) {
        deliveryDriveToPortAdd(objectId, planId, successAction);
      }
    }
  );

  $(document).on('click', '.removeDeliveryDriveToPort', function (event) {
    event.preventDefault();
    let objectId = $(this).data('object_id'),
      planId = $(this).data('plan_id'),
      objectName = $(this).data('object_name'),
      objectVin = $(this).data('object_vin'),
      successAction = (response) => {
        let htmlLink =
          "<a href='' class='deliveryDriveToPortAdd_Navis_Cars' data-object_id='" +
          objectId +
          "' data-plan_id='" +
          planId +
          "' data-object_name='" +
          objectName +
          "' data-object_vin='" +
          objectVin +
          "'>Доставить</a>";

        $(`#dlv-${objectId}`).html(htmlLink);
        $(`#dlv-check-${objectId} i`).remove();
      },
      isConfirm = confirm(
        'Вы уверены, что хотите удалить заявку на сгон ' +
        objectName +
        ' ' +
        objectVin +
        '?'
      );

    if (isConfirm) {
      deliveryDriveToPortRemove(objectId, planId, successAction);
    }
  });

  $(document).on('click', '.openModalCancelObjectFromPlan', function (event) {
    event.preventDefault();
    let modalId = '#modal_cancel_object_from_plan',
      objectId = $(this).data('object_id'),
      objectName = $(this).data('object_name'),
      objectVin = $(this).data('object_vin');

    $(modalId + ' #reasonId')
      .val(0)
      .trigger('change');
    $(modalId + ' #objectId').val(objectId);
    $(modalId + ' #object_name').text(objectName);
    $(modalId + ' #object_vin').text(objectVin);
    $(modalId).modal('show');
  });

  $(document).on('click', '.openModalMoveObjectFromPlan', function (event) {
    event.preventDefault();
    let modalId = '#modal_move_object_from_plan',
      objectId = $(this).data('object_id'),
      objectName = $(this).data('object_name'),
      objectVin = $(this).data('object_vin');

    $(modalId + ' #moveReasonId')
      .val(0)
      .trigger('change');
    $(modalId + ' #objectId').val(objectId);
    $(modalId + ' #object_name').text(objectName);
    $(modalId + ' #object_vin').text(objectVin);
    $(modalId).modal('show');
  });

  $(document).on(
    'click',
    '#cancel_object_success_button__navis__cars',
    function (event) {
      event.preventDefault();
      let modalId = '#modal_cancel_object_from_plan',
        objectId = $(modalId + ' #objectId').val(),
        planId = $('#planId').val(),
        reasonId = $(modalId + ' #reasonId').val(),
        reasonName = $(modalId + ' #reasonId option:selected').text(),
        objectName = $(modalId + ' #object_name').text(),
        objectVin = $(modalId + ' #object_vin').text(),
        successAction = (response) => {
          if (!response['is_send_email']) {
            alert(
              'Письмо владельцу не отправлено по причине: ' + response['msg']
            );
          }

          $('#obj-' + objectId).html(
            '<a id="' +
            objectId +
            '" class="restoreToPlan" href="#' +
            objectId +
            '" plan="' +
            planId +
            '" data-object_name="' +
            objectName +
            '" data-object_vin="' +
            objectVin +
            '">Вернуть</a>'
          );
          let htmlTmp = $('#icons_' + objectId).html();
          $('#icons_' + objectId).html(
            htmlTmp +
            '<i class="fas fa-ban color-red standard-size-icon" title="Объект снят с рейса по причине: ' +
            reasonName +
            '"></i><br />'
          );
          $('#dlv-check-' + objectId).html('');
          $('#att-' + objectId).hide();
          $('#dlv-' + objectId).hide();
          $('#bnd-' + objectId).hide();
          $('#changeAction_' + objectId).addClass('hide');
          $(modalId).modal('hide');
          location.reload();
        };

      cancelObjectFromPlan(objectId, planId, reasonId, successAction);
    }
  );

  $(document).on(
    'click',
    '#move_object_success_button__navis__cars',
    function (event) {
      event.preventDefault();
      let modalId = '#modal_move_object_from_plan',
        objectId = $(modalId + ' #objectId').val(),
        currentPlanId = $("#planId").val(),
        newPlanId = $(modalId + "_newPlanId").val(),
        reasonId = $(modalId + "_moveReasonId").val(),
        reasonName = $(modalId + ' #moveReasonId option:selected').text(),
        objectName = $(modalId + ' #object_name').text(),
        objectVin = $(modalId + ' #object_vin').text(),
        successAction = (response) => {
          $('#obj-' + objectId).html(
            '<a id="' +
            objectId +
            '" class="restoreToPlan" href="#' +
            objectId +
            '" plan="' +
            newPlanId +
            '" data-object_name="' +
            objectName +
            '" data-object_vin="' +
            objectVin +
            '">Вернуть</a>'
          );
          let htmlTmp = $('#icons_' + objectId).html();
          $('#icons_' + objectId).html(
            htmlTmp +
            '<i class="fas fa-ban color-red standard-size-icon" title="Объект снят с рейса по причине: ' +
            reasonName +
            '"></i><br />'
          );
          $('#dlv-check-' + objectId).html('');
          $('#att-' + objectId).hide();
          $('#dlv-' + objectId).hide();
          $('#bnd-' + objectId).hide();
          $('#changeAction_' + objectId).addClass('hide');
          $(modalId).modal('hide');
        };

      moveobjectFromPlanToNewPlan(objectId, currentPlanId, newPlanId, reasonId, successAction);
    }
  );

  $(document).on('click', '.restoreToPlan', function () {
    let car = $(this).attr('id'),
      plan = $(this).attr('plan'),
      elem = $(this).parent().siblings('.changeAction'),
      objectName = $(this).data('object_name'),
      objectVin = $(this).data('object_vin');
    $('#obj-' + car).html('Выполняется запрос...');
    $.post('/navis/restore?id=' + car + '&plan=' + plan, function (data) {
      if (data !== '1') {
        alert(data);
      }
      if (data === '1') {
        $('#icons_' + car + ' .fa-ban + br').detach();
        $('#icons_' + car + ' .fa-ban').detach();
        $('#att-' + car).show();
        $('#dlv-' + car).show();
        $('#bnd-' + car).show();
        elem.removeClass('hide');
        location.reload()
      }
    });
  });

  $(document).on(
    'click',
    '.openModalCancelObjectFromPlan__observer__object',
    function (event) {
      event.preventDefault();
      let modalId = '#modal_cancel_object_from_plan',
        planId = $(this).data('plan_id'),
        objectName = $(this).data('object_name');

      $(modalId + ' #reasonId')
        .val(0)
        .trigger('change');
      $(modalId + ' #planId').val(planId);
      $(modalId + ' #object_name').text(objectName);
      $(modalId).modal('show');
    }
  );

  $(document).on(
    'click',
    '#cancel_object_success_button__observer__object',
    function (event) {
      event.preventDefault();
      let modalId = '#modal_cancel_object_from_plan',
        objectId = $(modalId + ' #objectId').val(),
        planId = $('#planId').val(),
        reasonId = $(modalId + ' #reasonId').val();

      cancelObjectFromPlan(objectId, planId, reasonId);
    }
  );

  $('.photosCar').click(clickPhotosCar);

  $(document).on('click', '.openModalBoundaryCar', function () {
    let modalSelector = '#modal-set-boundary',
      objectId = $(this).data('object_id'),
      objectName = $(this).data('object_name'),
      objectNumber = $(this).data('object_number'),
      dateManufacture = $(this).data('date_manufacture'),
      flatpickr = $(modalSelector + ' #dateOfManufacture').flatpickr({
        dateFormat: 'Y-m-d',
        locale: 'ru',
        time_24hr: true,
        enableTime: false,
        defaultDate: dateManufacture,
      });

    $(modalSelector + ' #object_name_text').text(objectName);
    $(modalSelector + ' #object_number_text').text(objectNumber);
    $(modalSelector + ' #objectId').val(objectId);
    flatpickr._input.removeAttribute('readonly');

    $(modalSelector).modal('show');
  });

  $('.addToPlanObject').click(clickAddToPlanObject);

  function instantSearchMagadan(text) {
    $('#magadanSearchBtn').hide();
    $('#magadanCars').html('Ищем...');
    $.post('/magadan/list?vin=' + text, function (data) {
      $('#magadanCars').html(data);
      /*if(data == 'Ничего не найдено') {
            $('#magadanSearchBtn').show();
          }*/
      $('#magadanSearchBtn').show();
      $('.issue-object-open-modal-btn').click(function () {
        openModalIssueObject(this);
      });
    });
  }

  function instantSearchNavis() {
    let text = $('#navissearchform-value').val();
    let observe = window.location.href.includes('observe') ? 1 : 0;
    if (text) {
      $('#navisCars').html('Ищем...');
      $.ajax({
        method: 'get',
        cache: false,
        url: `/navis/search?${$.param({
          value: text,
          observe,
        })}`,
      })
        .done(function (data) {
          $('#navisCars').html(data);
        })
        .fail(function () {
          $('#navisCars').html(
            '<h4 class="text-center">Ошибка выполнения запроса. Обратитесь к администратору сайта.</h4>'
          );
        });
    }
  }

  function instantAgentNavis(text) {
    $('#navisAgents').html('Ищем...');
    $.post('/navis/searchagents?name=' + text, function (data) {
      $('#navisAgents').html(data);
    });
  }

  function instantSearchNavisCar(text) {
    $('#activeServicesRequest').addClass("hide");
    var plan = $('#naviscarform-plan').val();
    var car = $('#naviscarform-vin').val();
    $('#navisCarAttention').html('');
    $('.form-control').prop('disabled', true);

    $.ajax({
      type: 'POST',
      cache: false,
      url: '/navis/prev?id=' + plan + '&car=' + car,
    })
      .done(function (data) {
        $('.form-control').removeAttr('disabled');
        $('#naviscarform-vin').focus();
        if (data != '') {
          let car;
          car = data;
          if (!$.isEmptyObject(car)) {
            // $("#naviscarform-contract").val(car.contract);
            $('#naviscarform-maker').val(car.maker).trigger('change');
            $('#naviscarform-vin').val(car.vin);
            if (car.draft_client_name) {
              $('#naviscarform-draft_client').removeClass('hide');
              $('#naviscarform-draft_client_name').text(car.draft_client_name);
            } else {
              $('#naviscarform-draft_client').addClass('hide');
              $('#naviscarform-draft_client_name').text('');
            }
            if (car.draft_broker_name) {
              $('#naviscarform-draft_broker').removeClass('hide');
              $('#naviscarform-draft_broker_name').text(car.draft_broker_name);
              $('#naviscarform-draft_broker_address').text(
                car.draft_broker_address
              );
              $('#naviscarform-draft_broker_contacts').text(
                car.draft_broker_contacts
              );
            } else {
              $('#naviscarform-draft_broker').addClass('hide');
              $('#naviscarform-draft_broker_name').text('');
              $('#naviscarform-draft_broker_address').text('');
              $('#naviscarform-draft_broker_contacts').text('');
            }

            if (car.auctionWillDelivery) {
              $('#navisCarAttention').append('<div style="color:red;font-weight:bold; font-size: 20px">Аукцион доставит сам: ' + car.auctionWillDelivery + '</div>')
            }
            if (car.activeHold) {
              $('#navisCarAttention').append('<div style="color:red;font-weight:bold; font-size: 20px">Отправка отложена до: ' + car.activeHold + '</div>')
            }
            if (car.is_priority_pass) {
              $('#navisCarAttention').append('<p class="label label-primary" style="background-color: #000000;color:#ff5722; font-size:18px"><strong>Priority Pass</strong></p>')
            }
            if (car.draft_object_state) {
              $('#naviscarform-draft_object_state_container').removeClass(
                'hide'
              );
              $('#naviscarform-draft_object_state_in_c').text(
                car.draft_object_state
              );
            } else {
              $('#naviscarform-draft_object_state_container').addClass('hide');
              $('#naviscarform-draft_object_state_in_c').text('');
            }

            if (car.draft_object_maker) {
              $('#naviscarform-draft_object').removeClass('hide');
              if (car.draft_object_vin) {
                $('#naviscarform-draft_object_vin').text(
                  'Номер кузова: ' + car.draft_object_vin
                );
              } else {
                $('#naviscarform-draft_object_vin').text('');
              }
              if (car.draft_object_maker) {
                $('#naviscarform-draft_object_maker').text(
                  'Модель: ' + car.draft_object_maker
                );
              } else {
                $('#naviscarform-draft_object_maker').text('');
              }
              if (car.draft_object_owner) {
                $('#naviscarform-draft_object_owner').text(
                  'Владелец: ' + car.draft_object_owner
                );
              } else {
                $('#naviscarform-draft_object_owner').text('');
              }
              if (car.draft_object_broker) {
                $('#naviscarform-draft_object_broker').text(
                  'Брокер: ' + car.draft_object_broker
                );
              } else {
                $('#naviscarform-draft_object_broker').text('');
              }
              if (car.draft_object_country) {
                $('#naviscarform-draft_object_country').text(
                  'Страна оплаты: ' + car.draft_object_country
                );
              } else {
                $('#naviscarform-draft_object_country').text('');
              }
              if (car.draft_object_state) {
                $('#naviscarform-draft_object_state').text(
                  car.draft_object_state
                );
              } else {
                $('#naviscarform-draft_object_state').text('');
              }
              if (car.draft_object_price) {
                $('#naviscarform-draft_object_price').text(
                  'Экспортная цена: ' +
                  car.draft_object_price +
                  ' ' +
                  car.draft_object_price_currency_symbol
                );
              } else {
                $('#naviscarform-draft_object_price').text('');
              }
              if (car.draft_object_sender) {
                $('#naviscarform-draft_object_sender').text(
                  'Отправитель: ' + car.draft_object_sender
                );
              } else {
                $('#naviscarform-draft_object_sender').text('');
              }
              if (car.draft_object_boundary) {
                $('#naviscarform-draft_object_boundary').text(
                  car.draft_object_boundary
                );
              } else {
                $('#naviscarform-draft_object_boundary').text('');
              }
            } else {
              $('#naviscarform-draft_object').addClass('hide');
              $('#naviscarform-draft_object_maker').text('');
              $('#naviscarform-draft_object_owner').text('');
              $('#naviscarform-draft_object_broker').text('');
              $('#naviscarform-draft_object_country').text('');
            }
            if (!car.id) {
              $('#naviscarform-sender').attr('search', '0');
            }

            $('#naviscarform-sender').val(car.sender).trigger('change');
            $('#naviscarform-type').val(car.type);
            $('#naviscarform-chassis').val(car.chassis);
            $('#naviscarform-engine').val(car.engine);
            $('#naviscarform-height').val(car.height);
            $('#naviscarform-width').val(car.width);
            $('#naviscarform-seats').val(car.seats);
            $('#naviscarform-year').val(car.year);
            if (car.price) {
              $('#naviscarform-price').val(car.price);
            } else {
              $('#naviscarform-price').val('');
            }
            if (car.price_currency_id) {
              $('#naviscarform-price_currency_id').val(car.price_currency_id);
              $('#naviscarform-price_currency_id').trigger('change');
            } else {
              $('#naviscarform-price_currency_id').val([]);
            }
            if (car.isExistExportCertificate) {
              $('#exportCertificateBtnBlock').hide();
              $('#exportCertificateImageContainer').html(
                '<hr />' +
                '<div class="col-md-6">' +
                `<div class="SmallCarPhoto m-0" id="carPhoto${car.exportCertificateId}">` +
                '<h4 class="">Экспортный сертификат</h4>' +
                '<div class="mark-icon" title="Удалить">' +
                `<a id="897275" class="photoRemove" href="#carPhoto${car.exportCertificateId}">` +
                '<i id="" class="cursor-pointer glyphicon glyphicon-remove color-red"></i>' +
                '</a>' +
                '</div>' +
                `<a href="${car.exportCertificateLink}" target="_blank">` +
                `<img src="${car.exportCertificateThumbsLink}">` +
                '</a>' +
                '</div>' +
                '</div>'
              );
            }

            if ($.inArray(Number(car.type), [4, 8, 9, 10, 11, 12]) !== -1) {
              $('.field-naviscarform-load_capacity').removeClass('hide');
            } else {
              $('.field-naviscarform-load_capacity').addClass('hide');
            }

            if (car.type) {
              $.ajax({
                type: 'POST',
                url: `/navis/saw-config?type=${car.type}&chassis=${car.chassis}`,
                dataType: 'json',
              }).done(function (data) {
                $('#naviscarform-saw').html(
                  data.saws || '<option selected value=30>Целая</option>'
                );
                $('#naviscarform-saw').val(car.saw);
              });
            }
            $.ajax({
              type: 'POST',
              url: `/navis/parts-config?saw=${car.saw}&type=${car.type}&chassis=${car.chassis}`,
            }).done(function (data) {
              var parts;
              try {
                parts = JSON.parse(data);
              } catch (e) {
                parts = false;
              }
              DisassembleParts(parts);
            });

            $('#naviscarform-owner').val(car.owner);
            $('#naviscarform-broker').val(car.broker);
            $('#naviscarform-weight').val(car.weight);
            $('#naviscarform-length').val(car.length);
            $('#naviscarform-comment').val(car.comment);
            if (car.custom) {
              $('#naviscarform-custom').val(car.custom);
            }
            $('#naviscarform-trip').val(car.trip);
            $('#naviscarform-id').val(car.id);
            if (car.maker) {
              $.post('/navis/models?maker=' + car.maker, function (data) {
                $('#naviscarform-mark').html(data);
                setTimeout(() => {
                  $('#naviscarform-mark').val(car.mark).trigger('change');
                }, 50);
              });
            }
            $('#naviscarform-sender').attr('search', '1');
            if (car.is_drivable) {
              $('#notDrivable').addClass('hide');
            } else {
              $('#notDrivable').removeClass('hide');
            }

            $('#naviscarform-owner_id').val(car.owner_id);
            $('#naviscarform-broker_id').val(car.broker_id);
            if (car.msg) alert(car.msg);
            if (car.hasActiveServicesRequests) {
              $('#activeServicesRequest').removeClass("hide");
            } else {
              $('#activeServicesRequest').addClass("hide");
            }
          } else {
            $('#naviscarform-sender').attr('search', '0');
          }
        }
      })
      .fail(function (jqXHR) {
        alert(
          'Произошла ошибка при попытке запроса к Cartrack\n' +
          'Статус: ' +
          jqXHR['statusText'] +
          '\n' +
          'Код статуса: ' +
          jqXHR['status'] +
          '\n' +
          'Ответ сервера: ' +
          jqXHR['responseText'] +
          '\n'
        );
      });
  }

  let text = '';

  $(document).on('input', '#navissearchform-value', function (event) {
    let str = this.value.substr(this.value.length - 1),
      result = str.search(/[a-np-zA-NP-Z0-9-\/]{1}/);
    if (result === -1) {
      this.value = this.value.slice(0, -1);
    }
  });

  $('form#navisSearch-form #startSearch').on('click', instantSearchNavis);

  $('form#navisSearch-form input').on('keyup', function (e) {
    e.preventDefault();

    if (e.keyCode === 13) instantSearchNavis();
  });

  $("button[name='navis-agent-search-button']").on('click', function () {
    text = $('#navisagentform-name').val();
    $('#navisAgent-form').submit(function (event) {
      event.preventDefault();
    });
    instantAgentNavis(text);
  });

  $('#naviscarform-vin').focusout(function () {
    let textNow = $(this).val();
    let textPrev = $(this).attr('search');
    if (textNow != textPrev) {
      textPrev = $(this).attr('search', textNow);
      instantSearchNavisCar(textNow);
      $('#naviscarform-sender').focus();
    }
  });

  /*var timer3;
    $('#magadansearchform-vin').on("keyup", function(){
       clearTimeout(timer3);
       text = $(this).val();
       if (text.length >= 5) {
               timer3 = setTimeout(instantSearchMagadan(text), 300);
           }
    });*/

  function instantSearchOtaru(text) {
    $('#magadanSearchBtn').hide();
    $('#magadanCars').html('Searching...');
    $.post('/outer-stock/list?vin=' + text, function (data) {
      $('#magadanCars').html(data);
      if (data == 'Nothing found') {
        $('#magadanSearchBtn').show();
      }
    });
  }

  $('#outerstocksearchform-vin').on('keyup', function () {
    clearTimeout(timer3);
    text = $(this).val();
    timer3 = setTimeout(instantSearchOtaru(text), 300);
  });

  $(document).on('click', '.check-debts', function (e) {
    e.preventDefault();
    var id = $(this).attr('data-id');
    $(this).remove();
    $.ajax({
      url: "/akebono/is-car-finance-clear?id=" + id,
      method: 'POST',
      contentType: false,
      processData: false
    })
      .done(function (result) {
        if (result.status) {
          $('#result-debts' + id).text('Has Akebono debts');
          $('#result-debts' + id).css({ color: 'red' });
        } else {
          $('#result-debts' + id).text('Debts clear');
          $('#result-debts' + id).css({ color: 'green' });
        }
      })
      .fail(function () {
        alert('Ошибка выполнения запроса. Обратитесь к администратору.');
      });
  });

  $(document).on('keydown', '#vin', function (e) {
    if (e.keyCode == 13) {
      this.form.submit();
    }
  });

  $('.photoRemove').on('click', function () {
    let mediaId = $(this).attr('id'),
      isOk = confirm('Вы уверены, что хотите удалить медиафайл?');
    if (isOk) {
      $.post({
        cache: false,
        url: '/data/remove-media',
        data: { id: mediaId },
      })
        .done(function (response) {
          switch (response['status']) {
            case 'success':
              $('#carPhoto' + mediaId).hide();
              break;
            case 'fail':
              alert(
                'Ошибка при попытке удалить медиафайл. \nОтвет сервера: ' +
                response['msg']
              );
              break;
            default:
              alert('Неизвестная ошибка');
              break;
          }
        })
        .fail(function (jqXHR) {
          alert(
            'Произошла ошибка при попытке запроса к Cartrack\n' +
            'Статус: ' +
            jqXHR['statusText'] +
            '\n' +
            'Код статуса: ' +
            jqXHR['status'] +
            '\n' +
            'Ответ сервера: ' +
            jqXHR['responseJSON']['name'] +
            '\n'
          );
        });
    }
  });

  //$('#magadanSearchBtn').hide();

  $('#magadandetailform-is_rad_check').on('change', function () {
    if ($(this).is(':checked')) {
      $('#magadandetailform-radiation').prop('disabled', false);
    } else {
      $('#magadandetailform-radiation').prop('disabled', true);
    }
  });

  // $('.linked').on("click", function(){
  //     document.location.href = "/watch/car?id=" + $(this).attr('car') + "&plan=" + $(this).attr('plan') + '&saw=' + $(this).attr('saw');
  // });

  $('.attentionCar').on('click', (e) => {
    let car = $(e.currentTarget).data('id'),
      plan = $(e.currentTarget).data('plan');
    $.post(`/navis/attention?id=${car}&plan=${plan}`, (data) => {
      if (data !== '-1') {
        $(`#car_${car}`).css(
          'background-color',
          data === '1' ? 'gold' : '#f9f9f9'
        );
      }
    });
  });

  $('.markDriverCar').on('click', function () {
    var car = $(this).attr('id');
    $.post('/driver/mark?id=' + car, function (data) {
      if (data != '-1') {
        if (data == '1') {
          $('#car_' + car).css('background-color', '#DAFFF3');
        } else {
          $('#car_' + car).css('background-color', '#f9f9f9');
        }
      }
    });
  });

  $('.moveDriverCar').on('click', function () {
    let contract = $(this).data('contract'),
      markModel = $(this).data('markmodel'),
      vin = $(this).data('vin');
    var delivery = $(this).attr('id');
    var isOK = confirm(
      'ARE YOU SURE? ' + contract + ' ' + markModel + ' ' + vin
    );
    if (isOK == true) {
      $.post('/driver/move?id=' + delivery, function (data) {
        if (data == '1') {
          $('#car_' + delivery).hide();

          var vessel = $('#driverfiltersform-plan').val();
          var stock = $('#driverfiltersform-stock').val();
          var sector = $('#driverfiltersform-sector').val();

          $.post('/driver/vessels', function (data) {
            $('#driverfiltersform-plan').html(data);
            $.post('/driver/stocks?plan_id=' + vessel, function (data) {
              $('#driverfiltersform-stock').html(data);
              $.post(
                '/driver/sectors?plan_id=' + vessel + '&stock_id=' + stock,
                function (data) {
                  $('#driverfiltersform-sector').html(data);

                  $('#driverfiltersform-plan').val(vessel);
                  $('#driverfiltersform-stock').val(stock);
                  $('#driverfiltersform-sector').val(sector);
                }
              );
            });
          });
          //location.reload();
          //$("form#driverList-form").submit();
        }
        if (data == '7') {
          alert('Time is over! Sorry...');
        }
        if (data == '9') {
          alert('Delivery stopped.');
        }
        if (data == '10') {
          alert('Delivery complete fail.');
        }
        if (data == '11') {
          alert('No delivery available.');
        }
      }).fail(function (jqXHR) {
        alert(
          'Произошла ошибка при попытке запроса к Cartrack\n' +
          'Статус: ' +
          jqXHR['statusText'] +
          '\n' +
          'Код статуса: ' +
          jqXHR['status'] +
          '\n' +
          'Ответ сервера: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      });
    }
  });

  $('.moveDriverCarWoPlan').on('click', function () {
    let markModel = $(this).data('markmodel'),
      vin = $(this).data('vin');
    var delivery = $(this).attr('id');
    var isOK = confirm('ARE YOU SURE? ' + markModel + ' ' + vin);
    if (isOK == true) {
      $.post('/driver/move-without-plan?id=' + delivery, function (data) {
        if (data == '1') {
          $('#car_' + delivery).hide();

          var stock = $('#driverfiltersform-stock').val();
          var sector = $('#driverfiltersform-sector').val();

          $.post('/driver/stocks', function (data) {
            $('#driverfiltersform-stock').html(data);
            $.post('/driver/sectors?stock_id=' + stock, function (data) {
              $('#driverfiltersform-sector').html(data);

              $('#driverfiltersform-stock').val(stock);
              $('#driverfiltersform-sector').val(sector);
            });
          });
        }
        if (data == '10') {
          alert('Delivery complete fail.');
        }
      }).fail(function (jqXHR) {
        alert(
          'Cartrack unavailable\n' +
          'Status: ' +
          jqXHR['statusText'] +
          '\n' +
          'Status code: ' +
          jqXHR['status'] +
          '\n' +
          'Server response: ' +
          jqXHR['responseText'] +
          '\n'
        );
      });
    }
  });

  $('.foundDriverCar').on('click', function () {
    let contract = $(this).data('contract'),
      markModel = $(this).data('markmodel'),
      vin = $(this).data('vin');
    var delivery = $(this).attr('id');
    var isOK = confirm(
      'ARE YOU FOUND THIS CAR? ' + contract + ' ' + markModel + ' ' + vin
    );
    if (isOK == true) {
      $.post('/driver/found?id=' + delivery, function (data) {
        if (data == '1') {
          $('#car_' + delivery).css('background-color', '#E3FAEF');
          $('#li-' + delivery).hide();
        }
        if (data == '2') {
          alert('Car already delivered.');
          $('#car_' + delivery).hide();
        }
        //location.reload();
        //$("form#driverList-form").submit();
      });
    }
  });

  $('#smsdaily').on('click', function () {
    var isOK = confirm('Вы уверены?');
    if (isOK == true) {
      $.post('/magadan/sms', function (data) {
        try {
          data = JSON.parse(data);
          let ignored = '';
          if (data.ignored && data.ignored.length) {
            ignored =
              ' Сообщения были отправлены ранее, поэтому проигнорированы: ' +
              data.ignored.join('; ');
          }
          alert('Отправлено ' + data.count + ' сообщений.' + ignored);
        } catch (e) {
          console.log(e);
        }
      });
    }
  });

  $('#driverfiltersform-vin').on('keydown', function (e) {
    if (e.keyCode == 13) {
      $('#driverList-form').submit();
    }
  });

  $('.form-control').on('keydown', function (e) {
    if (e.keyCode == 13) {
      let id = $(this).attr('id');
      if (id == 'naviscarform-contract') $('#naviscarform-vin').focus();
      if (id == 'naviscarform-vin') {
        //text = $('#naviscarform-vin').val();
        //instantSearchNavisCar(text);
        $('#naviscarform-sender').focus();
      }
      if (id == 'naviscarform-sender') $('#naviscarform-type').focus();
      if (id == 'naviscarform-type') $('#naviscarform-maker').focus();
      if (id == 'naviscarform-maker') $('#naviscarform-mark').focus();
      if (id == 'naviscarform-mark') $('#naviscarform-chassis').focus();
      if (id == 'naviscarform-chassis') $('#naviscarform-engine').focus();
      if (id == 'naviscarform-engine') $('#naviscarform-year').focus();
      if (id == 'naviscarform-year') $('#naviscarform-saw').focus();
      if (id == 'naviscarform-saw') $('#naviscarform-owner').focus();
      if (id == 'naviscarform-owner') $('#naviscarform-comment').focus();
      if (id == 'naviscarform-comment') $('#naviscarform-weight').focus();
      if (id == 'naviscarform-weight') $('#naviscarform-length').focus();
      if (id == 'naviscarform-length') $('#navisCarDetail-form').submit();
      e.preventDefault();
      return false;
    }
    if (e.keyCode == 33) {
      let id = $(this).attr('id');
      //if(id == 'naviscarform-contract') $('#naviscarform-sender').focus();
      if (id == 'naviscarform-vin') $('#naviscarform-contract').focus();
      if (id == 'naviscarform-sender') $('#naviscarform-vin').focus();
      if (id == 'naviscarform-type') $('#naviscarform-sender').focus();
      if (id == 'naviscarform-maker') $('#naviscarform-type').focus();
      if (id == 'naviscarform-mark') $('#naviscarform-maker').focus();
      if (id == 'naviscarform-chassis') $('#naviscarform-mark').focus();
      if (id == 'naviscarform-engine') $('#naviscarform-chassis').focus();
      if (id == 'naviscarform-year') $('#naviscarform-engine').focus();
      if (id == 'naviscarform-saw') $('#naviscarform-year').focus();
      if (id == 'naviscarform-owner') $('#naviscarform-saw').focus();
      if (id == 'naviscarform-comment') $('#naviscarform-owner').focus();
      e.preventDefault();
      return false;
    }
    if (e.keyCode == 27) {
      $('#navisCarDetail-form').submit();
    }
  });

  $('#naviscarform-sender').on('focus', function () {
    $(this).select();
  });
  $('#naviscarform-owner').on('focus', function () {
    $(this).select();
  });

  $('.btn').on('click', function () {
    /*let user = detect.parse(navigator.userAgent);
        if(user.browser.family !== 'Safari') {
            window.navigator.vibrate(200);
        }*/
  });

  if ($(window.location.hash).length) {
    setTimeout(function () {
      $('html').animate(
        {
          scrollTop: $(window.location.hash).offset().top - 60,
        },
        500
      );
    }, 1);
  }

  $('#naviscarform-chassis').on('change', function (e) {
    let val = $(this).val();
    if (val == 1) {
      $('#naviscarform-car_frame').prop('disabled', true);
    } else {
      if (!$('#naviscarform-is_disassemble').disabled) {
        $('#naviscarform-car_frame').removeAttr('disabled');
      }
    }
  });

  if (!$('#magadandetailform-is_rad_check').prop('checked')) {
    $('#magadandetailform-radiation').prop('disabled', true);
  }

  $('#magadandetailform-is_rad_check').on('change', function (e) {
    if ($(this).prop('checked')) {
      $('#magadandetailform-radiation').prop('disabled', false);
      $('#magadandetailform-radiation').val('OK');
    } else {
      $('#magadandetailform-radiation').prop('disabled', true);
      $('#magadandetailform-radiation').val('НЕ ИЗМЕРЯЛАСЬ');
    }
  });

  if (!$('#outerstockdetailform-is_rad_check').prop('checked')) {
    $('#outerstockdetailform-radiation').prop('disabled', true);
  }

  $('#outerstockdetailform-is_rad_check').on('change', function (e) {
    if ($(this).prop('checked')) {
      $('#outerstockdetailform-radiation').prop('disabled', false);
      $('#outerstockdetailform-radiation').val('OK');
    } else {
      $('#outerstockdetailform-radiation').prop('disabled', true);
      $('#outerstockdetailform-radiation').val('NO MEASURE');
    }
  });

  $('#naviscarform-owner').on('change', function () {
    $('#owner').html('Владелец: ' + $(this).label);
  });

  function InitCarType(event) {
    if (!$('#naviscarform-type').length) {
      return;
    }
    const type = $('#naviscarform-type').val();
    const chassis = $('#naviscarform-chassis').val();
    const saw = $('#naviscarform-saw').val();
    if ($.inArray(Number(type), [4, 8, 9, 10, 11, 12]) !== -1) {
      $('.field-naviscarform-load_capacity').removeClass('hide');
    } else {
      $('.field-naviscarform-load_capacity').addClass('hide');
    }

    $.post(
      `/navis/saw-config?type=${$('#naviscarform-type').val()}&chassis=${$(
        '#naviscarform-chassis'
      ).val()}`,
      (data) => {
        if (!data.saws) {
          // $("#naviscarform-saw").prop('disabled', true);
          // $(".field-naviscarform-saw").hide();
        } else {
          // $("#naviscarform-saw").removeAttr('disabled');
          // $(".field-naviscarform-saw").show();
        }
        if (!event || !$('#naviscarform-saw').is($(event.target))) {
          $('#naviscarform-saw').html(
            data.saws || '<option selected value=30>Целая</option>'
          );
        }

        if (!data.chassis) {
          // $("#naviscarform-chassis").prop('disabled', true);
          // $(".field-naviscarform-chassis").hide();
        } else {
          // $("#naviscarform-chassis").removeAttr('disabled');
          // $(".field-naviscarform-chassis").show();
        }
        if (!event || !$('#naviscarform-chassis').is($(event.target))) {
          // $("#naviscarform-chassis").html(data.chassis);
        }

        if (!event) {
          console.log(type, chassis, saw);
          $('#naviscarform-type').val(type);
          $('#naviscarform-chassis').val(chassis);
          $('#naviscarform-saw').val(saw);
        }
        DisassemblePartsAsync();
      },
      'json'
    );
  }

  $('#naviscarform-type,#naviscarform-chassis').on('change', InitCarType);

  $('#naviscarform-saw').on('change', (e) => {
    console.log(e);
    DisassemblePartsAsync();
  });

  let carParts = ['forward', 'back', 'engine', 'frame', 'pallet'];

  function HideAssembleParts() {
    // $('#naviscarform-is_disassemble').prop('checked', false);

    carParts.forEach((part) => {
      $(`#naviscarform-car_${part}`).prop('disabled', true);
      $(`#naviscarform-car_${part}`).prop('checked', false);
      $(`.field-naviscarform-car_${part}`).hide();
    });
  }

  function DisassembleParts(config) {
    HideAssembleParts();

    if (!config) {
      console.error('no parts config');
      $(`#naviscarform-is_disassemble`).prop('disabled', true);
      return;
    } else {
      $('#naviscarform-is_disassemble').removeAttr('disabled');
    }

    carParts.forEach((part) => {
      if (config[`${part}_part`] == 1) {
        $(`#naviscarform-car_${part}`).removeAttr('disabled');
        $(`#naviscarform-car_${part}`).prop('checked', true);
        $(`.field-naviscarform-car_${part}`).show();
      }
    });
  }

  function DisassemblePartsAsync(type, chassis, saw) {
    if (!type && !chassis && !saw) {
      type = $('#naviscarform-type').val();
      chassis = $('#naviscarform-chassis').val();
      saw = $('#naviscarform-saw').val();
    }

    $.post(
      `/navis/parts-config?saw=${saw}&type=${type}&chassis=${chassis}`,
      (data) => {
        try {
          data = JSON.parse(data);
        } catch (e) {
          data = false;
        }
        DisassembleParts(data);
      }
    );
  }

  InitCarType();

  // $('#sms-detail').on("click", function(event){
  //     event.preventDefault();
  //     var isOK = confirm("Вы уверены?");
  //     if(isOK == true) {
  //         $.post(`/magadan/detail-sms${window.location.search}`, function(data) {
  //               const count = Number(data);
  //               if (count > 0) {
  //                   alert('Отправлено ' + data + ' сообщений.');
  //               } else {
  //                   alert('Сообщение не отправлено!');
  //               }
  //         });
  //     }
  // });

  $('#hidden-files-input').on('change', (event) => {
    const files = Array.from(event.target.files);
    $('#magadandetailform-images').val(
      files.map((f) => f.name).join('%%%;%%%')
    );
    $('#filenames').text(`Выбрано файлов: ${files.length}`);
  });

  $('#template').on('change', (event) => {
    const template = TEMPLATES[Number(event.target.value)];
    if (template) {
      if ($('#navispartsform-name').length > 0) {
        $('#navispartsform-name').val(template);
      }
      if ($('#magadandetailform-attachments').length > 0) {
        let v = $('#magadandetailform-attachments').val();
        if (v) {
          v += '; ';
        }
        $('#magadandetailform-attachments').val(v + template);
      }
      if ($('#outerstockdetailform-attachments').length > 0) {
        let v = $('#outerstockdetailform-attachments').val();
        if (v) {
          v += '; ';
        }
        $('#outerstockdetailform-attachments').val(v + template);
      }
    }
  });

  $('.closePlan').click(function () {
    if (confirm('Вы уверены?')) {
      $.get('/watch/close?id=' + $(this).attr('plan'), (data) => {
        if (data === 'ok') {
          alert('Закрыто');
          $(this).closest('tr').remove();
        } else {
          alert('Не удалось закрыть');
        }
      });
    }
  });

  $('.remainsDelete').click(function () {
    var reason = prompt('Укажите причину');
    if (reason) {
      $.get(
        `/navis/remains-delete?stock=${$(this).attr('stock')}&car=${$(
          this
        ).attr('car')}&reason=${reason}`,
        (data) => {
          if (data === 'ok') {
            $(this).closest('tr').remove();
          } else {
            alert('Не удалось удалить');
          }
        }
      );
    }
  });

  $('.remainsMove').click(function () {
    if (confirm('Вы уверены?')) {
      const select = $(this).siblings('select');
      console.log(select);
      $.get(
        `/navis/remains-move?stock=${select.val()}&car=${select.attr('car')}`,
        (data) => {
          if (data === 'ok') {
            $(this).closest('tr').remove();
          } else {
            alert('Не удалось переместить');
          }
        }
      );
    }
  });

  $(document).on('click', '#send-clarification-email', function () {
    if (confirm('Вы уверены?')) {
      const mark = $('#naviscarform-mark option:selected').text();
      const maker = $('#naviscarform-maker option:selected').text();
      const vin = $('#naviscarform-vin').val();
      const plan = window.location.search.match(/plan=([0-9]+)/)[1];
      const owner = $('#naviscarform-owner_id').val();
      $.get(
        '/navis/send-clarification-email?' +
        `maker=${maker}&mark=${mark}&vin=${vin}&plan=${plan}&owner=${owner}`,
        (data) => {
          if (data === 'ok') {
            alert('Отправлено!');
          } else {
            alert(`Не удалось отправить письмо: ${data}`);
          }
        }
      );
    }
  });

  $(document).on('click', '.send-clarification-email', function () {
    if (confirm('Вы уверены?')) {
      let mark = $(this).data('mark'),
        maker = $(this).data('maker'),
        vin = $(this).data('vin'),
        plan = $(this).data('plan_id'),
        owner = $(this).data('owner_id');
      $.get(
        '/navis/send-clarification-email?' +
        `maker=${maker}&mark=${mark}&vin=${vin}&plan=${plan}&owner=${owner}`,
        (data) => {
          if (data === 'ok') {
            alert('Отправлено!');
          } else {
            alert(`Не удалось отправить письмо: ${data}`);
          }
        }
      );
    }
  });

  const onCarDetailsInit = (e) => {
    const type = $('#naviscarform-type').val();
    const saw = $('#naviscarform-saw').val();
    // неопределен + конструктор/распил
    console.log(e);
    if (
      [4, 12].includes(parseInt(type)) &&
      ((e && e.target.id === 'naviscarform-type') || saw === '30')
    ) {
      $('#send-clarification-email').show();
    } else {
      $('#send-clarification-email').hide();
    }
  };
  $('#naviscarform-type,#naviscarform-saw').change(onCarDetailsInit);
  onCarDetailsInit();

  function AKBInitCarType(event) {
    if (!$('#akebonodetailform-type').length) {
      return;
    }
    const type = $('#akebonodetailform-type').val();
    const chassis = $('#akebonodetailform-chassis').val();
    const saw = $('#akebonodetailform-saw').val();

    $.post(
      `/navis/saw-config?type=${$('#akebonodetailform-type').val()}&chassis=${$(
        '#akebonodetailform-chassis'
      ).val()}`,
      (data) => {
        if (!event || !$('#akebonodetailform-saw').is($(event.target))) {
          $('#akebonodetailform-saw').html(
            data.saws || '<option selected value=30>НЕОПРЕДЕЛЕН</option>'
          );
        }

        if (!event) {
          console.log(type, chassis, saw);
          $('#akebonodetailform-type').val(type);
          $('#akebonodetailform-chassis').val(chassis);
          $('#akebonodetailform-saw').val(saw);
        }
      },
      'json'
    );
  }

  $('#akebonodetailform-type,#akebonodetailform-chassis').on(
    'change',
    AKBInitCarType
  );

  AKBInitCarType();

  $('#move-object-data-move-button').click(function () {
    moveMedia();
  });

  $('#add-user-button').click(function () {
    addUserReminder();
  });
  $('#apply-reminder-button').click(function () {
    document.location.href = '/director/reminders';
  });
  $('.remove-user').click(function () {
    removeUserFromListReminder(this);
  });

  $('.write-off-open-modal-btn').click(function () {
    openModalWriteOff(this);
  });
  $('#write-off-button').click(function () {
    writeOffObject();
  });

  $('.write-comment-open-modal-btn').click(function () {
    openModalComment(this);
  });
  $('#write-comment-button').click(function () {
    commentObject();
  });

  $('.akebono-comment-open-modal-btn').click(function () {
    openModalAkebonoComment(this);
  });
  $('#akebono-comment-button').click(function () {
    commentAkebonoObject();
  });

  $(document).on('click', '#move-to-stock-apply-button', function (event) {
    event.preventDefault();
    let carId = $('#object-to-move-id').val(),
      targetStockId = $('#target-stock option:selected').val(),
      // Магия select2(ajax), option всегда один, только выбранный. При этом атрибут selected отсутствует
      targetSectorId = $('#target-sector option:selected').val();
    let targetCountryId = null;
    if ($('#target-country option:selected')) {
      targetCountryId = $('#target-country option:selected').val();
    }
    moveObjectToStock(carId, targetStockId, targetSectorId, targetCountryId);
  });

  $('#target-stock').change(function () {
    // Сброс значения сектора при смене склада
    $('#target-sector').html('');
  });

  $('.setBasicPhoto').click(function () {
    let thisElem = $(this),
      imageId = thisElem.attr('id'),
      carId = $('#carId').val(),
      oldBasicImg = $('.glyphicon-star');

    $.post({
      cache: false,
      url: '/observer/set-basic-image-ajax',
      data: { imageId: imageId, carId: carId },
    })
      .done(function (data) {
        switch (data['status']) {
          case 'success':
            oldBasicImg.removeClass('glyphicon-star');
            oldBasicImg.addClass('glyphicon-star-empty');
            thisElem.removeClass('glyphicon-star-empty');
            thisElem.addClass('glyphicon-star');
            location.reload();
            break;
          case 'fail':
            alert(
              'Ошибка при попытке установить главное изображение. Ответ сервера:\n' +
              data['msg']
            );
        }
      })
      .fail(function (jqXHR) {
        alert(
          'Произошла ошибка при попытке запроса к Cartrack\n' +
          'Статус: ' +
          jqXHR['statusText'] +
          '\n' +
          'Код статуса: ' +
          jqXHR['status'] +
          '\n' +
          'Ответ сервера: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      });
  });

  $('#driverCarsList table thead th').on('click', (e) => {
    sortTableBackend(e);
  });

  $('#change-datetime-drive-to-apply-button').click(function () {
    changeDriveTo();
  });

  $('.solve-problem-open-modal-btn').click(function () {
    openModalSolveProblem(this);
  });
  $('#solve-problem-apply-button').click(function () {
    solveProblem();
  });

  $('.issue-object-open-modal-btn').click(function () {
    openModalIssueObject(this);
  });

  $('#create-request-issue-object-success-button').click(function () {
    let nameBtnSuccess = $(
      '#create-request-issue-object-success-button'
    ).text();
    if (nameBtnSuccess[0].search(/[a-z]/i) !== -1) {
      createRequestToIssueObject('english');
    } else {
      createRequestToIssueObject('russian');
    }
  });

  $('#open-modal-create-request-issue-object').click(function () {
    $('#modal-create-request-issue-object').modal('show');
  });

  //---------------------BEGIN-Построение таблиц для складов-------------------
  $('#create-expected-delivery-stats-type-auction-table').click(function () {
    let idDivTable = '#expected-delivery-stats-type-auction-table-div';
    if ($(idDivTable).html() === '') {
      createTableExpectedDeliveryAucStatsTable(idDivTable);
    }
  });
  $('#create-expected-delivery-stats-type-carrier-table').click(function () {
    let idDivTable = '#expected-delivery-stats-type-carrier-table-div';
    if ($(idDivTable).html() === '') {
      createTableExpectedDeliveryCarrierStatsTable(idDivTable);
    }
  });
  $('#create-expected-departure-stats-type-trips-table').click(function () {
    if ($('#expected-departure-stats-type-trips-table-div').html() === '') {
      createTableExpectedDepartureStatsTypeTripsTable();
    }
  });
  $('#create-expected-departure-stats-type-sender-table').click(function () {
    if ($('#expected-departure-stats-type-sender-table-div').html() === '') {
      createTableExpectedDepartureStatsTypeSenderTable();
    }
  });
  $('#create-expected-departure-stats-type-date-table').click(function () {
    if ($('#expected-departure-stats-type-date-table-div').html() === '') {
      createTableExpectedDepartureStatsTypeDateTable();
    }
  });
  $('#create-stats-type-sectors-table').click(function () {
    if ($('#stock-sectors-stats-table-div').html() === '') {
      createTableStockSectorsStatTable();
    }
  });
  //------------------END-Построение таблиц для складов------------------------------

  $('#getDataTableTypeSectorsBtn').click(function () {
    let sectorId = $(this).attr('data-sector'),
      boundary = $(this).attr('data-boundary'),
      noOwner = $(this).attr('data-noOwner'),
      senderId = $('#sendersList').val(),
      countMinStorageDays = $('#countMinStorageDays').val();
    createTableCarsStock(
      sectorId,
      senderId,
      boundary,
      countMinStorageDays,
      noOwner
    );
  });
  $('#resetParams').click(function () {
    $('#sendersList').select2('val', '0');
    $('#countMinStorageDays').val(0);

    let sectorId = $('#getDataTableTypeSectorsBtn').attr('data-sector'),
      boundary = $('#getDataTableTypeSectorsBtn').attr('data-boundary'),
      noOwner = $('#getDataTableTypeSectorsBtn').attr('data-noOwner'),
      senderId = $('#sendersList').val(),
      countMinStorageDays = $('#countMinStorageDays').val();
    createTableCarsStock(
      sectorId,
      senderId,
      boundary,
      countMinStorageDays,
      noOwner
    );
  });
  $('#toStartPage').click(function () {
    $('body,html').animate({ scrollTop: 0 }, 300);
  });

  //---------------------BEGIN-Построение таблиц для отправителей-------------------
  $('#create-sender-stock-stats-type-object-table').click(function () {
    let senderId = $('input#senderId').val(),
      idDivTable = '#sender-stock-stats-type-object-table-div',
      url = '/observer/data-stock-type-object-senders-stats-ajax',
      data = { senderId: senderId };
    if ($(idDivTable).html() === '') {
      createTableStat(data, idDivTable, url, 'types');
    }
  });
  $('#create-sender-stock-stats-type-saw-table').click(function () {
    let senderId = $('input#senderId').val(),
      idDivTable = '#sender-stock-stats-type-saw-table-div',
      url = '/observer/data-stock-type-saw-senders-stats-ajax',
      data = { senderId: senderId };
    if ($(idDivTable).html() === '') {
      createTableStat(data, idDivTable, url, 'types');
    }
  });
  $('#create-sender-stock-stats-type-custom-table').click(function () {
    let senderId = $('input#senderId').val(),
      idDivTable = '#sender-stock-stats-type-custom-table-div',
      url = '/observer/data-stock-type-custom-senders-stats-ajax',
      data = { senderId: senderId };
    if ($(idDivTable).html() === '') {
      createTableStat(data, idDivTable, url, 'types');
    }
  });
  $('#create-sender-trips-stats-table').click(function () {
    let senderId = $('input#senderId').val(),
      idDivTable = '#sender-trips-stats-table-div',
      url = '/observer/data-trips-senders-stats-ajax',
      data = { senderId: senderId };
    if ($(idDivTable).html() === '') {
      createTableStat(data, idDivTable, url, 'trips');
    }
  });
  $('#create-sender-send-stats-type-object-table').click(function () {
    let senderId = $('input#senderId').val(),
      idDivTable = '#sender-send-stats-type-object-table-div',
      url = '/observer/data-send-type-object-senders-stats-ajax',
      data = { senderId: senderId };
    if ($(idDivTable).html() === '') {
      createTableStat(data, idDivTable, url, 'types');
    }
  });

  $('.createTableCarsStat').click(function () {
    removeSelectionSenderStat();
    removeSelectionOwnerStat();
    $(this).parent().addClass('color-selected-cell-table');

    let stockId = $(this).attr('data-stockid'),
      senderId = $('input#senderId').val(),
      ownerId = $('input#ownerId').val(),
      countMinStorageDays = $(this).attr('data-countMinStorageDays'),
      title = $(this).attr('data-title'),
      idDivTable = '#table-cars-container',
      url = '/observer/get-filtered-cars-ajax',
      data = {};
    if (typeof stockId === 'undefined' || stockId === null) stockId = '';
    if (typeof senderId === 'undefined' || senderId === null) senderId = '';
    if (typeof ownerId === 'undefined' || ownerId === null) ownerId = '';
    data = {
      stockId: stockId,
      senderId: senderId,
      ownerId: ownerId,
      countMinStorageDays: countMinStorageDays,
    };
    createTableCarsTypes(data, idDivTable, url, title);
  });

  $(document).on('click', '#createTableCarsStatAllCurrentStock', function () {
    removeSelectionSenderStat();
    removeSelectionOwnerStat();
    $(this).parent().addClass('color-selected-cell-table');

    let stocksIds = [],
      senderId = $('input#senderId').val(),
      countMinStorageDays = $(this).attr('data-countMinStorageDays'),
      title = $(this).attr('data-title'),
      idDivTable = '#table-cars-container',
      url = '/observer/get-filtered-cars-ajax',
      data = { senderId: senderId, countMinStorageDays: countMinStorageDays };

    $.each($('.createTableCarsStat'), function (index, value) {
      stocksIds.push($(value).attr('data-stockid'));
    });

    createTableCarsTypesStocks(stocksIds, data, url, idDivTable, title);
  });
  //---------------------END-Построение таблиц для отправителей-------------------

  //---------------------BEGIN-Построение таблиц для владельцев-------------------
  $('#create-owner-stock-stats-type-object-table').click(function () {
    let ownerId = $('input#ownerId').val(),
      idDivTable = '#owner-stock-stats-type-object-table-div',
      url = '/observer/data-stock-type-object-owner-stat-ajax',
      data = { ownerId: ownerId };
    if ($(idDivTable).html() === '') {
      createTableStat(data, idDivTable, url, 'types');
    }
  });
  $('#create-owner-stock-stats-type-saw-table').click(function () {
    let ownerId = $('input#ownerId').val(),
      idDivTable = '#owner-stock-stats-type-saw-table-div',
      url = '/observer/data-stock-type-saw-owner-stat-ajax',
      data = { ownerId: ownerId };
    if ($(idDivTable).html() === '') {
      createTableStat(data, idDivTable, url, 'types');
    }
  });
  $('#create-owner-stock-stats-type-custom-table').click(function () {
    let ownerId = $('input#ownerId').val(),
      idDivTable = '#owner-stock-stats-type-custom-table-div',
      url = '/observer/data-stock-type-custom-owner-stat-ajax',
      data = { ownerId: ownerId };
    if ($(idDivTable).html() === '') {
      createTableStat(data, idDivTable, url, 'types');
    }
  });
  $('#create-owner-trips-stats-table').click(function () {
    let ownerId = $('input#ownerId').val(),
      idDivTable = '#owner-trips-stats-table-div',
      url = '/observer/data-trips-owner-stat-ajax',
      data = { ownerId: ownerId };
    if ($(idDivTable).html() === '') {
      createTableStat(data, idDivTable, url, 'trips');
    }
  });
  $('#create-owner-export-trips-stats-table').click(function () {
    let ownerId = $('input#ownerId').val(),
      idDivTable = '#owner-export-trips-stats-table-div',
      url = '/observer/data-export-trips-owner-stat-ajax',
      data = { ownerId: ownerId };
    if ($(idDivTable).html() === '') {
      createTableStat(data, idDivTable, url, 'trips');
    }
  });

  /*$(".createTableCarsStat").click(function () {
        removeSelectionSenderStat();
        $(this).parent().addClass("color-selected-cell-table");

        let stockId = $(this).attr("data-stockid"),
            ownerId = $("input#ownerId").val(),
            countMinStorageDays = $(this).attr("data-countMinStorageDays"),
            title = $(this).attr("data-title"),
            idDivTable = "#table-cars-container",
            url = "/observer/get-filtered-cars-ajax",
            data = {};
        if (typeof stockId === "undefined" || stockId === null) stockId = "";
        if (typeof ownerId === "undefined" || ownerId === null) ownerId = "";
        data = {stockId: stockId, ownerId: ownerId, countMinStorageDays: countMinStorageDays};
        createTableCarsTypes(data, idDivTable, url, title);
    })*/
  //---------------------END-Построение таблиц для владельцев-------------------

  $('#rejectPreDeliveryRequestBtn').click(function () {
    rejectPreDeliveryRequest();
  });

  $('.createDeliveryRequestOpenModal').click(function () {
    openModalCreateDeliveryRequest(this);
  });
  $('#createDeliveryRequestBtn').click(function () {
    createDeliveryRequest();
  });

  $('.openModalPreDeliveryRequestAccept').click(function () {
    openModalPreDeliveryAccept(this);
  });
  $('#acceptPreDeliveryRequestSuccessBtn').click(function () {
    acceptPreDeliveryRequest();
  });

  $('.openModalCancelRequestCarrier').click(function () {
    let numberDeliveryRequest = $(this).attr('data-numberDeliveryRequest'),
      objectName = $(this).attr('data-objectName'),
      objectNumber = $(this).attr('data-objectNumber'),
      lot = $(this).attr('data-lot'),
      from = $(this).attr('data-from'),
      to = $(this).attr('data-to'),
      price = $(this).attr('data-price');
    $('div#modal-cancel-delivery-request #numberDeliveryRequest').text(
      numberDeliveryRequest
    );
    $('div#modal-cancel-delivery-request #carName').text(objectName);
    $('div#modal-cancel-delivery-request #vin').text(objectNumber);
    $('div#modal-cancel-delivery-request #lot').text(lot);
    $('div#modal-cancel-delivery-request #from').text(from);
    $('div#modal-cancel-delivery-request #to').text(to);
    $('div#modal-cancel-delivery-request #price').text(price);

    $('#modal-cancel-delivery-request').modal('show');
  });
  $('.openModalCancelRequest').click(function () {
    let numberDeliveryRequest = $(this).attr('data-numberDeliveryRequest'),
      objectName = $(this).attr('data-objectName'),
      client = $(this).attr('data-client'),
      carrier = $(this).attr('data-carrier'),
      from = $(this).attr('data-from'),
      to = $(this).attr('data-to'),
      deliveryPrice = $(this).attr('data-deliveryPrice'),
      clientPrice = $(this).attr('data-clientPrice'),
      comment = $(this).attr('data-comment'),
      linkRequest = '/logistic/delivery?id=' + numberDeliveryRequest,
      linkObject = '/observer/object?id=' + $(this).attr('data-objectId');
    $('div#modal-cancel-delivery-request #numberDeliveryRequest').text(
      numberDeliveryRequest
    );
    $('div#modal-cancel-delivery-request #linkRequest').attr(
      'href',
      linkRequest
    );
    $('div#modal-cancel-delivery-request #linkObject').attr('href', linkObject);
    $('div#modal-cancel-delivery-request #objectName').html(objectName);
    $('div#modal-cancel-delivery-request #client').text(client);
    $('div#modal-cancel-delivery-request #carrier').text(carrier);
    $('div#modal-cancel-delivery-request #from').text(from);
    $('div#modal-cancel-delivery-request #to').text(to);
    $('div#modal-cancel-delivery-request #deliveryPrice').html(deliveryPrice);
    $('div#modal-cancel-delivery-request #clientPrice').html(clientPrice);
    $('div#modal-cancel-delivery-request #comment').text(comment);

    $('#modal-cancel-delivery-request').modal('show');
  });
  $('#cancelDeliveryRequest-success-button').click(function () {
    let number = $(
      'div#modal-cancel-delivery-request #numberDeliveryRequest'
    ).text(),
      reason = $('div#modal-cancel-delivery-request #cancelReason').val(),
      nameBtnSuccess = $('#cancelDeliveryRequest-success-button').text();

    if (typeof reason === 'undefined') reason = '';
    if (nameBtnSuccess[0].search(/[a-z]/i) !== -1) {
      cancelDeliveryRequest(
        number,
        reason,
        '/outer-carrier/cancel-delivery-request-ajax',
        'english'
      );
    } else {
      cancelDeliveryRequest(
        number,
        reason,
        '/logistic/cancel-delivery-request-ajax',
        'russian'
      );
    }
  });

  $('#accept-new-data-recipient-success-button').click(function () {
    $('#modal-accept-new-data-recipient').modal('hide');
    let form = document.getElementById('LogisticRecipientPerson-form');
    if (form.checkValidity()) {
      form.submit();
    } else {
      let list = form.querySelectorAll(':invalid');
      let index = 0;
      for (var item of list) {
        item.setAttribute('style', 'border-color: red;');
        if (index === 0) {
          setTimeout(function () {
            item.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }, 500);
        }
        index += 1;
      }
    }
  });
  $('.removeFile').click(function () {
    let reason = prompt('Укажите основание удаления (обязательно)', ''),
      fileId = $(this).attr('data-fileId'),
      recipientId = $('#recipientId').val(),
      elem = $(this);

    if (reason === '') {
      alert('Основание не может быть пустым');
    } else {
      $.post({
        cache: false,
        url: '/logistic/remove-doc-recipient-ajax',
        data: { id: fileId, recipientId: recipientId, reason: reason },
      })
        .done(function (data) {
          switch (data['status']) {
            case 'success':
              elem.parent().parent().addClass('hide');
              break;
            case 'fail':
              alert(
                'Произошла ошибка при удалении документа. \nОтвет сервера ' +
                data['msg']
              );
              break;
            default:
              alert('Произошла неизвестная ошибка');
              break;
          }
        })
        .fail(function (jqXHR) {
          alert(
            'Произошла ошибка при попытке запроса к Cartrack\n' +
            'Статус: ' +
            jqXHR['statusText'] +
            '\n' +
            'Код статуса: ' +
            jqXHR['status'] +
            '\n' +
            'Ответ сервера: ' +
            jqXHR['responseJSON']['name'] +
            '\n'
          );
        });
    }
  });

  if (
    window.location.href.indexOf('/navis/car') > -1 ||
    window.location.href.indexOf('/navis/parts') > -1 ||
    window.location.href.indexOf('/navis/aggregate') > -1
  ) {
    let listExclude =
      '#navispartsform-owner, #navispartsform-formal_owner, #navisaggregateform-owner';
    $('input:not(' + listExclude + ')').click(function () {
      if ($(this).attr('id') !== 'naviscarform-owner')
        overrideFilterAutocomplete('default');
    });
    $(listExclude).focus(function () {
      if ($(this).attr('id') !== 'naviscarform-owner')
        overrideFilterAutocomplete('beginSearch');
    });
  }

  $('#btn-search-vin').click(function () {
    let idDivTable = '#recipients-search-objects-table',
      url = '/logistic/get-data-table-objects-recipients-ajax',
      vin = $('#vin').val(),
      data = { vin: vin };
    createTable(data, idDivTable, url);
  });

  $('#changeDeliveryRoute-success-button').click(function () {
    let deliveryId = $('#deliveryId').val(),
      sourceId = $('#sourceId').val(),
      destinationId = $('#destinationId').val(),
      url = '/logistic/change-delivery-route-ajax',
      data = {
        deliveryId: deliveryId,
        sourceId: sourceId,
        destinationId: destinationId,
      };
    console.log(data);
    changeDeliveryRoute(url, data);
  });

  $('.removeReminder').click(function () {
    let id = $(this).attr('data-reminderId');
    removeReminder(id, this);
  });

  $('.removeReminderFromUser').click(function () {
    let id = $(this).attr('data-reminderId'),
      elem = this;
    removeReminderFromUser(id, elem);
  });

  $('#changeCommentDelivery-success-button').click(function () {
    let deliveryId = $('#deliveryRequestId').val(),
      comment = $('#commentDelivery').val();
    changeDeliveryComment(deliveryId, comment);
  });

  $('#changeDriverDelivery-success-button').click(function () {
    let deliveryId = $('#deliveryRequestId').val(),
      driverId = $('#driverId').val();
    changeDeliveryDriver(deliveryId, driverId);
  });

  $(document).on('focus', 'input[type=number]', function (e) {
    $(this).on('mousewheel.disableScroll', function (e) {
      e.preventDefault();
    });
  });
  $(document).on('blur', 'input[type=number]', function (e) {
    $(this).off('mousewheel.disableScroll');
  });

  $(document).on('click', '.openModalSendEmail', function () {
    let senderId = $(this).attr('data-senderId'),
      senderName = $(this).attr('data-senderName'),
      senderEmails = $(this).attr('data-senderEmails');

    $('#senderId').val(senderId);
    $('#senderName').text(senderName);
    $('#senderEmails').text(senderEmails);
    $('#modal-send-email').modal('show');
  });

  $.fn.modal.Constructor.prototype.enforceFocus = function () {
    let $modalElement = this.$element;
    $(document).on('focusin.modal', function (e) {
      if (
        $modalElement[0] !== e.target &&
        !$modalElement.has(e.target).length &&
        $(e.target).parentsUntil('*[role="dialog"]').length === 0
      ) {
        $modalElement.focus();
      }
    });
  };

  $(document).on(
    'click',
    '.openModalChangeDeliveryDefaultCarrier',
    function (e) {
      e.preventDefault();
      let deliveryDefaultCarrierId = $(this).attr(
        'data-deliveryDefaultCarrierId'
      ),
        sourceName = $(this).attr('data-sourceName'),
        destName = $(this).attr('data-destName'),
        carrierId = $(this).attr('data-carrierId'),
        deliveryPriceValue = $(this).attr('data-deliveryPriceValue'),
        clientPriceValue = $(this).attr('data-clientPriceValue'),
        notDriveDeliveryPriceValue = $(this).attr(
          'data-notDriveDeliveryPriceValue'
        ),
        notDriveClientPriceValue = $(this).attr(
          'data-notDriveClientPriceValue'
        );

      $('#deliveryDefaultCarrierId').val(deliveryDefaultCarrierId);
      $('#deliveryDefaultCarrierIdText').text(deliveryDefaultCarrierId);
      $('#sourceName').text(sourceName);
      $('#destinationName').text(destName);
      $('#carrierId').val(carrierId).trigger('change');
      $('#deliveryPrice').val(deliveryPriceValue);
      $('#clientPrice').val(clientPriceValue);
      $('#notDriveDeliveryPrice').val(notDriveDeliveryPriceValue);
      $('#notDriveClientPrice').val(notDriveClientPriceValue);
      $('#modal-ChangeDeliveryDefaultCarrier').modal('show');
    }
  );

  $(document).on('change', 'input#vin-issue-object', function () {
    let elemPlanned = '#plannedAt',
      flatpickr = $(elemPlanned).flatpickr({
        dateFormat: 'Y-m-d H:i',
        locale: 'en',
        time_24hr: true,
        enableTime: true,
      });
    $('#issue-not-allow-msg').hide();
    $('#data-car').hide();
    $('#mark').text('');
    $('#maker').text('');
    $('#location').text('');
    flatpickr._input.setAttribute('disabled', 'disabled');
    $(elemPlanned).addClass('cursor-not-allowed');
  });

  $(document).on('click', '#vin-issue-object-search', function () {
    let vin = $('input#vin-issue-object').val(),
      elemPlanned = '#plannedAt';
    $.get({
      cache: false,
      url: '/navis-sender/get-planned-date-last-request-issue-car-ajax',
      data: { vin: vin },
    })
      .done(function (data) {
        let flatpickr = $(elemPlanned).flatpickr({
          dateFormat: 'Y-m-d H:i',
          locale: 'en',
          time_24hr: true,
          enableTime: true,
        });
        $(elemPlanned).attr('disabled', 'disabled');
        switch (data['status']) {
          case 'success':
            flatpickr.set('minDate', data['minDate']);
            flatpickr._input.removeAttribute('disabled');
            flatpickr._input.removeAttribute('readonly');
            $(elemPlanned).addClass('cursor-pointer');
            $(elemPlanned).removeClass('cursor-not-allowed');
            $('#mark').text(data['mark']);
            $('#model').text(data['model']);
            $('#location').text(data['location']);
            if (data['isIssueAllow'] == false) {
              $('#issue-not-allow-msg').show();
            }
            $('#data-car').show();
            break;
          case 'fail':
            flatpickr._input.setAttribute('disabled', 'disabled');
            $(elemPlanned).addClass('cursor-not-allowed');
            break;
          default:
            alert('Unknown error');
            break;
        }
      })
      .fail(function (jqXHR) {
        alert(
          'Cartrack unavailable\n' +
          'Status: ' +
          jqXHR['statusText'] +
          '\n' +
          'Status code: ' +
          jqXHR['status'] +
          '\n' +
          'Server response: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      });
  });

  $(document).on('click', '.openModalFoundInPort', function () {
    let objectId = $(this).attr('data-objectId'),
      vin = $(this).attr('data-vin'),
      senderName = $(this).attr('data-sender'),
      model = $(this).attr('data-model'),
      contract = $(this).attr('data-contract');

    $('#contract').text(contract);
    $('#vin').text(vin);
    $('#model').text(model);
    $('#senderName').text(senderName);
    $('#objectId').val(objectId);
    $('#modal-foundInPort').modal('show');
  });

  $(document).on('click', '#foundInPort-success-button', function () {
    moveToPort();
  });

  $(document).on('click', '#uploadMediaBtn', function (e) {
    e.preventDefault();
    let $inputMedia = $('#mediaId'),
      urlPreSignedPostObject = '/system/get-data-pre-signed-form',
      entityId = $('#objectId').val(),
      entityType = $('#entityType').val(),
      mediaType = $('#mediaType').val(),
      successAction = function () {
        location.reload();
      },
      failAction = function (textError) {
        alert(textError);
        location.reload();
      };

    uploadToS3(
      $inputMedia,
      urlPreSignedPostObject,
      entityId,
      entityType,
      mediaType,
      successAction,
      failAction
    );
  });

  $(document).on('change', '#stockIdNav', function () {
    let stockId = $('#stockIdNav').val(); /*,
            date = new Date(new Date().getTime() + 24 * 60 * 60 * 1000)*/
    document.cookie = 'currentStockIdNavMagadan=' + stockId + '; path=/;';
    location.reload();
  });

  $(document).on('click', '#searchBtn', function () {
    let vin = $('#magadansearchform-vin').val();
    if (vin.length > 3) {
      instantSearchMagadan(vin);
    }
  });

  $(document).on(
    'click',
    '#search-object-full-vin-success-button',
    function () {
      let vin = $('#modal-search-object-full-vin #vin').val();
      location.href = '/magadan/detail?vin=' + vin;
    }
  );

  $(document).on('click', '#set_boundary_success_button', function () {
    let dataManufacture = $('#dateOfManufacture').val(),
      objectId = $('#objectId').val();

    $.post({
      cache: false,
      url: '/observer/set-boundary-mark',
      data: { objectId: objectId, dataManufacture: dataManufacture },
    })
      .done(function (response) {
        switch (response['status']) {
          case 'success':
            location.reload();
            break;
          case 'fail':
            alert('Ошибка. Ответ сервера: ' + response['msg']);
            break;
          default:
            alert('Неизвестная ошибка');
            break;
        }
      })
      .fail(function (jqXHR) {
        alert(
          'Произошла ошибка при попытке запроса к Cartrack\n' +
          'Статус: ' +
          jqXHR['statusText'] +
          '\n' +
          'Код статуса: ' +
          jqXHR['status'] +
          '\n' +
          'Ответ сервера: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      });
  });

  $(document).on('click', '.openModalPreDeliveryAcceptObject', function () {
    let modalSelector = '#modal-pre-delivery-accept-object',
      auctionName = $(this).data('auction_name'),
      lotId = $(this).data('lot_id'),
      objectName = $(this).data('object_name'),
      frameNumber = $(this).data('frame_number'),
      price = $(this).data('price'),
      preObjectId = $(this).data('pre_object_id'),
      preAuctionId = $(this).data('auction_id'),
      aucId = $(this).data('auc_id'),
      markId = $(this).data('mark_id'),
      makerId = $(this).data('maker_id'),
      aucIdPos = $(this).data('auc_id_pos'),
      destinationId = $(this).data('destination_id');

    $(modalSelector + ' #aucIdPosDiv').removeClass('has-error');
    $(modalSelector + ' #aucIdPosDiv span.help-block').addClass('hide');

    if (parseInt(aucId) === 29) {
      $(modalSelector + ' #auctionIdDiv').removeClass('has-error');
      $(modalSelector + ' #auctionIdDiv span.help-block').addClass('hide');
      $(modalSelector + ' #auctionId').change(function () {
        getPreDeliveryCarriers(preAuctionId, $(this).val());
      });
    } else {
      $(modalSelector + ' #auctionIdDiv').remove();
    }

    if (parseInt(price) === 0) {
      $(modalSelector + ' #priceDeliveryDiv').removeClass('has-error');
      $(modalSelector + ' #priceDeliveryDiv span.help-block').addClass('hide');
    } else {
      $(modalSelector + ' #priceDeliveryDiv').remove();
    }

    $(modalSelector + ' #destinationIdDiv').removeClass('has-error');
    $(modalSelector + ' #destinationIdDiv span.help-block').addClass('hide');

    $(modalSelector + ' #markIdDiv').removeClass('has-error');
    $(modalSelector + ' #markIdDiv span.help-block').addClass('hide');

    $(modalSelector + ' #makerIdDiv').removeClass('has-error');
    $(modalSelector + ' #makerIdDiv span.help-block').addClass('hide');

    $(modalSelector + ' #frameNumberDiv').removeClass('has-error');
    $(modalSelector + ' #frameNumberDiv span.help-block').addClass('hide');

    $.get({
      cache: false,
      url: '/logistic/get-photos-pre-object',
      data: { preObjectId: preObjectId },
    })
      .done(function (response) {
        switch (response['status']) {
          case 'success':
            let htmlData = '';
            $.each(response['data'], function (index, value) {
              htmlData +=
                ' <div class="col-md-4 mb-5px">' +
                '<a href="' +
                value['img'] +
                "\" target='_blank'>\n" +
                '<img src="' +
                value['thumb'] +
                '" class="width-100per">\n' +
                '</a>\n' +
                '</div>';
            });
            $(modalSelector + ' #photosBlock').html(htmlData);
            break;
          case 'fail':
            alert(
              'Произошла ошибка при попытке получить фотографии. \nОтвет сервера: ' +
              response['msg']
            );
            break;
          default:
            alert('Неизвестная ошибка');
            break;
        }
      })
      .fail(function (jqXHR) {
        alert(
          'Произошла ошибка при попытке запроса к Cartrack\n' +
          'Статус: ' +
          jqXHR['statusText'] +
          '\n' +
          'Код статуса: ' +
          jqXHR['status'] +
          '\n' +
          'Ответ сервера: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      });

    $(modalSelector + ' #auctionNameText').text(auctionName);
    $(modalSelector + ' #lotIdText').text(lotId);
    $(modalSelector + ' #objectNameText').text(objectName);
    $(modalSelector + ' #frameNumberText').text(frameNumber);
    $(modalSelector + ' #priceText').html(price);
    $(modalSelector + ' #markIdHidden').val(markId);

    $(modalSelector + ' #makerId')
      .val(makerId)
      .trigger('change');
    $(modalSelector + ' #preObjectId').val(preObjectId);
    $(modalSelector + ' #frameNumber').val(frameNumber);
    $(modalSelector + ' #photos').val(null);
    $(modalSelector + ' #aucIdPos').val(aucIdPos);
    $(modalSelector + ' #destinationId')
      .val(destinationId)
      .trigger('change');

    getPreDeliveryCarriers(preAuctionId);

    $(modalSelector).modal('show');
  });

  function getPreDeliveryCarriers(preAuctionId, auctionId = null) {
    $.get({
      cache: false,
      url: '/logistic/get-carriers-for-pre-auction-route',
      data: { preAuctionId: preAuctionId, auctionId: auctionId },
    })
      .done(function (response) {
        switch (response['status']) {
          case 'success':
            let htmlData = "<option value='0'>Назначить позднее</option>";
            $.each(response['data'], function (index, value) {
              htmlData +=
                "<option value='" +
                value['value'] +
                "'>" +
                value['label'] +
                '</option>';
            });
            let carrierSelector =
              '#modal-pre-delivery-accept-object #carrierId';
            $(carrierSelector).empty().trigger('change');
            $(carrierSelector).html(htmlData);
            $(carrierSelector).val(null).trigger('change');
            break;
          case 'fail':
            alert(
              'Не удалось получить список перевозчиков. \nОтвет сервера: ' +
              response['msg']
            );
            break;
          default:
            alert('Неизвестная ошибка');
            break;
        }
      })
      .fail(function (jqXHR) {
        alert(
          'Произошла ошибка при попытке запроса к Cartrack\n' +
          'Статус: ' +
          jqXHR['statusText'] +
          '\n' +
          'Код статуса: ' +
          jqXHR['status'] +
          '\n' +
          'Ответ сервера: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      });
  }

  $(document).on(
    'click',
    '#modal-pre-delivery-accept-object #acceptPreDeliveryObjectSuccessBtn',
    function () {
      let modalSelector = '#modal-pre-delivery-accept-object',
        preObjectId = $(modalSelector + ' #preObjectId').val(),
        aucIdPos = $(modalSelector + ' #aucIdPos').val(),
        carrierId = $(modalSelector + ' #carrierId').val(),
        markId = $(modalSelector + ' #markId').val(),
        makerId = $(modalSelector + ' #makerId').val(),
        frameNumber = $(modalSelector + ' #frameNumber').val(),
        destinationId = $(modalSelector + ' #destinationId').val(),
        $photos = $(modalSelector + ' #photos').prop('files'),
        data = new FormData();

      if (typeof aucIdPos === 'undefined' || aucIdPos == '') {
        aucIdPos = '';
        $(modalSelector + ' #aucIdPosDiv').addClass('has-error');
        $(modalSelector + ' #aucIdPosDiv span.help-block').removeClass('hide');
      } else {
        $(modalSelector + ' #aucIdPosDiv').removeClass('has-error');
        $(modalSelector + ' #aucIdPosDiv span.help-block').addClass('hide');
      }

      if (typeof destinationId === 'undefined' || destinationId == '') {
        destinationId = '';
        $(modalSelector + ' #destinationIdDiv').addClass('has-error');
        $(modalSelector + ' #destinationIdDiv span.help-block').removeClass(
          'hide'
        );
      } else {
        $(modalSelector + ' #destinationIdDiv').removeClass('has-error');
        $(modalSelector + ' #destinationIdDiv span.help-block').addClass(
          'hide'
        );
      }

      if (typeof markId === 'undefined' || markId == '') {
        markId = '';
        $(modalSelector + ' #markIdDiv').addClass('has-error');
        $(modalSelector + ' #markIdDiv span.help-block').removeClass('hide');
      } else {
        $(modalSelector + ' #markIdDiv').removeClass('has-error');
        $(modalSelector + ' #markIdDiv span.help-block').addClass('hide');
      }

      if (typeof makerId === 'undefined' || makerId == '') {
        makerId = '';
        $(modalSelector + ' #makerIdDiv').addClass('has-error');
        $(modalSelector + ' #makerIdDiv span.help-block').removeClass('hide');
      } else {
        $(modalSelector + ' #makerIdDiv').removeClass('has-error');
        $(modalSelector + ' #makerIdDiv span.help-block').addClass('hide');
      }

      if (typeof frameNumber === 'undefined' || frameNumber == '') {
        frameNumber = '';
        $(modalSelector + ' #frameNumberDiv').addClass('has-error');
        $(modalSelector + ' #frameNumberDiv span.help-block').removeClass(
          'hide'
        );
      } else {
        $(modalSelector + ' #frameNumberDiv').removeClass('has-error');
        $(modalSelector + ' #frameNumberDiv span.help-block').addClass('hide');
      }

      let priceDelivery = null;
      let isHasFieldPrice = false;
      if ($(modalSelector + ' #priceDelivery').length > 0) {
        priceDelivery = $(modalSelector + ' #priceDelivery').val();
        isHasFieldPrice = true;
        if (
          typeof priceDelivery === 'undefined' ||
          priceDelivery == '' ||
          priceDelivery === 0
        ) {
          priceDelivery = '';
          $(modalSelector + ' #priceDeliveryDiv').addClass('has-error');
          $(modalSelector + ' #priceDeliveryDiv span.help-block').removeClass(
            'hide'
          );
        } else {
          $(modalSelector + ' #priceDeliveryDiv').removeClass('has-error');
          $(modalSelector + ' #priceDeliveryDiv span.help-block').addClass(
            'hide'
          );
        }
      }

      let auctionId = null;
      let isHasFieldAuction = false;
      if ($(modalSelector + ' #auctionId').length > 0) {
        auctionId = $(modalSelector + ' #auctionId').val();
        isHasFieldAuction = true;
        if (typeof auctionId === 'undefined' || auctionId == '') {
          auctionId = '';
          $(modalSelector + ' #auctionIdDiv').addClass('has-error');
          $(modalSelector + ' #auctionIdDiv span.help-block').removeClass(
            'hide'
          );
        } else {
          $(modalSelector + ' #auctionIdDiv').removeClass('has-error');
          $(modalSelector + ' #auctionIdDiv span.help-block').addClass('hide');
        }
      }

      if (typeof preObjectId === 'undefined' || preObjectId == '') {
        alert(
          'Неустановлен системный параметр. Попробуйте обновить страницу или обратитесь к администратору'
        );
      }

      if (
        preObjectId != '' &&
        aucIdPos != '' &&
        markId != '' &&
        makerId != '' &&
        frameNumber != '' &&
        destinationId != '' &&
        ((isHasFieldAuction && auctionId != '') || !isHasFieldAuction) &&
        ((isHasFieldPrice && priceDelivery != '') || !isHasFieldPrice)
      ) {
        data.append('preObjectId', preObjectId);
        data.append('aucIdPos', aucIdPos);
        data.append('carrierId', carrierId);
        data.append('markId', markId);
        data.append('makerId', makerId);
        data.append('frameNumber', frameNumber);
        data.append('destinationId', destinationId);
        data.append('auctionId', auctionId);
        data.append('priceDelivery', priceDelivery);

        $.each($photos, function (index, value) {
          data.append(index, value);
        });

        $.post({
          cache: false,
          url: '/logistic/pre-accept-object',
          data: data,
          processData: false,
          contentType: false,
        })
          .done(function (response) {
            switch (response['status']) {
              case 'success':
                let html = '',
                  countInProcess = Number($('#countInProcess').text()),
                  countAccepted = Number($('#countAccepted').text());

                $('#countInProcess').text(countInProcess - 1);
                $('#countAccepted').text(countAccepted + 1);

                if (typeof response['data']['deliveryId'] !== 'undefined') {
                  html +=
                    '<a href="/logistic/delivery?id=' +
                    response['data']['deliveryId'] +
                    '">Заявка на доставку №' +
                    response['data']['deliveryId'] +
                    '</a><br>';
                }
                if (html != '') {
                  $('#links_' + preObjectId).html(html);
                }
                $('#mark_' + preObjectId).html(response['data']['markName']);
                $('#model_' + preObjectId).html(response['data']['modelName']);

                $.get({
                  cache: false,
                  url: '/logistic/get-photos-pre-object',
                  data: { preObjectId: preObjectId },
                }).done(function (response) {
                  switch (response['status']) {
                    case 'success':
                      let htmlData = '';
                      $.each(response['data'], function (index, value) {
                        htmlData +=
                          '<div class="object-image-item">' +
                          '<a href="' +
                          value['img'] +
                          '" target="_blank">' +
                          '<img src="' +
                          value['thumb'] +
                          '" width="38px" height="27px" alt="">' +
                          '</a><br>' +
                          '</div>';
                      });
                      $('#objectImage_' + preObjectId).html(htmlData);
                      break;
                    case 'fail':
                      alert(
                        'Произошла ошибка при попытке получить фотографии. \nОтвет сервера: ' +
                        response['msg']
                      );
                      break;
                    default:
                      alert('Неизвестная ошибка');
                      break;
                  }
                });

                $('#acceptRejectPreObject_' + preObjectId).html('');
                $('#addPhotos_' + preObjectId).html('');
                $('#status_' + preObjectId).html(
                  "<span class='color-green'>Принята</span>"
                );
                $(modalSelector).modal('hide');
                break;
              case 'fail':
                alert(
                  'Ошибка при попытке принять предварительный объект. \nОтвет сервера: ' +
                  response['msg']
                );
                break;
              default:
                alert('Неизвестная ошибка');
                break;
            }
          })
          .fail(function (jqXHR) {
            alert(
              'Произошла ошибка при попытке запроса к Cartrack\n' +
              'Статус: ' +
              jqXHR['statusText'] +
              '\n' +
              'Код статуса: ' +
              jqXHR['status'] +
              '\n' +
              'Ответ сервера: ' +
              jqXHR['responseJSON']['name'] +
              '\n'
            );
          });
      }
    }
  );

  $(document).on('click', '.openModalPreDeliveryRejectObject', function () {
    let modalSelector = '#modal-pre-delivery-reject-object',
      auctionName = $(this).data('auction_name'),
      lotId = $(this).data('lot_id'),
      objectName = $(this).data('object_name'),
      frameNumber = $(this).data('frame_number'),
      price = $(this).data('price'),
      preObjectId = $(this).data('pre_object_id'),
      reasonRejectDivSelector = modalSelector + ' div#reasonRejectDiv';

    $(reasonRejectDivSelector).removeClass('has-error');
    $(reasonRejectDivSelector + ' span.help-block').addClass('hide');

    $(modalSelector + ' #auctionNameText').text(auctionName);
    $(modalSelector + ' #lotIdText').text(lotId);
    $(modalSelector + ' #objectNameText').text(objectName);
    $(modalSelector + ' #frameNumberText').text(frameNumber);
    $(modalSelector + ' #priceText').html(price);

    $(modalSelector + ' #preObjectId').val(preObjectId);
    $(modalSelector + ' #reasonRejectInput').val('');

    $(modalSelector).modal('show');
  });

  $(document).on(
    'click',
    '#modal-pre-delivery-reject-object #rejectPreDeliveryObjectBtn',
    function () {
      let modalSelector = '#modal-pre-delivery-reject-object',
        reason = $(
          '#modal-pre-delivery-reject-object #reasonRejectInput'
        ).val(),
        preObjectId = $('#modal-pre-delivery-reject-object #preObjectId').val(),
        reasonRejectDivSelector =
          'div#modal-pre-delivery-reject-object div#reasonRejectDiv';

      if (typeof reason === 'undefined') reason = '';

      if (reason === '') {
        $(reasonRejectDivSelector).addClass('has-error');
        $(reasonRejectDivSelector + ' span.help-block').removeClass('hide');
      } else {
        $.post({
          cache: false,
          url: '/logistic/pre-reject-object',
          data: { preObjectId: preObjectId, rsn: reason },
        })
          .done(function (data) {
            switch (data['status']) {
              case 'success':
                let countInProcess = Number($('#countInProcess').text()),
                  countRejected = Number($('#countRejected').text());
                $('#countInProcess').text(countInProcess - 1);
                $('#countRejected').text(countRejected + 1);

                $(reasonRejectDivSelector).removeClass('has-error');
                $(reasonRejectDivSelector + ' span.help-block').addClass(
                  'hide'
                );
                $('#acceptRejectPreObject_' + preObjectId).html('');
                $('#addPhotos_' + preObjectId).html('');
                $('#status_' + preObjectId).html(
                  "<span class='color-red'>Отклонена</span>"
                );
                $(modalSelector).modal('hide');
                break;
              case 'fail':
                alert('Ошибка. Ответ сервера: ' + data['msg']);
                break;
              default:
                alert('Неизвестная ошибка');
                break;
            }
          })
          .fail(function (jqXHR) {
            console.log(jqXHR);
            alert(
              'Произошла ошибка при попытке запроса к Cartrack\n' +
              'Статус: ' +
              jqXHR['statusText'] +
              '\n' +
              'Код статуса: ' +
              jqXHR['status'] +
              '\n' +
              'Ответ сервера: ' +
              jqXHR['responseJSON']['name'] +
              '\n'
            );
          });
      }
    }
  );

  $(document).on('click', '#mailing_invoices', function () {
    let isConfirm = confirm(
      'Вы уверены, что хотите сделать рассылку инвойсов?'
    ),
      $this = $(this);

    if (isConfirm) {
      $.post({
        cache: false,
        url: '/documents/mailing-invoice-delivery-to-senders-prev-month',
        data: {},
      })
        .done(function (response) {
          let fails = '';
          switch (response['status']) {
            case 'success':
              alert('Рассылка выполнена успешно');
              $this.hide();
              break;
            case 'warning':
              $.each(response['data']['failsList'], function (index, value) {
                fails +=
                  value['senderName'] + ' Причина: ' + value['errMsg'] + '\n';
              });
              alert(
                'Рассылка завершилась с ошибками. Следующие отправители не получили письма:\n' +
                fails
              );
              $this.hide();
              break;
            case 'fail':
              alert(
                'Произошла ошибка при попытке разослать инвойсы. \nОтвет сервера: ' +
                response['msg']
              );
              break;
            default:
              alert('Неизвестная ошибка');
              break;
          }
        })
        .fail(function (jqXHR) {
          alert(
            'Произошла ошибка при попытке запроса к Cartrack\n' +
            'Статус: ' +
            jqXHR['statusText'] +
            '\n' +
            'Код статуса: ' +
            jqXHR['status'] +
            '\n' +
            'Ответ сервера: ' +
            jqXHR['responseText'] +
            '\n'
          );
        });
    }
  });

  $(document).on('click', '.sent_invoice_delivery', function () {
    let senderName = $(this).data('sender_name'),
      senderId = $(this).data('sender_id'),
      monthName = $(this).data('prev_month'),
      isConfirm = confirm(
        'Отправить инвойс за ' + monthName + ' отправителю ' + senderName + '?'
      ),
      $this = $(this);

    if (isConfirm) {
      $.post({
        cache: false,
        url: '/documents/sent-invoice-delivery-to-sender',
        data: { senderId: senderId },
      })
        .done(function (response) {
          switch (response['status']) {
            case 'success':
              alert('Инвойс успешно отправлен');
              $this.hide();
              break;
            case 'fail':
              alert('Ошибка. \nОтвет сервера: ' + response['msg']);
              break;
            default:
              alert('Неизвестная ошибка');
              break;
          }
        })
        .fail(function (jqXHR) {
          alert(
            'Произошла ошибка при попытке запроса к Cartrack\n' +
            'Статус: ' +
            jqXHR['statusText'] +
            '\n' +
            'Код статуса: ' +
            jqXHR['status'] +
            '\n' +
            'Ответ сервера: ' +
            jqXHR['responseText'] +
            '\n'
          );
        });
    }
  });

  $(document).on(
    'click',
    '#modal-add-comment #add_comment_success_button',
    function () {
      let modalSelector = '#modal-add-comment',
        objectId = $('#objectId').val(),
        comment = $(modalSelector + ' #object_comment').val();

      $.post({
        cache: false,
        url: '/observer/add-object-comment',
        data: { objectId: objectId, comment: comment },
      })
        .done(function (response) {
          switch (response['status']) {
            case 'success':
              location.reload();
              break;
            case 'fail':
              alert(
                'Ошибка при попытке изменить комментарий\nОтвет сервера ' +
                response['msg']
              );
              break;
            default:
              alert('Неизвестная ошибка');
              break;
          }
        })
        .fail(function (jqXHR) {
          alert(
            'Произошла ошибка при попытке запроса к Cartrack\n' +
            'Статус: ' +
            jqXHR['statusText'] +
            '\n' +
            'Код статуса: ' +
            jqXHR['status'] +
            '\n' +
            'Ответ сервера: ' +
            jqXHR['responseJSON']['name'] +
            '\n'
          );
        });
    }
  );
  $(document).on('click', '#btnShowComment', function () {
    if ($('#commentModalSbkts').css('display') == 'none') {
      $('#btnShowComment').html('Показать комментарии');
    } else {
      $('#btnShowComment').html('Скрыть комментарии');
      let sbktsId = $('#sbktsId').val();
      let html = '';
      $.post({
        cache: false,
        url: '/object/get-sbkts-comments',
        data: { sbkts_id: sbktsId },
      })
        .done(function (response) {
          switch (response['status']) {
            case 'success':
              for (let i = 0; i < response['comments'].length; i++) {
                let t = response['comments'][i]['date'] * 1000;
                let d = new Date(t);
                html +=
                  '<tr><td>' +
                  d.toLocaleString() +
                  '</td><td>' +
                  response['comments'][i]['text'] +
                  '</td><td>' +
                  response['comments'][i]['user'] +
                  '</td><tr>';
              }
              document.querySelector('#tableSbktsComment > tbody').innerHTML =
                html;
              break;
            case 'fail':
              alert(
                'Ошибка при попытке получить комментарии\nОтвет сервера ' +
                response['msg']
              );
              document.querySelector('#tableSbktsComment > tbody').innerHTML =
                html;
              break;
            default:
              alert('Неизвестная ошибка');
              document.querySelector('#tableSbktsComment > tbody').innerHTML =
                html;
              break;
          }
        })
        .fail(function (jqXHR) {
          alert(
            'Произошла ошибка при попытке запроса к Cartrack\n' +
            'Статус: ' +
            jqXHR['statusText'] +
            '\n' +
            'Код статуса: ' +
            jqXHR['status'] +
            '\n' +
            'Ответ сервера: ' +
            jqXHR['responseJSON']['name'] +
            '\n'
          );
        });
    }
  });
  //Sbkts Comments
  $(document).on(
    'click',
    '#modal-add-sbkts-comment #add_comment_sbkts_success_button',
    function () {
      let modalSelector = '#modal-add-sbkts-comment',
        sbktsId = $('#sbktsId').val(),
        comment = $(modalSelector + ' #sbkts_comment').val();
      $.post({
        cache: false,
        url: '/object/add-sbkts-comment',
        data: { sbkts_id: sbktsId, comment: comment },
      })
        .done(function (response) {
          switch (response['status']) {
            case 'success':
              location.reload();
              break;
            case 'fail':
              alert(
                'Ошибка при попытке добавить комментарий\nОтвет сервера ' +
                response['msg']
              );
              break;
            default:
              alert('Неизвестная ошибка');
              break;
          }
        })
        .fail(function (jqXHR) {
          alert(
            'Произошла ошибка при попытке запроса к Cartrack\n' +
            'Статус: ' +
            jqXHR['statusText'] +
            '\n' +
            'Код статуса: ' +
            jqXHR['status'] +
            '\n' +
            'Ответ сервера: ' +
            jqXHR['responseJSON']['name'] +
            '\n'
          );
        });
    }
  );

  $(document).on('click', '.apply-capacity-stock', function () {
    let stockId = $(this).data('stock_id'),
      stockName = $(this).data('stock_name'),
      $capacityInput = $('#capacityStock_' + stockId),
      capacity = $capacityInput.val();

    $.post({
      cache: false,
      url: '/observer/change-capacity-stock',
      data: { stockId: stockId, capacity: capacity },
    })
      .done(function (response) {
        switch (response['status']) {
          case 'success':
            break;
          case 'fail':
            alert(
              'Ошибка при повытке изменить емкость склада. \nОтвет сервера:' +
              response['msg']
            );
            break;
          default:
            alert('Неизвестная ошибка');
            break;
        }
      })
      .fail(function (jqXHR) {
        alert(
          'Произошла ошибка при попытке запроса к Cartrack\n' +
          'Статус: ' +
          jqXHR['statusText'] +
          '\n' +
          'Код статуса: ' +
          jqXHR['status'] +
          '\n' +
          'Ответ сервера: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      });
  });

  $(document).on('click', '.apply-capacity-sector', function () {
    let sectorId = $(this).data('sector_id'),
      sectorName = $(this).data('sector_name'),
      stockName = $(this).data('stock_name'),
      $capacityInput = $('#capacitySector_' + sectorId),
      capacity = $capacityInput.val();

    $.post({
      cache: false,
      url: '/observer/change-capacity-sector',
      data: { sectorId: sectorId, capacity: capacity },
    })
      .done(function (response) {
        switch (response['status']) {
          case 'success':
            break;
          case 'fail':
            alert(
              'Ошибка при попытке изменить емкость склада. \nОтвет сервера:' +
              response['msg']
            );
            break;
          default:
            alert('Неизвестная ошибка');
            break;
        }
      })
      .fail(function (jqXHR) {
        alert(
          'Произошла ошибка при попытке запроса к Cartrack\n' +
          'Статус: ' +
          jqXHR['statusText'] +
          '\n' +
          'Код статуса: ' +
          jqXHR['status'] +
          '\n' +
          'Ответ сервера: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      });
  });

  $(document).on('change', '#control_synonyms #makerId', function (e) {
    const markSelector = '#markId';

    $('#open_modal_add_synonym_maker').addClass('hide');

    $.post('/navis/models?maker=' + e.target.value, function (data) {
      $(markSelector).html(data);
    });
    $.get(
      '/data/get-synonyms?originalId=' + $('#makerId').val() + '&type=maker',
      function (response) {
        switch (response['status']) {
          case 'success':
            let htmlData = '';
            $.each(response['data'], function (index, data) {
              htmlData +=
                '<h4>' +
                data['synonym'] +
                " <i id='remove_synonym_maker' class='fas fa-times cursor-pointer color-red' " +
                "title='Удалить синоним модели' data-synonym_name='" +
                data['synonym'] +
                "' data-synonym_id='" +
                data['id'] +
                "'></i><br>" +
                '</h4>';
            });
            $('#synonyms_makers').html(htmlData);
            $('#open_modal_add_synonym_maker').removeClass('hide');
            break;
          case 'fail':
            alert('Ошибка при попытке получения списка синонимов');
            break;
          default:
            alert('Неизвестная ошибка');
            break;
        }
      }
    );
  });

  $(document).on('change', '#control_synonyms #markId', function (e) {
    $('#open_modal_add_synonym_mark').addClass('hide');

    $.get(
      '/data/get-synonyms?originalId=' + $('#markId').val() + '&type=mark',
      function (response) {
        switch (response['status']) {
          case 'success':
            let htmlData = '';
            $.each(response['data'], function (index, data) {
              htmlData +=
                '<h4>' +
                data['synonym'] +
                " <i id='remove_synonym_mark' class='fas fa-times cursor-pointer color-red' " +
                "title='Удалить синоним модели' data-synonym_name='" +
                data['synonym'] +
                "' data-synonym_id='" +
                data['id'] +
                "'></i><br>" +
                '</h4>';
            });
            $('#synonyms_marks').html(htmlData);
            $('#open_modal_add_synonym_mark').removeClass('hide');
            break;
          case 'fail':
            alert('Ошибка при попытке получения списка синонимов');
            break;
          default:
            alert('Неизвестная ошибка');
            break;
        }
      }
    );
  });

  $(document).on('click', '#remove_synonym_maker', function () {
    let synonymName = $(this).data('synonym_name'),
      synonymId = $(this).data('synonym_id'),
      isOk = confirm('Удалить синоним ' + synonymName + ' ?'),
      $this = $(this);

    if (isOk) {
      $.post({
        cache: false,
        url: '/data/remove-synonym',
        data: { synonymId: synonymId },
      })
        .done(function (response) {
          $this.parent().remove();
        })
        .fail(function (jqXHR) {
          alert(
            'Произошла ошибка при попытке запроса к Cartrack\n' +
            'Статус: ' +
            jqXHR['statusText'] +
            '\n' +
            'Код статуса: ' +
            jqXHR['status'] +
            '\n' +
            'Ответ сервера: ' +
            jqXHR['responseText'] +
            '\n'
          );
        });
    }
  });

  $(document).on('click', '#remove_synonym_mark', function () {
    let synonymName = $(this).data('synonym_name'),
      synonymId = $(this).data('synonym_id'),
      isOk = confirm('Удалить синоним ' + synonymName + ' ?'),
      $this = $(this);

    if (isOk) {
      $.post({
        cache: false,
        url: '/data/remove-synonym',
        data: { synonymId: synonymId },
      })
        .done(function (response) {
          $this.parent().remove();
        })
        .fail(function (jqXHR) {
          alert(
            'Произошла ошибка при попытке запроса к Cartrack\n' +
            'Статус: ' +
            jqXHR['statusText'] +
            '\n' +
            'Код статуса: ' +
            jqXHR['status'] +
            '\n' +
            'Ответ сервера: ' +
            jqXHR['responseText'] +
            '\n'
          );
        });
    }
  });

  $(document).on('click', '#open_modal_add_synonym_maker', function () {
    let makerName = $('#makerId option:selected').text(),
      modalSelector = '#modal_add_synonym',
      originalId = $('#makerId').val();

    $(modalSelector + ' #synonymName')
      .prev()
      .removeClass('color-red');
    $(modalSelector + ' #nameText').text('марки ' + makerName);
    $(modalSelector + ' #original_id').val(originalId);
    $(modalSelector + ' #type').val('maker');
    $(modalSelector + ' #synonymName').val('');
    $(modalSelector).modal('show');
  });

  $(document).on('click', '#open_modal_add_synonym_mark', function () {
    let markName = $('#markId option:selected').text(),
      modalSelector = '#modal_add_synonym',
      originalId = $('#markId').val();

    $(modalSelector + ' #synonymName')
      .prev()
      .removeClass('color-red');
    $(modalSelector + ' #nameText').text('модели ' + markName);
    $(modalSelector + ' #original_id').val(originalId);
    $(modalSelector + ' #type').val('mark');
    $(modalSelector + ' #synonymName').val('');
    $(modalSelector).modal('show');
  });

  $(document).on('click', '#add_synonym', function () {
    let modalSelector = '#modal_add_synonym',
      originalId = $(modalSelector + ' #original_id').val(),
      type = $(modalSelector + ' #type').val(),
      synonymName = $(modalSelector + ' #synonymName').val(),
      html = '';

    if (synonymName == '') {
      $(modalSelector + ' #synonymName')
        .prev()
        .addClass('color-red');
    } else {
      if (type == 'mark') {
        html = $('#synonyms_marks').html();
      } else if (type == 'model') {
        html = $('#synonyms_models').html();
      }
      $.post({
        cache: false,
        url: '/data/add-synonym',
        data: { originalId: originalId, type: type, synonymName: synonymName },
      })
        .done(function (response) {
          let nameEntity = '',
            containerSelector = '';
          if (type == 'mark') {
            nameEntity = 'марки';
            containerSelector = '#synonyms_marks';
          } else if (type == 'model') {
            nameEntity = 'модели';
            containerSelector = '#synonyms_models';
          }
          html +=
            '<h4>' +
            synonymName +
            " <i id='remove_synonym_" +
            type +
            "' class='fas fa-times cursor-pointer color-red' " +
            "title='Удалить синоним " +
            nameEntity +
            "' data-synonym_name='" +
            synonymName +
            "' data-synonym_id='" +
            response['data']['synonymId'] +
            "'></i></h4>";

          $(containerSelector).html(html);
          $(modalSelector).modal('hide');
        })
        .fail(function (jqXHR) {
          alert(
            'Произошла ошибка при попытке запроса к Cartrack\n' +
            'Статус: ' +
            jqXHR['statusText'] +
            '\n' +
            'Код статуса: ' +
            jqXHR['status'] +
            '\n' +
            'Ответ сервера: ' +
            jqXHR['responseText'] +
            '\n'
          );
        });
    }
  });

  $(document).on('click', '#modal_replace_double #vin_search', function () {
    let modalSelector = '#modal_replace_double',
      vin = $(modalSelector + ' #vin').val(),
      dataContainerSelector = '#objects_list',
      html = '';

    $.get({
      cache: false,
      url: '/data/get-objects-list',
      data: { vin: vin },
    })
      .done(function (response) {
        switch (response['status']) {
          case 'success':
            html +=
              "<table class='table table-striped'>" +
              '<thead>' +
              "<tr class='active'>" +
              '<th>Объект</th>' +
              '<th></th>' +
              '</tr>' +
              '</thead>' +
              '<tbody>';
            $.each(response['data']['objects'], function (index, value) {
              html +=
                '<tr>' +
                "<td><a href='/observer/object?id=" +
                value['objectId'] +
                "' target='_blank'>" +
                value['markName'] +
                ' ' +
                value['modelName'] +
                '<br>' +
                value['vin'] +
                '</a></td>' +
                "<td><button type='button' class='replace_double_apply btn btn-primary'" +
                "data-object_id='" +
                value['objectId'] +
                "' data-object_name='" +
                value['markName'] +
                ' ' +
                value['modelName'] +
                ' ' +
                value['vin'] +
                "'>" +
                '<i class="fas fa-sync" title=\'Заменить\'></i></button></td>' +
                '</tr>';
            });
            html += '</tbody></table>';
            $(modalSelector + ' ' + dataContainerSelector).html(html);
            break;
          case 'fail':
            alert(
              'Ошибка при попытке получить список объектов. \nОтвет сервера: ' +
              response['msg']
            );
            break;
          default:
            alert('Неизвестная ошибка');
            break;
        }
      })
      .fail(function (jqXHR) {
        alert(
          'Произошла ошибка при попытке запроса к Cartrack\n' +
          'Статус: ' +
          jqXHR['statusText'] +
          '\n' +
          'Код статуса: ' +
          jqXHR['status'] +
          '\n' +
          'Ответ сервера: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      });
  });

  $(document).on('click', '.replace_double_apply', function () {
    let modalSelector = '#modal_replace_double',
      objectIdDouble = $('#objectId').val(),
      objectIdOriginal = $(this).data('object_id'),
      objectNameDouble = $(modalSelector + ' #object_name').text(),
      objectNameOriginal = $(this).data('object_name'),
      isOk = confirm(
        'Дубль: ' +
        objectNameDouble +
        ' -> оригинал: ' +
        objectNameOriginal +
        '. Вы уверены, что хотите произвести замену?'
      );

    if (isOk) {
      $.post({
        cache: false,
        url: '/data/replace-double-object',
        data: {
          objectIdDouble: objectIdDouble,
          objectIdOriginal: objectIdOriginal,
        },
      })
        .done(function (response) {
          switch (response['status']) {
            case 'success':
              location.reload();
              break;
            case 'fail':
              alert(
                'Ошибка при попытке заменить дубль. \nОтвет сервера: ' +
                response['msg']
              );
              location.reload();
              break;
            default:
              alert('Неизвестная ошибка');
              break;
          }
        })
        .fail(function (jqXHR) {
          alert(
            'Произошла ошибка при попытке запроса к Cartrack\n' +
            'Статус: ' +
            jqXHR['statusText'] +
            '\n' +
            'Код статуса: ' +
            jqXHR['status'] +
            '\n' +
            'Ответ сервера: ' +
            jqXHR['responseJSON']['name'] +
            '\n'
          );
        });
    }
  });

  $(document).on('click', '#akb-worker-create-delivery', function () {
    let objectId = $(this).data('object_id'),
      isOk = confirm('Вы уверены?');

    if (isOk) {
      $.post({
        cache: false,
        url: '/akebono-worker/create-delivery-request-to-disassemble',
        data: { objectId: objectId },
      })
        .done(function (response) {
          switch (response['status']) {
            case 'success':
              location.reload();
              break;
            case 'fail':
              alert(
                'Ошибка при попытке создать заявку на доставку. \nОтвет сервера: ' +
                response['msg']
              );
              break;
            default:
              alert('Неизвестная ошибка');
              break;
          }
        })
        .fail(function (jqXHR) {
          alert(
            'Произошла ошибка при попытке запроса к Cartrack\n' +
            'Статус: ' +
            jqXHR['statusText'] +
            '\n' +
            'Код статуса: ' +
            jqXHR['status'] +
            '\n' +
            'Ответ сервера: ' +
            jqXHR['responseJSON']['name'] +
            '\n'
          );
        });
    }
  });

  $(document).on('click', '#showInputExportCertificate', function () {
    $('#exportCertificateImg').removeClass('hide');
    $(this).addClass('hide');
    $('#startVideoThread').removeClass('hide');
    $('#exportCertificateBox').addClass('hide');
    $('#photoPreview').addClass('hide');
    document.querySelector('#photoPreview').setAttribute('src', '');
  });

  $(document).on('click', '#startVideoThread', function () {
    let videoBoxSelector = '#videoBox',
      canvasBoxSelector = '#canvas',
      imgSelector = '#photoPreview',
      data = null;

    //$("#startVideoThread").parent().addClass("hide");
    $(this).addClass('hide');
    $('#exportCertificateImg').addClass('hide');
    $('#showInputExportCertificate').removeClass('hide');
    $('#naviscarform-exportcertificateimg')[0].value = '';

    startVideoThread(videoBoxSelector)
      .then(function (videoObject) {
        $('#exportCertificateBox').removeClass('hide');
        document.getElementById('takeSnippet').addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            data = takeSnippetVideo(videoObject, canvasBoxSelector);
            if (data) {
              document.querySelector(imgSelector).setAttribute('src', data);
              $('#photoPreview').removeClass('hide');
            } else {
              alert(
                'Произошла ошибка при попытке сделать снимок, попробуйте прикрепить файл вручную'
              );
              $('#exportCertificateImg').removeClass('hide');
            }
          },
          false
        );
      })
      .catch(function (err) {
        let userMsg = 'Неизвестная ошибка';
        switch (err) {
          case 'HTMLMedia​ElementPlayError':
            userMsg =
              'Произошла ошибка при попытке воспроизведения.\n' +
              'Проверьте выходной формат оборудования';
            break;
          case 'getUserMediaError':
            userMsg =
              'Произошла ошибка при попытке получить медиа от пользователя.\n' +
              'Проверьте доступ к оборудованию и убедитесь в его работоспособности';
            break;
          case 'NotSupportBrowserError':
            userMsg = 'Данный браузер не поддерживает интеграцию веб-камеры';
            break;
          default:
            userMsg = 'Неизвестная ошибка';
            break;
        }
        alert(userMsg);
        $('#exportCertificateImg').removeClass('hide');
      });
  });

  $(document).on('click', '#submitNavisCar', function (e) {
    e.preventDefault();
    let data = $('#photoPreview').attr('src'),
      formId = $(this).data('form_id'),
      $form = $('#' + formId);

    if (data) {
      $('#exportCertificateImg').append(
        "<input type='hidden' name='exportCertificateBase64' value='" +
        data +
        "'>"
      );
    }
    $form.submit();
  });

  $(document).on(
    'click',
    "#modal-feedback button[type='submit']",
    function (e) {
      e.preventDefault();
      if ($('#user_files').prop('files').length > 3) {
        alert('No more than 3 files');
      } else {
        $('form#feedback-form').submit();
      }
    }
  );

  $(document).on('click', '#change_object_type_apply_button', function () {
    let objectId = $('#objectId').val(),
      typeId = $('#objectTypeId').val();

    $.post({
      cache: false,
      url: '/data/change-type-object',
      data: { objectId: objectId, typeId: typeId },
    })
      .done(function (response) {
        switch (response['status']) {
          case 'success':
            location.reload();
            break;
          case 'fail':
            alert('Произошла ошибка. \nОтвет сервера: ' + response['msg']);
            break;
          default:
            alert('Неизвестная ошибка');
            break;
        }
      })
      .fail(function (jqXHR) {
        alert(
          'Произошла ошибка при попытке запроса к Cartrack\n' +
          'Статус: ' +
          jqXHR['statusText'] +
          '\n' +
          'Код статуса: ' +
          jqXHR['status'] +
          '\n' +
          'Ответ сервера: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      });
  });

  $(document).on('click', '.openModalAddCarrierComment', function () {
    let numberDeliveryRequest = $(this).data('number_delivery_request'),
      objectName = $(this).data('object_name'),
      objectNumber = $(this).data('object_number'),
      lot = $(this).data('lot'),
      from = $(this).data('from'),
      to = $(this).data('to'),
      price = $(this).data('price'),
      carrierComment = $(this).data('carrier_comment'),
      modalSelector = 'div#modal_add_carrier_comment';

    $(modalSelector + ' #number_delivery_request').text(numberDeliveryRequest);
    $(modalSelector + ' #car_name').text(objectName);
    $(modalSelector + ' #vin').text(objectNumber);
    $(modalSelector + ' #lot').text(lot);
    $(modalSelector + ' #from').text(from);
    $(modalSelector + ' #to').text(to);
    $(modalSelector + ' #price').text(price);
    $(modalSelector + ' #carrier_comment').text(carrierComment);

    $(modalSelector).modal('show');
  });

  $(document).on('click', '#add_carrier_comment_success_button', function () {
    let modalSelector = 'div#modal_add_carrier_comment',
      requestNumber = $(modalSelector + ' #number_delivery_request').text(),
      carrierComment = $(modalSelector + ' #carrier_comment_new').val(),
      data = { requestNumber: requestNumber, carrierComment: carrierComment },
      successAction = (response) => {
        location.reload();
      },
      failAction = (response) => {
        alert('Error. Server response: \n' + response['msg']);
      },
      defaultAction = (response) => {
        alert('Unknown error');
      },
      failAjaxAction = (jqXHR) => {
        let serverResponse = '';
        if (typeof jqXHR['responseJSON'] !== 'undefined') {
          serverResponse = jqXHR['responseJSON']['name'];
        }
        alert(
          'Cartrack unavailable\n' +
          'Status: ' +
          jqXHR['statusText'] +
          '\n' +
          'Status code: ' +
          jqXHR['status'] +
          '\n' +
          'Server response: ' +
          serverResponse +
          '\n'
        );
      };

    if (isValidValue(carrierComment)) {
      defaultAjaxRequest(
        'post',
        '/outer-carrier/add-carrier-comment-request',
        data,
        false,
        successAction,
        failAction,
        defaultAction,
        failAjaxAction
      );
    } else {
      alert('Comment cannot be blank');
    }
  });

  $(document).on('click', '#openModalAddRouteCarrier', function () {
    let sourceId = $('#source_id').val(),
      destinationId = $('#destination_id').val();

    if (!isValidValue(sourceId) || !isValidValue(destinationId)) {
      sourceId = $(this).data('source_id');
      destinationId = $(this).data('destination_id');
      $('#source_id').val(sourceId);
      $('#destination_id').val(destinationId);
    }

    stylingEmptyInput([
      'carrier_id',
      'client_price_value',
      'delivery_price_value',
      'client_price_value_not_drivable',
      'delivery_price_value_not_drivable',
    ]);

    $('#carrier_id').val('').trigger('change');
    $('#client_price_value').val('');
    $('#delivery_price_value').val('');
    $('#client_price_value_not_drivable').val('');
    $('#delivery_price_value_not_drivable').val('');

    $('#modal_add_route_carrier').modal('show');
  });

  $(document).on('click', '#add_route_carrier_success_btn', function () {
    let carrierId = $('#carrier_id').val(),
      sourceId = $('#source_id').val(),
      destinationId = $('#destination_id').val(),
      ownerOrganizationId = $('#ownerOrganizationId').val(),
      clientPriceValue = $('#client_price_value').val(),
      deliveryPriceValue = $('#delivery_price_value').val(),
      clientPriceValueNotDrivable = $('#client_price_value_not_drivable').val(),
      deliveryPriceValueNotDrivable = $(
        '#delivery_price_value_not_drivable'
      ).val(),
      data = {
        carrierId: carrierId,
        sourceId: sourceId,
        destinationId: destinationId,
        clientPriceValue: clientPriceValue,
        deliveryPriceValue: deliveryPriceValue,
        clientPriceValueNotDrivable: clientPriceValueNotDrivable,
        deliveryPriceValueNotDrivable: deliveryPriceValueNotDrivable,
        ownerOrganizationId: ownerOrganizationId,
      };

    if (
      !isValidValue(sourceId) ||
      !isValidValue(destinationId) ||
      !isValidValue(ownerOrganizationId)
    ) {
      alert(
        'Системный параметр не установлен. Попробуйте обновить страницу или обратитесь к администратору'
      );
      return;
    }

    if (
      isValidValue(carrierId) &&
      isValidValue(sourceId) &&
      isValidValue(destinationId) &&
      isValidValue(clientPriceValue) &&
      isValidValue(deliveryPriceValue) &&
      isValidValue(clientPriceValueNotDrivable) &&
      isValidValue(deliveryPriceValueNotDrivable)
    ) {
      defaultAjaxRequest('post', '/data/add-route-to-carrier', data);
    } else if (isValidValue(sourceId) && isValidValue(destinationId)) {
      alert('Проверьте правильность заполнения всех требуемых полей');
    }
  });

  $(document).on('click', '#object_complete_change', function () {
    let objectId = $('#objectId').val(),
      isCompleted = $(this).data('is_completed'),
      newIsCompletedValue = null,
      data = { objectId: objectId };

    if (isCompleted == 1) {
      newIsCompletedValue = 0;
    } else if (isCompleted == 0) {
      newIsCompletedValue = 1;
    } else {
      alert('Ошибка. Неверный параметр isComplete');
    }

    if (isValidValue(newIsCompletedValue)) {
      data['newIsCompletedValue'] = newIsCompletedValue;
      defaultAjaxRequest('post', '/data/object-complete-change', data);
    }
  });

  $(document).on('click', '#log_events_list_header', function () {
    let objectId = $('#objectId').val(),
      successAction = (response) => {
        let targetContainerSelector = '#log_events_list_data',
          html = '';
        $.each(response['data'], function (index, value) {
          let userNameText =
            "<a href='/director/member?id=" +
            value['userId'] +
            "' target='_blank>'>" +
            value['userName'] +
            '</a>';

          if (value['additionalUserName']) {
            userNameText = value['additionalUserName'];
          }

          html +=
            "<div class='col-md-12 px-0 middle-line-h border-b-1solid'>" +
            "<div class='col-md-2'>" +
            value['date'] +
            '</div>' +
            "<div class='col-md-2'>" +
            userNameText +
            '</div>' +
            "<div class='col-md-4'>" +
            value['title'] +
            '</div>' +
            "<div class='col-md-4'>" +
            value['description'] +
            '</div>' +
            "<div class='clearfix'></div>" +
            '</div>';
        });
        $(targetContainerSelector).html(html);
        $('#log_events_list').toggle();
      };

    if ($('#log_events_list_data').html() == '') {
      defaultAjaxRequest(
        'get',
        '/data/get-object-log-events',
        { objectId: objectId },
        false,
        successAction
      );
    } else {
      $('#log_events_list').toggle();
    }
  });

  if (
    location.pathname === '/driver/' ||
    location.pathname === '/driver' ||
    location.pathname.indexOf('/driver/index') !== -1
  ) {
    let timerId = setTimeout(function updateCountCars() {
      defaultAjaxRequest('get', '/data/get-count-delivery-cars', {}, true)
        .then(function (response) {
          let receivedData = {};
          switch (response['status']) {
            case 'success':
              if (typeof response['data'] !== 'undefined') {
                receivedData = response['data'];
              } else {
                alert('Data not found');
              }
              $('#count_cars_stock_to_port').text(
                receivedData['countDeliveryCarsStockToPort']
              );
              $('#count_cars_stock_to_auction').text(
                receivedData['countDeliveryCarsStockToAuction']
              );
              $('#count_cars_stock_to_disassemble').text(
                receivedData['countDeliveryCarsStocksToDisassemble']
              );
              $('#count_cars_port_to_stock').text(
                receivedData['countDeliveryCarsReturnFromPortToStock']
              );
              $('#count_cars_stock_to_stock').text(
                receivedData['countDeliveryCarsFromStockToStock']
              );
              $('#count_cars_auction_to_stocks_TRUCK_DELIVERY').text(
                receivedData['countDeliveryCarsAuctionToStocksTRUCK_DELIVERY']
              );
              $('#count_cars_auction_to_stocks_ECL_GROUP').text(
                receivedData['countDeliveryCarsAuctionToStocksECL_GROUP']
              );
              $('#count_cars_auction_to_stocks_KYUSHU').text(
                receivedData['countDeliveryCarsAuctionToStocksKYUSHU']
              );
              $('#count_cars_auction_to_stocks_KANEKO_TEAM').text(
                receivedData['countDeliveryCarsAuctionToStocksKANEKO_TEAM']
              );
              break;
            case 'fail':
              alert(
                'Update count cars fail. \nServer response: ' + response['msg']
              );
              break;
            default:
              alert('Unknown error');
              break;
          }
        })
        .catch(function (jqXHR) {
          alert(
            'Cartrack unavailable\n' +
            'Status: ' +
            jqXHR['statusText'] +
            '\n' +
            'Status code: ' +
            jqXHR['status'] +
            '\n' +
            'Server response: ' +
            jqXHR['responseJSON']['name'] +
            '\n'
          );
        });
      timerId = setTimeout(updateCountCars, 60000);
    }, 60000);
  }

  $(document).on('click', '#watchdetailform-is_broken', function () {
    let $commentBlock = $('#watchdetailform-comment');

    addCommentBroken($(this)[0], $commentBlock);
  });

  $(document).on('click', '.hide_show_trip', function () {
    let tripId = $(this).data('trip_id'),
      tripName = $(this).data('trip_name'),
      newIsHidden = Number($(this).data('new_is_hidden')),
      isConfirm = false,
      data = { tripId: tripId, isHidden: newIsHidden };

    if (newIsHidden === 1) {
      isConfirm = confirm(
        'Вы уверены, что хотите скрыть рейс ' + tripName + '?'
      );
    } else if (newIsHidden === 0) {
      isConfirm = confirm(
        'Вы уверены, что хотите отобразить рейс ' + tripName + '?'
      );
    }

    if (isConfirm) {
      defaultAjaxRequest('post', '/navis-schedule/set-trip-hidden', data, true)
        .then(function (response) {
          location.reload();
        })
        .catch(function (jqXHR) {
          let serverResponse = '';
          if (typeof jqXHR['responseJSON'] !== 'undefined') {
            serverResponse = jqXHR['responseJSON']['name'];
          }
          alert(
            'Произошла ошибка при попытке запроса к Cartrack\n' +
            'Статус: ' +
            jqXHR['statusText'] +
            '\n' +
            'Код статуса: ' +
            jqXHR['status'] +
            '\n' +
            'Ответ сервера: ' +
            serverResponse +
            '\n'
          );
        });
    }
  });

  $(document).on('click', '.hide_show_plan', function () {
    let planId = $(this).data('plan_id'),
      planName = $(this).data('plan_name'),
      newIsHidden = Number($(this).data('new_is_hidden')),
      isConfirm = false,
      data = { planId: planId, isHidden: newIsHidden };

    if (newIsHidden === 1) {
      isConfirm = confirm(
        'Вы уверены, что хотите скрыть план ' + planName + '?'
      );
    } else if (newIsHidden === 0) {
      isConfirm = confirm(
        'Вы уверены, что хотите отобразить план ' + planName + '?'
      );
    }

    if (isConfirm) {
      defaultAjaxRequest('post', '/navis-schedule/set-plan-hidden', data, true)
        .then(function (response) {
          location.reload();
        })
        .catch(function (jqXHR) {
          let serverResponse = '';
          if (typeof jqXHR['responseJSON'] !== 'undefined') {
            serverResponse = jqXHR['responseJSON']['name'];
          }
          alert(
            'Произошла ошибка при попытке запроса к Cartrack\n' +
            'Статус: ' +
            jqXHR['statusText'] +
            '\n' +
            'Код статуса: ' +
            jqXHR['status'] +
            '\n' +
            'Ответ сервера: ' +
            serverResponse +
            '\n'
          );
        });
    }
  });

  $(document).on('click', '.close_trip_js', function (e) {
    e.preventDefault();
    let tripName = $(this).data('trip_name'),
      isConfirm = confirm(
        'Вы уверены, что хотите закрыть рейс ' + tripName + '?'
      ),
      targetUrl = $(this).data('target_url');

    if (isConfirm) {
      location.href = targetUrl;
    }
  });

  $(document).on('click', '.change_pause_play_drive', function (e) {
    e.preventDefault();

    let planName = $(this).data('plan_name'),
      isPaused = Number($(this).data('is_pause')),
      targetUrl = $(this).data('target_url'),
      isConfirm = false,
      data = {};

    if (isPaused === 1) {
      isConfirm = confirm(
        'Вы уверены, что хотите возобновить сгон на ' + planName + '?'
      );
    } else if (isPaused === 0) {
      isConfirm = confirm(
        'Вы уверены, что хотите приостановить сгон на ' + planName + '?'
      );
    }

    if (isConfirm) {
      location.href = targetUrl;
    }
  });

  $(document).on('click', '.vessel_departed', function (e) {
    e.preventDefault();

    let planName = $(this).data('plan_name'),
      targetUrl = $(this).data('target_url'),
      isConfirm = confirm(
        'Вы уверены, что хотите поставить отметку, о том что судно вышло из ' +
        planName +
        '?'
      );

    if (isConfirm) {
      location.href = targetUrl;
    }
  });

  $(document).on('change', '#navistripform-dateto', function () {
    let $dateTo = $('#navistripform-dateto'),
      $shipUnloadingFrom = $('#navistripform-shipunloadingfrom'),
      $shipUnloadingTo = $('#navistripform-shipunloadingto'),
      dateToValue = $dateTo.val(),
      shipUnloadingFromValue = $shipUnloadingFrom.val(),
      shipUnloadingToValue = $shipUnloadingTo.val(),
      deltaDaysShipUnloading = getDaysBetweenDates(
        shipUnloadingFromValue,
        shipUnloadingToValue
      );

    $shipUnloadingFrom.val(dateToValue);
    $shipUnloadingFrom.flatpickr({
      allowInput: false,
      dateFormat: 'Y-m-d',
      locale: 'ru',
      time_24hr: true,
      enableTime: false,
      defaultDate: dateToValue,
    });

    if (isValidValue(deltaDaysShipUnloading)) {
      let newShipUnloadingToValueDate = new Date(dateToValue),
        newShipUnloadingToValue = '';

      newShipUnloadingToValueDate.setDate(
        newShipUnloadingToValueDate.getDate() + deltaDaysShipUnloading
      );
      newShipUnloadingToValue =
        newShipUnloadingToValueDate.getFullYear() +
        '-' +
        ('0' + (newShipUnloadingToValueDate.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + newShipUnloadingToValueDate.getDate()).slice(-2);

      $shipUnloadingTo.val(newShipUnloadingToValue);

      $shipUnloadingTo.flatpickr({
        allowInput: false,
        dateFormat: 'Y-m-d',
        locale: 'ru',
        time_24hr: true,
        enableTime: false,
        defaultDate: newShipUnloadingToValue,
      });
    }
  });

  let calendarTripEl = document.getElementById('calendarTrip'),
    calendarTrip = new FullCalendar.Calendar(calendarTripEl, {
      locale: 'ru',
      firstDay: 1,
      weekNumbers: true,
      plugins: ['dayGrid'],
      buttonText: {
        today: 'Сегодня',
        month: 'Месяц',
        week: 'Неделя',
        day: 'День',
        list: 'Список',
      },
      eventRender: function (info) {
        if (typeof info.event.extendedProps.icon !== 'undefined') {
          $(info.el)
            .find('.fc-title')
            .prepend(info.event.extendedProps.icon + ' ');
        }
        if (typeof info.event.extendedProps.iconWarning !== 'undefined') {
          $(info.el)
            .find('.fc-title')
            .prepend(info.event.extendedProps.iconWarning + ' ');
        }
        $(info.el).attr('title', info.event.extendedProps.description);
      },
      dayRender: function (dayRenderInfo) {
        /** 0 - Sunday */
        if (dayRenderInfo.date.getDay() == 0) {
          // if you aren't using ui theme, just remove this line
          $(dayRenderInfo.el).removeClass('ui-widget-content');
          $(dayRenderInfo.el).addClass('holiday-style-cell-fullcalendar');
        }
        $(dayRenderInfo.el)
          .closest('.fc-week')
          .css('border-bottom', '2px solid black');
      },
    }),
    eventsTrip = [];
  $(document).on('click', '.open_dialog_calendar_js', function () {
    let tripId = $(this).data('trip_id'),
      tripName = $(this).data('trip_name'),
      $dialogWindow = $('#dialogWindowCalendar'),
      isClosed = $(this).data('is_closed'),
      data = { tripId: tripId, isClosed: isClosed };

    if (!$dialogWindow.dialog('isOpen')) {
      defaultAjaxRequest(
        'get',
        '/navis-schedule/get-events-by-trip',
        data,
        true
      )
        .then(function (response) {
          $.each(response['data'], function (index, eventProperties) {
            var event = {
              id: eventProperties['id'],
              title: eventProperties['title'],
              start: eventProperties['start'],
              backgroundColor: eventProperties['backgroundColor'],
              borderColor: eventProperties['borderColor'],
              textColor: eventProperties['textColor'],
              editable: eventProperties['editable'],
              allDay: eventProperties['allDay'],
              description: eventProperties['description'],
            };
            if (eventProperties['end'] !== undefined) {
              event.end = eventProperties['end'];
            }
            if (eventProperties['icon'] !== undefined) {
              event.icon = eventProperties['icon'];
            }
            if (eventProperties['iconWarning'] !== undefined) {
              event.iconWarning = eventProperties['iconWarning'];
            }
            if (eventProperties['classNames'] !== undefined) {
              event.classNames = eventProperties['classNames'];
            }
            eventsTrip.push(event);
            calendarTrip.addEvent(event);
          });
          $dialogWindow.dialog('option', 'title', tripName);
          $dialogWindow.dialog('open');
          if (isValidValue(calendarTripEl)) {
            calendarTrip.render();
          }
        })
        .catch(function (jqXHR) {
          let serverResponse = '';
          if (typeof jqXHR['responseJSON'] !== 'undefined') {
            serverResponse = jqXHR['responseJSON']['name'];
          }
          alert(
            'Произошла ошибка при попытке запроса к Cartrack\n' +
            'Статус: ' +
            jqXHR['statusText'] +
            '\n' +
            'Код статуса: ' +
            jqXHR['status'] +
            '\n' +
            'Ответ сервера: ' +
            serverResponse +
            '\n'
          );
        });
    }
  });

  $(document).on('dialogclose', '#dialogWindowCalendar', function () {
    if (isValidValue(calendarTripEl)) {
      $.each(eventsTrip, function (index, event) {
        calendarTrip.getEventById(event.id).remove();
      });
      eventsTrip = [];
    }
  });

  $(document).on('click', '.found_car', function (event) {
    event.preventDefault();
    let deliveryId = $(this).data('delivery_id'),
      isConfirm = confirm('Are you sure?'),
      $this = $(this);

    if (isConfirm) {
      $.post('/driver/found?id=' + deliveryId, function (data) {
        if (data == '1') {
          location.reload();
        }
        if (data == '2') {
          alert('Заявка не найдена');
          $this.hide();
        }
      });
    }
  });

  $(document).on('click', '#move_to_stock_apply_js', function (event) {
    let carId = $('#objectId').val(),
      targetStockId = $('#target-stock').val(),
      targetSectorId = $('#target-sector').val(),
      data = { carId: carId, stockId: targetStockId, sectorId: targetSectorId },
      successAction = (response) => {
        location.reload();
      };

    if (
      typeof targetStockId === 'undefined' ||
      typeof targetSectorId === 'undefined' ||
      targetStockId === 0 ||
      targetSectorId === 0
    ) {
      alert('Не указан склад или сектор');
    } else {
      defaultAjaxRequest(
        'post',
        '/observer/move-to-stock-object-ajax',
        data,
        false,
        successAction
      );
    }
  });

  $(document).on('click', '#move-to-port-apply-button', function (event) {
    event.preventDefault();

    let objectId = $('#objectId').val(),
      planId = $('#planId').val(),
      stockId = $('#portStockId').val(),
      data = { objectId: objectId, planId: planId, stockId: stockId },
      successAction = (response) => {
        location.reload();
      };

    defaultAjaxRequest(
      'post',
      '/watch/move-to-port',
      data,
      false,
      successAction
    );
  });

  $(document).on('click', '#print_qr', function (event) {
    let source = $('#qr_source').attr('src');
    printImage(source, 'landscape');
  });

  $(document).on('click', '.deliver_car', function (event) {
    event.preventDefault();
    let deliveryId = $(this).data('delivery_id'),
      isConfirm = confirm('Are you sure?');

    if (isConfirm) {
      defaultAjaxRequest('get', '/driver/move', { id: deliveryId }, true)
        .then(function (response) {
          if (response == '1') {
            location.reload();
          } else {
            alert('Error. Status code: ' + response);
          }
        })
        .catch(function (jqXHR) {
          let serverResponse = '';
          if (typeof jqXHR['responseJSON'] !== 'undefined') {
            serverResponse = jqXHR['responseJSON']['name'];
          }
          alert(
            'Exception error\n' +
            'Status: ' +
            jqXHR['statusText'] +
            '\n' +
            'Status code: ' +
            jqXHR['status'] +
            '\n' +
            'Server response: ' +
            serverResponse +
            '\n'
          );
        });
    }
  });

  $(document).on(
    'click',
    '#modal_change_vin #change_vin_apply_button',
    function (event) {
      event.preventDefault();
      let modalId = '#modal_change_vin',
        objectId = $('#objectId').val(),
        newVin = $(modalId + ' #new_vin').val();

      if (isValidValue(newVin)) {
        let isConfirm = confirm(
          'Вы уверены, что хотите сменить номер кузова на ' + newVin + '?'
        );
        if (isConfirm) {
          changeObjectVin(objectId, newVin);
        }
      } else {
        alert('Новый номер кузова не указан');
      }
    }
  );

  $(document).on(
    'click',
    '#create_invoice_japan_auction_purchase',
    function (event) {
      let objectId = Number($('#objectId').val());

      if (
        confirm('Вы уверены, что хотите создать инвойс за покупку на аукционе?')
      ) {
        createInvoiceJapanAuctionPurchase(objectId);
      }
    }
  );
});

$(document).on('keydown', (e) => {
  if (e.key === 'Escape') {
    if (
      window.location.pathname === '/navis/car' &&
      !window.location.search.includes('id=')
    ) {
      $('#naviscarform-vin').val(LAST_CAR.vin);
      $('#naviscarform-sender').val(LAST_CAR.sender).trigger('change');
      $('#naviscarform-type').val(LAST_CAR.type);
      $('#naviscarform-maker').val(LAST_CAR.maker);
      setTimeout(() => {
        $('#naviscarform-mark').val(LAST_CAR.mark);
      }, 100);
      $('#naviscarform-chassis').val(LAST_CAR.chassis);
      $('#naviscarform-engine').val(LAST_CAR.engine);
      $('#naviscarform-year').val(LAST_CAR.year);
      $('#naviscarform-saw').val(LAST_CAR.saw);
      $('#naviscarform-owner').val(LAST_CAR.owner.toUpperCase());
      $('#naviscarform-comment').val(LAST_CAR.comment);
      $('#naviscarform-weight').val(LAST_CAR.weight);
      $('#naviscarform-length').val(LAST_CAR.length);
    }
    if (
      window.location.pathname === '/navis/parts' &&
      !window.location.search.includes('id=')
    ) {
      $('#navispartsform-sender').val(LAST_PART.sender.toUpperCase());
      $('#navispartsform-type').val(LAST_PART.type);
      $('#navispartsform-count').val(LAST_PART.count);
      $('#navispartsform-name').val(LAST_PART.name);
      $('#navispartsform-owner').val(LAST_PART.owner.toUpperCase());
      $('#navispartsform-comment').val(LAST_PART.comment);
      $('#navispartsform-weight').val(LAST_PART.weight);
      $('#navispartsform-length').val(LAST_PART.length);
    }
    if (
      window.location.pathname === '/navis/aggregate' &&
      !window.location.search.includes('id=')
    ) {
      $('#navisaggregateform-sender').val(LAST_AGGREGATE.sender.toUpperCase());
      $('#navisaggregateform-type').val(LAST_AGGREGATE.type);
      $('#navisaggregateform-owner').val(LAST_AGGREGATE.owner.toUpperCase());
      $('#navisaggregateform-comment').val(LAST_AGGREGATE.comment);
      $('#navisaggregateform-maker')
        .val(LAST_AGGREGATE.maker)
        .trigger('change');
      setTimeout(() => {
        $('#navisaggregateform-mark')
          .val(LAST_AGGREGATE.mark)
          .trigger('change');
      }, 100);
      $('#navisaggregateform-weight').val(LAST_AGGREGATE.weight);
      $('#navisaggregateform-length').val(LAST_AGGREGATE.length);
    }
  }
});

let editReason = () => {
  let vin = '',
    reason = '';

  reason = prompt('Укажите причину');
  vin = $('#noPhotoViewed').attr('vin');
  if (typeof vin != 'undefined') {
    $.ajax({
      method: 'post',
      cache: false,
      url: '/observer/photo?v=' + vin,
      data: { reason: reason },
    })
      .done(function (data) {
        if (data == 'hide') {
          $('#noPhotoViewed').css('visibility', 'visible');
          $('#statusMediaAccessAndReason').text(
            'Фото и видео запрещены к показу. Причина: ' + reason
          );
          $('#mediaLink').css('visibility', 'hidden');
          $('#objectVisiblePhotoLink').text('Разрешить показ фото и видео');
        } else {
          $('#noPhotoViewed').css('visibility', 'hidden');
          $('#mediaLink').css('visibility', 'visible');
          $('#objectVisiblePhotoLink').text('Запретить показ фото и видео');
        }
      })
      .fail(function (jqXHR) {
        alert(
          'Произошла ошибка при попытке запроса к Cartrack\n' +
          'Статус: ' +
          jqXHR['statusText'] +
          '\n' +
          'Код статуса: ' +
          jqXHR['status'] +
          '\n' +
          'Ответ сервера: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      });
  } else {
    alert('Не верная строка поиска!');
  }
};

let moveMedia = () => {
  let currentId = $('#currentId').val(),
    targetVin = $('#observerobjectmovemediaform-targetvin').val();
  $.ajax({
    method: 'post',
    cache: false,
    url: '/observer/move-object-data',
    data: { currentId: currentId, targetVin: targetVin },
  })
    .done(function (data) {
      data = JSON.parse(data);
      switch (data['status']) {
        case 'success':
          break;
        case 'incorrect':
          alert('Некорректный номер кузова');
          break;
        case 'fail':
          alert('Ошибка при переносе данных\n' + data['msg']);
          break;
      }
    })
    .fail(function (jqXHR) {
      alert(
        'Ошибка при переносе данных\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
  $('#move-object-data-close-button').trigger('click');
};

//----------BEGIN-Reminders------------------
let addUserReminder = () => {
  let username = $('#reminderaddform-selectedusers option:selected').text(),
    html = $('#addedUsersList').html(),
    userId = $('#reminderaddform-selectedusers option:selected').val(),
    reminderId = $('#reminder-id').val();

  html +=
    '<div class="col-lg-10">' +
    '<li id="' +
    userId +
    '">' +
    username +
    '</li>' +
    '</div>' +
    '<div class="col-lg-2">' +
    '<a href="javascript: void(0)" class="remove-user">Удалить</a>' +
    '</div>' +
    '<div class="clearfix"></div><hr>';
  $('#addedUsersList').html(html);

  $.post({
    cache: false,
    url: '/director/add-user-reminder-ajax',
    data: { reminderId: reminderId, userId: userId },
  })
    .done(function (data) {
      data = JSON.parse(data);
      switch (data['status']) {
        case 'success':
          break;
        case 'fail':
          alert('Ошибка. Напоминание не было найдено');
          break;
      }
    })
    .fail(function (jqXHR) {
      alert(
        'Произошла ошибка при попытке запроса к Cartrack\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
  $('.remove-user').click(function () {
    removeUserFromListReminder(this);
  });
};

let removeUserFromListReminder = (elem) => {
  let userId = $(elem).parent().prev().children().attr('id'),
    reminderId = $('#reminder-id').val();

  $(elem).parent().prev().remove();
  $(elem).parent().next().next().remove();
  $(elem).parent().next().remove();
  $(elem).parent().remove();

  $.post({
    cache: false,
    url: '/director/delete-user-reminder-ajax',
    data: { reminderId: reminderId, userId: userId },
  })
    .done(function (data) {
      data = JSON.parse(data);
      switch (data['status']) {
        case 'success':
          break;
        case 'fail':
          alert('Неизвестная ошибка при удалении пользователя');
          break;
      }
    })
    .fail(function (jqXHR) {
      alert(
        'Произошла ошибка при попытке запроса к Cartrack\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};
//----------END-Reminders------------------

let openModalWriteOff = (elem) => {
  let nameObject = $(elem).attr('data-name-object'),
    trackObject = $(elem).attr('data-track-object'),
    objectId = $(elem).attr('data-object-id');

  $('.name-object').text(nameObject);
  $('.track-object').text(trackObject);
  $('#object-id').val(objectId);
  $('#modal-write-off').modal('show');
};

let writeOffObject = () => {
  let id = $('#object-id').val(),
    reason = $('#reason').val(),
    inventoryId = $('#inventory-id').val();

  if (reason == '') {
    $('#require').css({ color: 'red' });
  } else {
    $.post({
      cache: false,
      url: '/observer/write-off-object-ajax',
      data: { id: id, reason: reason, inventoryId: inventoryId },
    })
      .done(function (data) {
        switch (data['status']) {
          case 'success':
            location.reload();
            break;
          case 'fail':
            alert(
              'Ошибка при попытке списать объект\n Ответ сервера: ' +
              data['msg']
            );
            break;
        }
      })
      .fail(function (jqXHR) {
        alert(
          'Произошла ошибка при попытке запроса к Cartrack\n' +
          'Статус: ' +
          jqXHR['statusText'] +
          '\n' +
          'Код статуса: ' +
          jqXHR['status'] +
          '\n' +
          'Ответ сервера: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      });
  }
};

let openModalComment = (elem) => {
  let nameObject = $(elem).attr('data-name-object'),
    trackObject = $(elem).attr('data-track-object'),
    objectId = $(elem).attr('data-object-id');

  $('.name-object').text(nameObject);
  $('.track-object').text(trackObject);
  $('#object-id').val(objectId);
  $('#modal-write-comment').modal('show');
};

let commentObject = () => {
  let id = $('#object-id').val(),
    reason = $('#comment').val(),
    inventoryId = $('#inventory-id').val();

  if (reason == '') {
    $('#require-comment').css({ color: 'red' });
  } else {
    $.post({
      cache: false,
      url: '/observer/comment-object-ajax',
      data: { id: id, reason: reason, inventoryId: inventoryId },
    })
      .done(function (data) {
        data = JSON.parse(data);
        switch (data['status']) {
          case 'success':
            location.reload();
            break;
          case 'fail':
            alert(
              'Ошибка при попытке прокмментировать объект\n Ответ сервера: ' +
              data['msg']
            );
            break;
        }
      })
      .fail(function (jqXHR) {
        alert(
          'Произошла ошибка при попытке запроса к Cartrack\n' +
          'Статус: ' +
          jqXHR['statusText'] +
          '\n' +
          'Код статуса: ' +
          jqXHR['status'] +
          '\n' +
          'Ответ сервера: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      });
  }
};

let openModalAkebonoComment = (elem) => {
  let nameObject = $(elem).attr('data-name-object'),
    phoneObject = $(elem).attr('data-phone-object'),
    emailObject = $(elem).attr('data-email-object'),
    skypeObject = $(elem).attr('data-skype-object'),
    statusObject = $(elem).attr('data-status-object'),
    objectId = $(elem).attr('data-object-id');

  $('.name-object').text(nameObject);
  $('.phone-object').text(phoneObject);
  $('.email-object').text(emailObject);
  $('.skype-object').text(skypeObject);
  $('.status-object').text(statusObject);
  $('#object-id').val(objectId);
  if (statusObject == 'Не обработан') {
    $('.status-object').css({ color: 'red' });
  }
  $('#modal-akebono-comment').modal('show');
};

let commentAkebonoObject = () => {
  let id = $('#object-id').val(),
    reason = $('#akebono-comment').val(),
    status = $('#akebono-status').val(),
    city = $('#akebono-city').val();

  if (reason == '') {
    $('.require-akebono-comment').css({ color: 'red' });
  } else {
    $.post({
      cache: false,
      url: '/akebono/comment-akebono-user-ajax',
      data: { id: id, reason: reason, status: status, city: city },
    })
      .done(function (data) {
        data = JSON.parse(data);
        switch (data['status']) {
          case 'success':
            location.reload();
            break;
          case 'fail':
            alert(
              'Ошибка при попытке обработать пользователя\n Ответ сервера: ' +
              data['msg']
            );
            break;
        }
      })
      .fail(function (jqXHR) {
        alert(
          'Произошла ошибка при попытке запроса к Cartrack\n' +
          'Статус: ' +
          jqXHR['statusText'] +
          '\n' +
          'Код статуса: ' +
          jqXHR['status'] +
          '\n' +
          'Ответ сервера: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      });
  }
};

let moveObjectToStock = (carId, targetStockId, targetSectorId, targetCountryId) => {
  if (
    typeof targetStockId === 'undefined' ||
    typeof targetSectorId === 'undefined' ||
    targetStockId === 0 ||
    targetSectorId === 0
  ) {
    alert('Не указан склад или сектор');
  } else {
    $.post({
      cache: false,
      url: '/observer/move-to-stock-object-ajax',
      data: { carId: carId, countryId: targetCountryId, stockId: targetStockId, sectorId: targetSectorId },
    })
      .done(function (data) {
        switch (data['status']) {
          case 'success':
            location.reload();
            break;
          case 'fail':
            alert(
              'Ошибка при переносе объекта.\n Ответ сервера: ' + data['msg']
            );
            break;
        }
      })
      .fail(function (jqXHR) {
        alert(
          'Произошла ошибка при попытке запроса к Cartrack\n' +
          'Статус: ' +
          jqXHR['statusText'] +
          '\n' +
          'Код статуса: ' +
          jqXHR['status'] +
          '\n' +
          'Ответ сервера: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      });
    $('#move-to-stock-close-button').trigger('click');
  }
};

let sortTableBackend = (e) => {
  e.preventDefault();
  e.stopPropagation();

  let sort = $(e.currentTarget).data('sort'),
    order = $(e.currentTarget).data('order');

  if (isDefined(order) && isDefined(sort)) {
    let qs = getQueryParams();
    qs.sort = sort;
    qs.order = order ? 0 : 1;
    Spinner.show();
    location.assign(location.origin + location.pathname + `?${$.param(qs)}`);
  }
};

let changeDriveTo = () => {
  let newDateTimeDriveTo = $('#new-drive-to').val(),
    newDateTimeDriveFrom = $('#new-drive-from').val(),
    planId = $('#planId').val();

  $.post({
    cache: false,
    url: '/observer/change-drive-to-ajax',
    data: {
      newDateTimeDriveTo: newDateTimeDriveTo,
      newDateTimeDriveFrom: newDateTimeDriveFrom,
      planId: planId,
    },
  })
    .done(function (data) {
      switch (data['status']) {
        case 'success':
          location.reload();
          break;
        case 'fail':
          alert(
            'Произошла ошибка при попытке изменения времени сгона.\n Ответ сервера: ' +
            data['msg']
          );
          break;
      }
    })
    .fail(function (jqXHR) {
      alert(
        'Произошла ошибка при попытке запроса к Cartrack\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let openModalSolveProblem = (elem) => {
  let problemId = $(elem).attr('data-problem-id'),
    titleProblem = $(elem).attr('data-title-problem'),
    messageProblem = $(elem).attr('data-msg-problem');

  $('#problem-id').val(problemId);
  $('#title-problem').text(titleProblem);
  $('#msg-problem').text(messageProblem);
  $('#modal-solve-problem').modal('show');
};

let solveProblem = () => {
  let actions = $('#actions').val(),
    problemId = $('#problem-id').val();

  if (actions === '') {
    $('div#actions-div').addClass('has-error');
    $('div#actions-div span.help-block').removeClass('hide');
  } else {
    $.post({
      cache: false,
      url: '/observer/solve-problem-ajax',
      data: { problemId: problemId, actions: actions },
    })
      .done(function (data) {
        switch (data['status']) {
          case 'success':
            location.reload();
            break;
          case 'fail':
            alert('Ошибка при принятии мер.\n Ответ сервера: ' + data['msg']);
            break;
        }
      })
      .fail(function (jqXHR) {
        alert(
          'Произошла ошибка при попытке запроса к Cartrack\n' +
          'Статус: ' +
          jqXHR['statusText'] +
          '\n' +
          'Код статуса: ' +
          jqXHR['status'] +
          '\n' +
          'Ответ сервера: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      });
  }
};

let openModalIssueObject = (elem) => {
  let objectId = $(elem).attr('data-object-id'),
    mark = $(elem).attr('data-mark'),
    maker = $(elem).attr('data-maker'),
    vin = $(elem).attr('data-vin');

  $('#objectId').val(objectId);
  $('#object-name').text(maker + ' ' + mark);
  $('#vin').text(vin);
  $.get({
    cache: false,
    url: '/exchange/is-car-finance-clear',
    data: { objectId: objectId },
  })
    .done(function (response) {
      console.log(response);
      switch (response['status']) {
        case 'success':
          if (response['data']['isFinanceClear'] === true) {
            $('#msgFinanceBlock').hide();
            $('#issue-object-success-button').prop('disabled', false);
          } else if (response['data']['isFinanceClear'] === false) {
            $('#msgFinanceBlock').show();
            $('#issue-object-success-button').prop('disabled', true);
          }
          break;
        case 'fail':
          alert(
            'Произошла ошибка при попытке получить информацию о финансовой задолженности. \n Ответ сервера: ' +
            response['msg']
          );
          break;
        default:
          alert('Неизвестная ошибка');
          break;
      }
    })
    .fail(function (jqXHR) {
      alert(
        'Произошла ошибка при попытке запроса к Cartrack\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });

  $('#modal-issue-object').modal('show');
};

let createRequestToIssueObject = (lang) => {
  let objectId = $('#objectId').val(),
    plannedAt = $('#plannedAt').val(),
    vin = $('#vin-issue-object').val(),
    comment = $('#comment-issue-object').val();

  if (vin === '') {
    $('div#modal-create-request-issue-object div#vin-div').addClass(
      'has-error'
    );
    $(
      'div#modal-create-request-issue-object div#vin-div span.help-block'
    ).removeClass('hide');
  } else if (plannedAt === '') {
    console.log(new Date($.now()));
    $('div#modal-create-request-issue-object div#planned-date-div').addClass(
      'has-error'
    );
    $(
      'div#modal-create-request-issue-object div#planned-date-div span.help-block'
    ).removeClass('hide');
  } else if (
    // Если есть vin, отправляем vin
    typeof vin !== 'undefined' &&
    vin !== ''
  ) {
    sendRequestToIssueObject(vin, plannedAt, comment, lang, true);
  } else if (
    // Если есть id объекта и нет vin, отправляем id объекта
    typeof objectId !== 'undefined' &&
    objectId !== 0 &&
    (typeof vin === 'undefined' || vin === '')
  ) {
    sendRequestToIssueObject(objectId, plannedAt, comment, lang, false);
  } else {
    if (lang === 'english') {
      alert('Error. Object not found');
    } else {
      alert('Ошибка. Объект не найден');
    }
  }
};

let sendRequestToIssueObject = (
  objectParam,
  plannedAt,
  comment,
  lang,
  isVin
) => {
  let data = {},
    url = '';

  if (lang === 'english') {
    url = '/navis-sender/create-request-issue';
  } else {
    url = '/observer/create-request-issue';
  }
  if (isVin) {
    data = {
      vin: objectParam,
      plannedAt: plannedAt,
      comment: comment,
      language: lang,
    };
  } else {
    data = {
      objectId: objectParam,
      plannedAt: plannedAt,
      comment: comment,
      language: lang,
    };
  }
  $.post({
    cache: false,
    url: url,
    data: data,
  })
    .done(function (data) {
      switch (data['status']) {
        case 'success':
          $('#modal-create-request-issue-object').modal('hide');
          $('div#modal-create-request-issue-object div#vin-div').removeClass(
            'has-error'
          );
          $(
            'div#modal-create-request-issue-object div#vin-div span.help-block'
          ).addClass('hide');
          $(
            'div#modal-create-request-issue-object div#planned-date-div'
          ).removeClass('has-error');
          $(
            'div#modal-create-request-issue-object div#planned-date-div span.help-block'
          ).addClass('hide');
          $('#vin-issue-object').val('');
          $('#plannedAt').val('');
          $('#comment-issue-object').val('');
          break;
        case 'fail':
          if (lang === 'english') {
            alert('Error. Server response: ' + data['msg']);
          } else {
            alert(
              'Произошла ошибка при попытке создать заявку. Ответ сервера: ' +
              data['msg']
            );
          }
          break;
        default:
          if (lang === 'english') {
            alert('Unknown error');
          } else {
            alert('Неизвестная ошибка');
          }
          break;
      }
    })
    .fail(function (jqXHR) {
      if (lang === 'english') {
        alert(
          'Error. Cartrack unavailable\n' +
          'Status: ' +
          jqXHR['statusText'] +
          '\n' +
          'Status code: ' +
          jqXHR['status'] +
          '\n' +
          'Server response: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      } else {
        alert(
          'Произошла ошибка при попытке запроса к Cartrack\n' +
          'Статус: ' +
          jqXHR['statusText'] +
          '\n' +
          'Код статуса: ' +
          jqXHR['status'] +
          '\n' +
          'Ответ сервера: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      }
    });
};

//------------------BEGIN-Статистика склада--------------------------------------------
let createTableExpectedDeliveryAucStatsTable = (idDivTable) => {
  let stockId = $('input#stockId').val();

  $.post({
    cache: false,
    url: '/observer/get-data-table-type-delivery-auc-ajax',
    data: { stockId: stockId },
  })
    .done(function (dataTable) {
      let htmlTable =
        '<table class="table table-striped">' +
        '<thead>' +
        "<tr class='active'>" +
        '<th>Откуда</th>' +
        '<th>Количество</th>' +
        '</tr>' +
        '</thead>' +
        '<tbody>';

      dataTable.forEach(function (row, key, dataTable) {
        htmlTable +=
          '<tr>' +
          '<td>' +
          row['name'] +
          '</td>' +
          '<td>' +
          '<a href="javascript:void(0);"' +
          'class="create-table-expected-delivery-auc-cars"' +
          'data-stock="' +
          stockId +
          '"' +
          'data-source="' +
          row['sourceId'] +
          '"' +
          'data-source-name="' +
          row['name'] +
          '">' +
          row['count'] +
          '</a></td>' +
          '</tr>';
      });
      htmlTable += '</tbody></table>';
      $(idDivTable).html(htmlTable);
      $('.create-table-expected-delivery-auc-cars').click(function () {
        removeSelectionStockStat();
        $(this).parent().addClass('color-selected-cell-table');
        createTableExpectedDeliveryAucCars(this);
      });
    })
    .fail(function (jqXHR) {
      alert(
        'Не удалось получить данные по выбранному фильтру\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let createTableExpectedDeliveryCarrierStatsTable = (idDivTable) => {
  let stockId = $('input#stockId').val();

  $.post({
    cache: false,
    url: '/observer/get-data-table-type-delivery-carrier-ajax',
    data: { stockId: stockId },
  })
    .done(function (dataTable) {
      let htmlTable =
        '<table class="table table-striped">' +
        '<thead>' +
        "<tr class='active'>" +
        '<th>Доставщик</th>' +
        '<th>Количество</th>' +
        '</tr>' +
        '</thead>' +
        '<tbody>';

      dataTable.forEach(function (row, key, dataTable) {
        htmlTable += '<tr>';
        if (row['name'] === false) {
          htmlTable += '<td class="color-red">НЕ НАЗНАЧЕН</td>';
        } else {
          htmlTable +=
            '<td><a href="/logistic/carrier-detail?id=' +
            row['carrierId'] +
            '">' +
            row['name'] +
            '</a></td>';
        }
        htmlTable +=
          '<td>' +
          '<a href="javascript:void(0);"' +
          'class="create-table-expected-delivery-carrier-cars"' +
          'data-stock="' +
          stockId +
          '"' +
          'data-carrier="' +
          row['carrierId'] +
          '"' +
          'data-carrier-name="' +
          row['name'] +
          '">' +
          row['count'] +
          '</a></td>' +
          '</tr>';
      });
      htmlTable += '</tbody></table>';
      $(idDivTable).html(htmlTable);
      $('.create-table-expected-delivery-carrier-cars').click(function () {
        removeSelectionStockStat();
        $(this).parent().addClass('color-selected-cell-table');
        createTableExpectedDeliveryCarrierCars(this);
      });
    })
    .fail(function (jqXHR) {
      alert(
        'Не удалось получить данные по выбранному фильтру\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let createTableExpectedDepartureStatsTypeTripsTable = () => {
  let stockId = $('input#stockId').val();

  $.post({
    cache: false,
    url: '/observer/get-data-table-type-trips-ajax',
    data: { stockId: stockId },
  })
    .done(function (dataTable) {
      let htmlTable =
        '<table class="table table-striped">' +
        '<thead>' +
        "<tr class='active'>" +
        '<th>Рейс</th>' +
        '<th>Сгон до</th>' +
        '<th>Количество</th>' +
        '<th>К вывозу</th>' +
        '</tr>' +
        '</thead>' +
        '<tbody>';

      dataTable.forEach(function (row, key, dataTable) {
        htmlTable += '<tr>';
        htmlTable += '<td>';
        if (row['tripName'] === false) {
          htmlTable += 'Неизвестно</td>';
        } else {
          if (row['planId'] !== false && row['planId'] != 0) {
            htmlTable +=
              '<a href="/observer/cars?id=' +
              row['planId'] +
              '" target="_blank">' +
              row['tripName'] +
              '</a></td>';
          } else {
            htmlTable += row['tripName'] + '</td>';
          }
        }
        htmlTable +=
          '<td>' +
          row['driveTo'] +
          '</td>' +
          '<td>' +
          '<a href="javascript:void(0);"' +
          'class="create-table-expected-departure-trips-cars"' +
          'data-trip-name="' +
          row['tripName'] +
          '"' +
          'data-plan-id="' +
          row['planId'] +
          '">' +
          row['count'] +
          '</a></td>' +
          '<td>' +
          row['notDeparture'] +
          '</td>' +
          '</tr>';
      });
      htmlTable += '</tbody></table>';
      $('#expected-departure-stats-type-trips-table-div').html(htmlTable);
      $('.create-table-expected-departure-trips-cars').click(function () {
        removeSelectionStockStat();
        $(this).parent().addClass('color-selected-cell-table');
        createTableExpectedDepartureCarsTypeTrips(this);
      });
    })
    .fail(function (jqXHR) {
      alert(
        'Не удалось получить данные по выбранному фильтру\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let createTableExpectedDepartureStatsTypeSenderTable = () => {
  let stockId = $('input#stockId').val();

  $.post({
    cache: false,
    url: '/observer/get-data-table-type-sender-ajax',
    data: { stockId: stockId },
  })
    .done(function (dataTable) {
      let htmlTable =
        '<table class="table table-striped">' +
        '<thead>' +
        "<tr class='active'>" +
        '<th>Отправитель</th>' +
        '<th>Количество</th>' +
        '</tr>' +
        '</thead>' +
        '<tbody>';

      dataTable.forEach(function (row, key, dataTable) {
        htmlTable +=
          '<tr>' +
          '<td>' +
          row['name'] +
          '</td>' +
          '<td>' +
          '<a href="javascript:void(0);"' +
          'class="create-table-expected-departure-senders-cars"' +
          'data-sender-name="' +
          row['name'] +
          '"' +
          'data-sender-id="' +
          row['senderId'] +
          '">' +
          row['count'] +
          '</a></td>' +
          '</tr>';
      });
      htmlTable += '</tbody></table>';
      $('#expected-departure-stats-type-sender-table-div').html(htmlTable);
      $('.create-table-expected-departure-senders-cars').click(function () {
        removeSelectionStockStat();
        $(this).parent().addClass('color-selected-cell-table');
        createTableExpectedDepartureCars(this, 'senders');
      });
    })
    .fail(function (jqXHR) {
      alert(
        'Не удалось получить данные по выбранному фильтру\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let createTableExpectedDepartureStatsTypeDateTable = () => {
  let stockId = $('input#stockId').val();

  $.post({
    cache: false,
    url: '/observer/get-data-table-type-date-ajax',
    data: { stockId: stockId },
  })
    .done(function (dataTable) {
      let htmlTable =
        '<table class="table table-striped">' +
        '<thead>' +
        "<tr class='active'>" +
        '<th>Дата</th>' +
        '<th>Количество</th>' +
        '</tr>' +
        '</thead>' +
        '<tbody>';

      dataTable.forEach(function (row, key, dataTable) {
        htmlTable +=
          '<tr>' +
          '<td>' +
          row['dateCustomFormat'] +
          '</td>' +
          '<td>' +
          '<a href="javascript:void(0);"' +
          'class="create-table-expected-departure-date-cars"' +
          'data-date-user="' +
          row['dateCustomFormat'] +
          '"' +
          'data-date="' +
          row['date'] +
          '">' +
          row['count'] +
          '</a></td>' +
          '</tr>';
      });
      htmlTable += '</tbody></table>';
      $('#expected-departure-stats-type-date-table-div').html(htmlTable);
      $('.create-table-expected-departure-date-cars').click(function () {
        removeSelectionStockStat();
        $(this).parent().addClass('color-selected-cell-table');
        createTableExpectedDepartureCars(this, 'dates');
      });
    })
    .fail(function (jqXHR) {
      alert(
        'Не удалось получить данные по выбранному фильтру\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let createTableStockSectorsStatTable = () => {
  let stockId = $('input#stockId').val();

  $.post({
    cache: false,
    url: '/observer/get-data-table-type-sectors-ajax',
    data: { stockId: stockId },
  })
    .done(function (dataTable) {
      let htmlTable =
        '<table id="stock-sectors-stats-table" class="table table-striped">' +
        '<thead>' +
        "<tr class='active'>" +
        '<th></th>' +
        '<th>Всего</th>' +
        '<th>Akebono</th>' +
        '<th>Без владельца</th>' +
        '<th>Пограничных</th>' +
        '<th>Дней на складе</th>' +
        '</tr>' +
        '</thead>' +
        '<tbody>';

      dataTable.forEach(function (row, key, dataTable) {
        htmlTable +=
          '<tr>' +
          '<td>' +
          row['name'] +
          '</td>' +
          '<td>' +
          '<a href="javascript:void(0)"' +
          '   class="create-table-cars-stock"' +
          '   data-stock="' +
          stockId +
          '"' +
          '   data-sector="' +
          row['sectorId'] +
          '">' +
          row['allCount'] +
          '</a></td>' +
          '<td>' +
          row['akebonoCount'] +
          '</td>' +
          '<td>' +
          '<a href="javascript:void(0)"' +
          'class="create-table-cars-stock"' +
          'data-stock="' +
          stockId +
          '"' +
          'data-sector="' +
          row['sectorId'] +
          '"' +
          'data-noOwner="1">' +
          row['noOwnerCount'] +
          '</a></td>' +
          '<td>' +
          '<a href="javascript:void(0)"' +
          '   class="create-table-cars-stock"' +
          '   data-stock="' +
          stockId +
          '"' +
          '   data-sector="' +
          row['sectorId'] +
          '"' +
          '   data-is-boundary="1">' +
          row['boundary'] +
          '</a></td>' +
          '<td>' +
          '<span title="Средний">' +
          row['averageDaysStorage'] +
          '</span>' +
          ' / ' +
          '<span title="Максимальный">' +
          row['maxDaysStorage'] +
          '</span></td>' +
          '</tr>';
      });
      htmlTable += '</tbody></table>';
      $('#stock-sectors-stats-table-div').html(htmlTable);
      $('.create-table-cars-stock').click(function () {
        removeSelectionStockStat();
        $(this).parent().addClass('color-selected-cell-table');
        let sectorId = $(this).attr('data-sector'),
          isBoundary = $(this).attr('data-is-boundary'),
          isNoOwner = $(this).attr('data-noOwner');
        if (typeof sectorId !== 'undefined')
          $('#getDataTableTypeSectorsBtn').attr('data-sector', sectorId);
        if (typeof isBoundary !== 'undefined')
          $('#getDataTableTypeSectorsBtn').attr('data-boundary', isBoundary);
        if (typeof isNoOwner !== 'undefined')
          $('#getDataTableTypeSectorsBtn').attr('data-noOwner', isNoOwner);

        createTableCarsStock(sectorId, null, isBoundary, null, isNoOwner);
      });
    })
    .fail(function (jqXHR) {
      alert(
        'Не удалось получить данные по выбранному фильтру\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let createTableExpectedDeliveryAucCars = (elem) => {
  let stockId = $(elem).attr('data-stock'),
    sourceId = $(elem).attr('data-source'),
    sourceName = $(elem).attr('data-source-name'),
    title = '';

  $('#table-cars-container').html('');
  if (typeof stockId === 'undefined') stockId = '';
  if (typeof sourceId === 'undefined') sourceId = 0;

  $.post({
    cache: false,
    url: '/observer/get-expected-delivery-auc-cars-ajax',
    data: { stockId: stockId, sourceId: sourceId },
  })
    .done(function (dataTable) {
      $('#filtersSectorType').addClass('hide');

      if (sourceId != '' && sourceId != 0)
        title =
          'Список ожидаемых объектов на текущий склад с аукциона: ' +
          sourceName;
      else title = 'Список ожидаемых объектов на текущий склад';

      let i = 1,
        htmlTable =
          '<h4 class="text-center">' +
          title +
          '</h4>' +
          '<table class="table table-striped">' +
          '<thead>' +
          "<tr class='active'>" +
          '<th>№</th>' +
          '<th>Трек-номер</th>' +
          '<th>Машина</th>' +
          '<th>Дата покупки</th>' +
          '<th>Аукцион</th>' +
          '<th>Заявка на доставку</th>' +
          '<th>Доставщик</th>' +
          '<th>Статус</th>' +
          '</tr>' +
          '</thead>' +
          '<tbody>';

      dataTable.forEach(function (row, key, dataTable) {
        htmlTable +=
          '<tr>' +
          '<td>' +
          i +
          '</td>' +
          '<td>' +
          row['trackNum'] +
          '</td>' +
          '<td>';
        if (row['isBoundary'] === true) {
          htmlTable +=
            '<i class="fas fa-exclamation color-red" title="Пограничная"></i> ';
        }
        if (row['isDepartureTrip'] === true) {
          if (row['tripFullName'] === false) {
            htmlTable +=
              '<i class="fas fa-ship color-green" title="Название рейса неизвестно"></i> ';
          } else {
            htmlTable +=
              '<i class="fas fa-ship color-green" title="Погрузка: ' +
              row['tripFullName'] +
              '"></i> ';
          }
        }
        if (row['isRequestIssue'] === true) {
          htmlTable +=
            '<i class="fas fa-undo-alt color-green" title="Убывает к отправителю"></i> ';
        }
        htmlTable +=
          '<a href="/observer/object?id=' +
          row['carId'] +
          '">' +
          row['carName'] +
          '</a></td>'; /* +
                    "<td>" + row['year'] + "</td>";
                if (row['owner'].toLowerCase() == "неопределенный владелец") {
                    htmlTable += "<td class=\"color-red\">" + row['owner'].toUpperCase() + "</td>";
                } else {
                    htmlTable += "<td>" + row['owner'].toUpperCase() + "</td>";
                }
                if (row['sender'].toLowerCase() == "неопределенный владелец") {
                    htmlTable += "<td class=\"color-red\">" + row['sender'].toUpperCase() + "</td>";
                } else {
                    htmlTable += "<td>" + row['sender'].toUpperCase() + "</td>"
                }*/
        if (row['dateBuyAuction'] === false) {
          htmlTable += '<td>Неизвестно</td>';
        } else {
          htmlTable += '<td>' + row['dateBuyAuction'] + '</td>';
        }
        htmlTable += '<td>' + row['auctionName'] + '</td>';
        htmlTable += '<td>';
        if (row['carrierName'] === false) {
          htmlTable +=
            '<i class="fas fa-user-times color-red" title="Доставщик не назначен"\'></i> ';
        }
        if (row['deliveryRequestId'] === false) {
          htmlTable += 'Неизвестно</td>';
        } else {
          htmlTable +=
            '<a href="/logistic/delivery?id=' +
            row['deliveryRequestId'] +
            '">' +
            row['deliveryRequestId'] +
            '</a></td>';
        }
        if (row['carrierName'] === false) {
          htmlTable += '<td>НЕ НАЗНАЧЕН</td>';
        } else {
          if (row['carrierId'] === false) {
            htmlTable += '<td>' + row['carrierName'] + '</td>';
          } else {
            htmlTable +=
              '<td><a href="/logistic/carrier-detail?id=' +
              row['carrierId'] +
              '">' +
              row['carrierName'] +
              '</a></td>';
          }
        }
        if (row['status'] === false) {
          htmlTable += '<td>Неизвестно</td>';
        } else {
          htmlTable += '<td>' + row['status'] + '</td>';
        }
        htmlTable += '</tr>';
        i++;
      });
      htmlTable += '</tbody></table>';
      $('#table-cars-container').html(htmlTable);

      let top = $('#table-cars-container').offset().top;
      $('body,html').animate({ scrollTop: top - 50 }, 400);
    })
    .fail(function (jqXHR) {
      alert(
        'Не удалось получить данные по выбранному фильтру\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let createTableExpectedDeliveryCarrierCars = (elem) => {
  let stockId = $(elem).attr('data-stock'),
    carrierId = $(elem).attr('data-carrier'),
    carrierName = $(elem).attr('data-carrier-name'),
    title = '';

  $('#table-cars-container').html('');
  if (typeof stockId === 'undefined') stockId = '';
  if (typeof carrierId === 'undefined') carrierId = 0;

  $.post({
    cache: false,
    url: '/observer/get-expected-delivery-carrier-cars-ajax',
    data: { stockId: stockId, carrierId: carrierId },
  })
    .done(function (dataTable) {
      $('#filtersSectorType').addClass('hide');

      if (carrierId == -1)
        title =
          'Список ожидаемых объектов на текущий склад, где доставщик не назначен';
      else if (carrierId != '' && carrierId != 0)
        title =
          'Список ожидаемых объектов на текущий склад от доставщика: ' +
          carrierName;
      else title = 'Список ожидаемых объектов на текущий склад';

      let i = 1,
        htmlTable =
          '<h4 class="text-center">' +
          title +
          '</h4>' +
          '<table class="table table-striped">' +
          '<thead>' +
          "<tr class='active'>" +
          '<th>№</th>' +
          '<th>Трек-номер</th>' +
          '<th>Машина</th>' +
          '<th>Дата покупки</th>' +
          '<th>Аукцион</th>' +
          '<th>Заявка на доставку</th>' +
          '<th>Доставщик</th>' +
          '<th>Статус</th>' +
          '</tr>' +
          '</thead>' +
          '<tbody>';

      dataTable.forEach(function (row, key, dataTable) {
        htmlTable +=
          '<tr>' +
          '<td>' +
          i +
          '</td>' +
          '<td>' +
          row['trackNum'] +
          '</td>' +
          '<td>';
        if (row['isBoundary'] === true) {
          htmlTable +=
            '<i class="fas fa-exclamation color-red" title="Пограничная"></i> ';
        }
        if (row['isDepartureTrip'] === true) {
          if (row['tripFullName'] === false) {
            htmlTable +=
              '<i class="fas fa-ship color-green" title="Название рейса неизвестно"></i> ';
          } else {
            htmlTable +=
              '<i class="fas fa-ship color-green" title="Погрузка: ' +
              row['tripFullName'] +
              '"></i> ';
          }
        }
        if (row['isRequestIssue'] === true) {
          htmlTable +=
            '<i class="fas fa-undo-alt color-green" title="Убывает к отправителю"></i> ';
        }
        htmlTable +=
          '<a href="/observer/object?id=' +
          row['carId'] +
          '">' +
          row['carName'] +
          '</a></td>'; /* +
                    "<td>" + row['year'] + "</td>";
                if (row['owner'].toLowerCase() == "неопределенный владелец") {
                    htmlTable += "<td class=\"color-red\">" + row['owner'].toUpperCase() + "</td>";
                } else {
                    htmlTable += "<td>" + row['owner'].toUpperCase() + "</td>";
                }
                if (row['sender'].toLowerCase() == "неопределенный владелец") {
                    htmlTable += "<td class=\"color-red\">" + row['sender'].toUpperCase() + "</td>";
                } else {
                    htmlTable += "<td>" + row['sender'].toUpperCase() + "</td>"
                }*/
        if (row['dateBuyAuction'] === false) {
          htmlTable += '<td>Неизвестно</td>';
        } else {
          htmlTable += '<td>' + row['dateBuyAuction'] + '</td>';
        }
        htmlTable += '<td>' + row['auctionName'] + '</td>';
        htmlTable += '<td>';
        if (row['carrierName'] === false) {
          htmlTable +=
            '<i class="fas fa-user-times color-red" title="Доставщик не назначен"\'></i> ';
        }
        if (row['deliveryRequestId'] === false) {
          htmlTable += 'Неизвестно</td>';
        } else {
          htmlTable +=
            '<a href="/logistic/delivery?id=' +
            row['deliveryRequestId'] +
            '">' +
            row['deliveryRequestId'] +
            '</a></td>';
        }
        if (row['carrierName'] === false) {
          htmlTable += '<td>НЕ НАЗНАЧЕН</td>';
        } else {
          if (row['carrierId'] === false) {
            htmlTable += '<td>' + row['carrierName'] + '</td>';
          } else {
            htmlTable +=
              '<td><a href="/logistic/carrier-detail?id=' +
              row['carrierId'] +
              '">' +
              row['carrierName'] +
              '</a></td>';
          }
        }
        if (row['status'] === false) {
          htmlTable += '<td>Неизвестно</td>';
        } else {
          htmlTable += '<td>' + row['status'] + '</td>';
        }
        htmlTable += '</tr>';
        i++;
      });
      htmlTable += '</tbody></table>';
      $('#table-cars-container').html(htmlTable);

      let top = $('#table-cars-container').offset().top;
      $('body,html').animate({ scrollTop: top - 50 }, 400);
    })
    .fail(function (jqXHR) {
      alert(
        'Не удалось получить данные по выбранному фильтру\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let createTableExpectedDepartureCars = (elem, type) => {
  let stockId = $('input#stockId').val(),
    planId = $(elem).attr('data-plan-id'),
    senderId = $(elem).attr('data-sender-id'),
    date = $(elem).attr('data-date'),
    url = '',
    data = {},
    title = '';

  $('#table-cars-container').html('');
  if (typeof stockId === 'undefined') stockId = '';
  if (typeof planId === 'undefined') planId = 0;
  if (typeof senderId === 'undefined') senderId = 0;

  switch (type) {
    case 'trips':
      let tripName = $(elem).attr('data-trip-name');
      if (typeof tripName === 'undefined') tripName = '';
      url = '/observer/get-expected-departure-trips-cars-ajax';
      data = { stockId: stockId, planId: planId };
      title =
        'Список объектов в ожидании покидания склада на рейс: ' + tripName;
      break;
    case 'senders':
      let senderName = $(elem).attr('data-sender-name');
      if (typeof senderName === 'undefined') senderName = '';
      url = '/observer/get-expected-departure-senders-cars-ajax';
      data = { stockId: stockId, senderId: senderId };
      title =
        'Список объектов в ожидании покидания склада для выдачи: ' + senderName;
      break;
    case 'dates':
      let date = $(elem).attr('data-date-user');
      if (typeof date === 'undefined') date = '';
      url = '/observer/get-expected-departure-dates-cars-ajax';
      data = { stockId: stockId, date: date };
      title = 'Список объектов в ожидании покидания склада для выдачи: ' + date;
      break;
    default:
      url = '';
      data = '';
      title = '';
      break;
  }

  $.post({
    cache: false,
    url: url,
    data: data,
  })
    .done(function (dataTable) {
      $('#filtersSectorType').addClass('hide');

      let i = 1,
        htmlTable =
          '<h4 class="text-center">' +
          title +
          '</h4>' +
          '<table class="table table-striped">' +
          '<thead>' +
          "<tr class='active'>" +
          '<th>№</th>' +
          '<th>Трек-номер</th>' +
          '<th>Машина</th>' +
          '<th>Владелец</th>' +
          '<th>Отправитель</th>' +
          '<th>Время хранения</th>' +
          '<th>Сектор</th>' +
          '</tr>' +
          '</thead>' +
          '<tbody>';

      dataTable.forEach(function (row, key, dataTable) {
        htmlTable +=
          '<tr>' +
          '<td>' +
          i +
          '</td>' +
          '<td>' +
          row['trackNum'] +
          '</td>' +
          '<td>';
        if (row['isMore60days'] === true || row['storageDays'] === false) {
          htmlTable +=
            '<i class="far fa-clock color-red" title="Хранится больше 60 дней"></i> ';
        } else if (row['isMore30days'] === true) {
          htmlTable +=
            '<i class="far fa-clock color-warning" title="Хранится больше 30 дней"></i> ';
        }
        if (row['isBoundary'] === true) {
          htmlTable +=
            '<i class="fas fa-exclamation color-red" title="Пограничная"></i> ';
        }
        if (row['isDepartureTrip'] === true) {
          if (row['tripFullName'] === false) {
            htmlTable +=
              '<i class="fas fa-ship color-green" title="Название рейса неизвестно"></i> ';
          } else {
            htmlTable +=
              '<i class="fas fa-ship color-green" title="Погрузка: ' +
              row['tripFullName'] +
              '"></i> ';
          }
        }
        if (row['isRequestIssue'] === true) {
          htmlTable +=
            '<i class="fas fa-undo-alt color-green" title="Убывает к отправителю"></i> ';
        }
        htmlTable +=
          '<a href="/observer/object?id=' +
          row['carId'] +
          '">' +
          row['carName'] +
          '</a></td>';
        if (row['owner'].toLowerCase() == 'неопределенный владелец') {
          htmlTable +=
            '<td class="color-red">' + row['owner'].toUpperCase() + '</td>';
        } else {
          htmlTable += '<td>' + row['owner'].toUpperCase() + '</td>';
        }
        if (row['sender'].toLowerCase() == 'неопределенный владелец') {
          htmlTable +=
            '<td class="color-red">' + row['sender'].toUpperCase() + '</td>';
        } else {
          htmlTable += '<td>' + row['sender'].toUpperCase() + '</td>';
        }
        if (row['storageDays'] === false) {
          htmlTable += '<td class="color-red">Неизвестно</td>';
        } else {
          htmlTable += '<td>' + row['storageDays'] + ' дн.</td>';
        }
        if (row['sectorName'] === false) {
          htmlTable += '<td>Неизвестно</td>';
        } else {
          htmlTable += '<td>' + row['sectorName'] + '</td>';
        }
        htmlTable += '</tr>';
        i++;
      });
      htmlTable += '</tbody></table>';
      $('#table-cars-container').html(htmlTable);

      let top = $('#table-cars-container').offset().top;
      $('body,html').animate({ scrollTop: top - 50 }, 400);
    })
    .fail(function (jqXHR) {
      alert(
        'Не удалось получить данные по выбранному фильтру\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let createTableExpectedDepartureCarsTypeTrips = (elem) => {
  let stockId = $('input#stockId').val(),
    planId = $(elem).attr('data-plan-id'),
    tripName = $(elem).attr('data-trip-name'),
    title = '';

  $('#table-cars-container').html('');
  if (typeof stockId === 'undefined') stockId = '';
  if (typeof planId === 'undefined') planId = 0;
  if (typeof tripName === 'undefined') tripName = '';

  title = 'Список объектов в ожидании покидания склада на рейс: ' + tripName;

  $.post({
    cache: false,
    url: '/observer/get-expected-departure-trips-cars-ajax',
    data: { stockId: stockId, planId: planId },
  })
    .done(function (dataTable) {
      $('#filtersSectorType').addClass('hide');

      let i = 1,
        htmlTable =
          '<h4 class="text-center">' +
          title +
          '</h4>' +
          '<table class="table table-striped">' +
          '<thead>' +
          "<tr class='active'>" +
          '<th>№</th>' +
          '<th>Трек-номер</th>' +
          '<th>Машина</th>' +
          '<th>Владелец</th>' +
          '<th>Отправитель</th>' +
          '<th>Время хранения</th>' +
          '<th>Сектор</th>' +
          '<th>Рейс</th>' +
          '</tr>' +
          '</thead>' +
          '<tbody>';

      dataTable.forEach(function (row, key, dataTable) {
        htmlTable +=
          '<tr>' +
          '<td>' +
          i +
          '</td>' +
          '<td>' +
          row['trackNum'] +
          '</td>' +
          '<td>';
        if (row['isMore60days'] === true || row['storageDays'] === false) {
          htmlTable +=
            '<i class="far fa-clock color-red" title="Хранится больше 60 дней"></i> ';
        } else if (row['isMore30days'] === true) {
          htmlTable +=
            '<i class="far fa-clock color-warning" title="Хранится больше 30 дней"></i> ';
        }
        if (row['isBoundary'] === true) {
          htmlTable +=
            '<i class="fas fa-exclamation color-red" title="Пограничная"></i> ';
        }
        if (row['isDepartureTrip'] === true) {
          if (row['tripFullName'] === false) {
            htmlTable +=
              '<i class="fas fa-ship color-green" title="Название рейса неизвестно"></i> ';
          } else {
            htmlTable +=
              '<i class="fas fa-ship color-green" title="Погрузка: ' +
              row['tripFullName'] +
              '"></i> ';
          }
        }
        if (row['isRequestIssue'] === true) {
          htmlTable +=
            '<i class="fas fa-undo-alt color-green" title="Убывает к отправителю"></i> ';
        }
        htmlTable +=
          '<a href="/observer/object?id=' +
          row['carId'] +
          '">' +
          row['carName'] +
          '</a></td>';
        if (row['owner'].toLowerCase() == 'неопределенный владелец') {
          htmlTable +=
            '<td class="color-red">' + row['owner'].toUpperCase() + '</td>';
        } else {
          htmlTable += '<td>' + row['owner'].toUpperCase() + '</td>';
        }
        if (row['sender'].toLowerCase() == 'неопределенный владелец') {
          htmlTable +=
            '<td class="color-red">' + row['sender'].toUpperCase() + '</td>';
        } else {
          htmlTable += '<td>' + row['sender'].toUpperCase() + '</td>';
        }
        if (row['storageDays'] === false) {
          htmlTable += '<td class="color-red">Неизвестно</td>';
        } else {
          htmlTable += '<td>' + row['storageDays'] + ' дн.</td>';
        }
        if (row['sectorName'] === false) {
          htmlTable += '<td>Неизвестно</td>';
        } else {
          htmlTable += '<td>' + row['sectorName'] + '</td>';
        }
        if (row['tripName'] === false) {
          htmlTable += '<td>Неизвестно</td>';
        } else {
          if (row['deliveryPlanId'] !== false) {
            htmlTable +=
              '<td><i class="fas fa-car color-green" title="Сгон до ' +
              row['driveTo'] +
              '"></i> ' +
              '<a href="/observer/delivered?plan_id=' +
              row['deliveryPlanId'] +
              '" target="_blank">' +
              row['tripName'] +
              '</a></td>';
          } else {
            htmlTable +=
              '<td><i class="fas fa-car color-red" title="Не добавлен на сгон"></i> ' +
              row['tripName'] +
              '</td>';
          }
        }
        /*if (row['tripName'] === false) {
                    htmlTable += "<td>Неизвестно</td>";
                } else {
                    if (row['planId'] !== false) {
                        htmlTable += "<td><a href=\"/observer/cars?id=" + row['planId'] + "\" target=\"_blank\">" +
                            row['tripName'] + "</a></td>";
                    } else {
                        htmlTable += "<td>" + row['tripName'] + "</td>";
                    }
                }
                if (row['deliveryPlanId'] === false) {
                    htmlTable += "<td>Неизвестно</td>";
                } else {
                    htmlTable += "<td><a href=\"/observer/delivered?plan_id=" + row['deliveryPlanId'] + "\" target=\"_blank\">" +
                        row['driveTo'] + "</a></td>";
                }*/
        htmlTable += '</tr>';
        i++;
      });
      htmlTable += '</tbody></table>';
      $('#table-cars-container').html(htmlTable);

      let top = $('#table-cars-container').offset().top;
      $('body,html').animate({ scrollTop: top - 50 }, 400);
    })
    .fail(function (jqXHR) {
      alert(
        'Не удалось получить данные по выбранному фильтру\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let createTableCarsStock = (
  sectorId,
  senderId,
  isBoundary,
  countMinStorageDays,
  isNoOwner
) => {
  let stockId = $('#stockId').val(),
    senderName = $('#sendersList option:selected').text(),
    title = '';

  $('#table-cars-container').html('');
  if (typeof stockId === 'undefined' || stockId === null) stockId = '';
  if (typeof sectorId === 'undefined' || sectorId === null) sectorId = '';
  if (typeof senderId === 'undefined' || senderId === null) senderId = '';
  if (typeof isBoundary === 'undefined' || isBoundary === null) isBoundary = '';
  if (
    typeof countMinStorageDays === 'undefined' ||
    countMinStorageDays === null
  )
    countMinStorageDays = '';
  if (
    typeof countMinStorageDays === 'undefined' ||
    countMinStorageDays === null
  )
    isNoOwner = '';

  $.post({
    cache: false,
    url: '/observer/get-filtered-cars-ajax',
    data: {
      stockId: stockId,
      sectorId: sectorId,
      senderId: senderId,
      isBoundary: isBoundary,
      countMinStorageDays: countMinStorageDays,
      isNoOwner: isNoOwner,
    },
  })
    .done(function (dataTable) {
      $('#filtersSectorType').removeClass('hide');

      if (senderId !== '' && senderId != 0)
        title = 'Объекты ' + senderName + ' на текущем складе';
      else if (isBoundary !== '' && isBoundary !== 0)
        title = 'Пограничные объекты на текущем складе';
      else title = 'Объекты на текущем складе';

      let i = 1,
        htmlTable =
          '<h4 class="text-center">' +
          title +
          '</h4>' +
          '<table class="table table-striped">' +
          '<thead>' +
          "<tr class='active'>" +
          '<th>№</th>' +
          '<th>Трек-номер</th>' +
          '<th>Машина</th>' +
          '<th>Владелец</th>' +
          '<th>Отправитель</th>' +
          '<th>Сектор</th>' +
          '<th>Время хранения</th>' +
          '</tr>' +
          '</thead>' +
          '<tbody>';

      dataTable.forEach(function (row, key, dataTable) {
        htmlTable +=
          '<tr>' +
          '<td>' +
          i +
          '</td>' +
          '<td>' +
          row['trackNum'] +
          '</td>' +
          '<td>';
        if (row['isMore60days'] === true || row['storageDays'] === false) {
          htmlTable +=
            '<i class="far fa-clock color-red" title="Хранится больше 60 дней"></i> ';
        } else if (row['isMore30days'] === true) {
          htmlTable +=
            '<i class="far fa-clock color-warning" title="Хранится больше 30 дней"></i> ';
        }
        if (row['isBoundary'] === true) {
          htmlTable +=
            '<i class="fas fa-exclamation color-red" title="Пограничная"></i> ';
        }
        if (row['isDepartureTrip'] === true) {
          if (row['tripFullName'] === false) {
            htmlTable +=
              '<i class="fas fa-ship color-green" title="Название рейса неизвестно"></i> ';
          } else {
            htmlTable +=
              '<i class="fas fa-ship color-green" title="Погрузка: ' +
              row['tripFullName'] +
              '"></i> ';
          }
        }
        if (row['isRequestIssue'] === true) {
          htmlTable +=
            '<i class="fas fa-undo-alt color-green" title="Убывает к отправителю"></i> ';
        }
        htmlTable +=
          '<a href="/observer/object?id=' +
          row['carId'] +
          '">' +
          row['carName'] +
          '</a></td>';
        if (row['owner'].toLowerCase() == 'неопределенный владелец') {
          htmlTable +=
            '<td class="color-red">' + row['owner'].toUpperCase() + '</td>';
        } else {
          htmlTable += '<td>' + row['owner'].toUpperCase() + '</td>';
        }
        if (row['sender'].toLowerCase() == 'неопределенный владелец') {
          htmlTable +=
            '<td class="color-red">' + row['sender'].toUpperCase() + '</td>';
        } else {
          htmlTable += '<td>' + row['sender'].toUpperCase() + '</td>';
        }
        htmlTable += '<td>' + row['sector'] + '</td>';
        if (row['storageDays'] === false) {
          htmlTable += '<td class="color-red">Неизвестно</td>';
        } else {
          htmlTable += '<td>' + row['storageDays'] + ' дн.</td>';
        }
        htmlTable += '</tr>';
        i++;
      });
      htmlTable += '</tbody></table>';

      $('#table-cars-container').html(htmlTable);
      let top = $('#table-cars-container').offset().top;
      $('body,html').animate({ scrollTop: top - 50 }, 400);
    })
    .fail(function (jqXHR) {
      alert(
        'Не удалось получить данные по выбранному фильтру\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let removeSelectionStockStat = () => {
  $('#expected-delivery-stats-type-auction-table-div td').removeClass(
    'color-selected-cell-table'
  );
  $('#expected-delivery-stats-type-carrier-table-div td').removeClass(
    'color-selected-cell-table'
  );
  $('#expected-departure-stats-type-trips-table-div td').removeClass(
    'color-selected-cell-table'
  );
  $('#expected-departure-stats-type-sender-table-div td').removeClass(
    'color-selected-cell-table'
  );
  $('#expected-departure-stats-type-date-table-div td').removeClass(
    'color-selected-cell-table'
  );
  $('#stock-sectors-stats-table-div td').removeClass(
    'color-selected-cell-table'
  );
};
//------------------END-Статистика склада--------------------------------------------

//------------------BEGIN-Статистика отправителей--------------------------------------------
let createTableStat = (data, idDivTable, url, type) => {
  $.post({
    cache: false,
    url: url,
    data: data,
  })
    .done(function (dataTable) {
      let htmlTable =
        '<table class="table table-striped">' +
        '<thead>' +
        "<tr class='active'>";

      dataTable['headers'].forEach(function (header, key, dataTable) {
        htmlTable += '<th>' + header + '</th>';
      });

      htmlTable += '</tr>' + '</thead>' + '<tbody>';

      dataTable['body'].forEach(function (row, key, dataTable) {
        htmlTable += '<tr>';
        row.forEach(function (cell, key, dataTable) {
          if (key == 0 || cell['class'] === '') {
            htmlTable += '<td class="">' + cell['value'] + '</td>';
          } else {
            htmlTable +=
              '<td class="">' +
              '<a href="javascript:void(0);" class="' +
              cell['class'] +
              '"' +
              cell['attr'] +
              '>' +
              cell['value'] +
              '</a></td>';
          }
        });
        htmlTable += '</tr>';
      });
      htmlTable += '</tbody></table>';
      $(idDivTable).html(htmlTable);
      let exportTrip =
        idDivTable === '#owner-export-trips-stats-table-div' ? true : false;
      $('.createTableCarsStat').click(function () {
        removeSelectionSenderStat();
        removeSelectionOwnerStat();
        $(this).parent().addClass('color-selected-cell-table');

        let stockId = $(this).attr('data-stockid'),
          senderId = $('input#senderId').val(),
          ownerId = $('input#ownerId').val(),
          carTypeId = $(this).attr('data-cartypeid'),
          sawTypeId = $(this).attr('data-sawtypeid'),
          customTypeId = $(this).attr('data-customtypeid'),
          countMinStorageDays = $(this).attr('data-countMinStorageDays'),
          tripId = $(this).attr('data-tripId'),
          title = $(this).attr('data-title'),
          idDivTable = '#table-cars-container',
          url = exportTrip
            ? '/observer/get-export-cars-ajax'
            : '/observer/get-filtered-cars-ajax',
          data = {};
        if (typeof stockId === 'undefined' || stockId === null) stockId = '';
        if (typeof senderId === 'undefined' || senderId === null) senderId = '';
        if (typeof carTypeId === 'undefined' || carTypeId === null)
          carTypeId = '';
        if (typeof sawTypeId === 'undefined' || sawTypeId === null)
          sawTypeId = '';
        if (typeof customTypeId === 'undefined' || customTypeId === null)
          customTypeId = '';
        if (
          typeof countMinStorageDays === 'undefined' ||
          countMinStorageDays === null
        )
          countMinStorageDays = '';
        if (typeof tripId === 'undefined' || tripId === null) tripId = '';
        if (typeof ownerId === 'undefined' || ownerId === null) ownerId = '';
        data = {
          stockId: stockId,
          senderId: senderId,
          ownerId: ownerId,
          carTypeId: carTypeId,
          sawTypeId: sawTypeId,
          customTypeId: customTypeId,
          countMinStorageDays: countMinStorageDays,
          tripId: tripId,
        };

        switch (type) {
          case 'types':
            createTableCarsTypes(data, idDivTable, url, title);
            break;
          case 'trips':
            createTableCarsTrips(data, idDivTable, url, title);
            break;
          default:
            break;
        }
      });
    })
    .fail(function (jqXHR) {
      alert(
        'Не удалось получить данные по выбранному фильтру\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let createTableCarsTypes = (data, idDivTable, url, title) => {
  $(idDivTable).html('');

  $.post({
    cache: false,
    url: url,
    data: data,
  })
    .done(function (dataTable) {
      let i = 1,
        htmlTable =
          '<h4 class="text-center">' +
          title +
          '</h4>' +
          '<table class="table table-striped">' +
          '<thead>' +
          "<tr class='active'>" +
          '<th>№</th>' +
          '<th>Трек-номер</th>' +
          '<th>Машина</th>' +
          '<th>Владелец</th>' +
          '<th>Сектор</th>' +
          '<th>Время хранения</th>' +
          '</tr>' +
          '</thead>' +
          '<tbody>';

      dataTable.forEach(function (row, key, dataTable) {
        htmlTable +=
          '<tr>' +
          '<td>' +
          i +
          '</td>' +
          '<td>' +
          row['trackNum'] +
          '</td>' +
          '<td>';
        if (row['isMore60days'] === true || row['storageDays'] === false) {
          htmlTable +=
            '<i class="far fa-clock color-red" title="Хранится больше 60 дней"></i> ';
        } else if (row['isMore30days'] === true) {
          htmlTable +=
            '<i class="far fa-clock color-warning" title="Хранится больше 30 дней"></i> ';
        }
        if (row['isBoundary'] === true) {
          htmlTable +=
            '<i class="fas fa-exclamation color-red" title="Пограничная"></i> ';
        }
        if (row['isCompleted'] === true) {
          htmlTable +=
            '<i class="fas fa-check-square color-warning standard-size-icon" title=\'Работа с машиной завершена\'></i> ';
        }
        if (row['isRemoved'] === true) {
          htmlTable +=
            '<i class="fas fa-times-circle color-red standard-size-icon" title=\'Машина удалена\'></i> ';
        }
        if (row['isDrivable'] !== true) {
          htmlTable +=
            '<i class="fas fa-truck-moving color-red standard-size-icon" title="Не ходовая"></i> ';
        }
        if (row['isDepartureTrip'] === true) {
          if (row['tripFullName'] === false) {
            htmlTable +=
              '<i class="fas fa-ship color-green" title="Название рейса неизвестно"></i> ';
          } else {
            htmlTable +=
              '<i class="fas fa-ship color-green" title="Погрузка: ' +
              row['tripFullName'] +
              '"></i> ';
          }
        }
        if (row['isRequestIssue'] === true) {
          htmlTable +=
            '<i class="fas fa-undo-alt color-green" title="Убывает к отправителю"></i> ';
        }
        htmlTable +=
          '<a href="/observer/object?id=' +
          row['carId'] +
          '">' +
          row['carName'] +
          '</a></td>';
        if (row['owner'].toLowerCase() == 'неопределенный владелец') {
          htmlTable +=
            '<td class="color-red">' + row['owner'].toUpperCase() + '</td>';
        } else {
          htmlTable += '<td>' + row['owner'].toUpperCase() + '</td>';
        }
        htmlTable += '<td>' + row['sector'] + '</td>';
        if (row['storageDays'] === false) {
          htmlTable += '<td class="color-red">Неизвестно</td>';
        } else {
          htmlTable += '<td>' + row['storageDays'] + ' дн.</td>';
        }
        htmlTable += '</tr>';
        i++;
      });
      htmlTable += '</tbody></table>';

      $(idDivTable).html(htmlTable);
      let top = $(idDivTable).offset().top;
      $('body,html').animate({ scrollTop: top - 50 }, 400);
    })
    .fail(function (jqXHR) {
      alert(
        'Не удалось получить данные по выбранному фильтру\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let createTableCarsTrips = (data, idDivTable, url, title) => {
  $('#table-cars-container').html('');

  $.post({
    cache: false,
    url: url,
    data: data,
  })
    .done(function (dataTable) {
      let i = 1,
        htmlTable =
          '<h4 class="text-center">' +
          title +
          '</h4>' +
          '<table class="table table-striped">' +
          '<thead>' +
          "<tr class='active'>" +
          '<th>№</th>' +
          '<th>Трек-номер</th>' +
          '<th>Машина</th>' +
          '<th>Владелец</th>' +
          '<th>Время хранения</th>' +
          '</tr>' +
          '</thead>' +
          '<tbody>';

      dataTable.forEach(function (row, key, dataTable) {
        htmlTable +=
          '<tr>' +
          '<td>' +
          i +
          '</td>' +
          '<td>' +
          row['trackNum'] +
          '</td>' +
          '<td>';
        if (row['isMore60days'] === true || row['storageDays'] === false) {
          htmlTable +=
            '<i class="far fa-clock color-red" title="Хранится больше 60 дней"></i> ';
        } else if (row['isMore30days'] === true) {
          htmlTable +=
            '<i class="far fa-clock color-warning" title="Хранится больше 30 дней"></i> ';
        }
        if (row['isBoundary'] === true) {
          htmlTable +=
            '<i class="fas fa-exclamation color-red" title="Пограничная"></i> ';
        }
        if (row['isDepartureTrip'] === true) {
          if (row['tripFullName'] === false) {
            htmlTable +=
              '<i class="fas fa-ship color-green" title="Название рейса неизвестно"></i> ';
          } else {
            htmlTable +=
              '<i class="fas fa-ship color-green" title="Погрузка: ' +
              row['tripFullName'] +
              '"></i> ';
          }
        }
        if (row['isRequestIssue'] === true) {
          htmlTable +=
            '<i class="fas fa-undo-alt color-green" title="Убывает к отправителю"></i> ';
        }
        htmlTable +=
          '<a href="/observer/object?id=' +
          row['carId'] +
          '">' +
          row['carName'] +
          '</a></td>';
        if (row['owner'].toLowerCase() == 'неопределенный владелец') {
          htmlTable +=
            '<td class="color-red">' + row['owner'].toUpperCase() + '</td>';
        } else {
          htmlTable += '<td>' + row['owner'].toUpperCase() + '</td>';
        }
        if (row['storageDays'] === false) {
          htmlTable += '<td class="color-red">Неизвестно</td>';
        } else {
          htmlTable += '<td>' + row['storageDays'] + ' дн.</td>';
        }
        htmlTable += '</tr>';
        i++;
      });
      htmlTable += '</tbody></table>';

      $(idDivTable).html(htmlTable);
      let top = $(idDivTable).offset().top;
      $('body,html').animate({ scrollTop: top - 50 }, 400);
    })
    .fail(function (jqXHR) {
      alert(
        'Не удалось получить данные по выбранному фильтру\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let createTypeObjectStockSendersStatsTable = (idDivTable) => {
  let senderId = $('input#senderId').val();
  $.post({
    cache: false,
    url: '/observer/get-data-table-types-senders-stats-ajax',
    data: { senderId: senderId },
  })
    .done(function (dataTable) {
      let htmlTable =
        '<table class="table table-striped">' +
        '<thead>' +
        "<tr class='active'>";

      dataTable['headers'].forEach(function (header, key, dataTable) {
        htmlTable += '<th>' + header + '</th>';
      });

      htmlTable += '</tr>' + '</thead>' + '<tbody>';

      dataTable['values'].forEach(function (row, key, dataTable) {
        htmlTable += '<tr>';
        row.forEach(function (value, key, dataTable) {
          htmlTable += '<td>' + value + '</td>';
        });
        htmlTable += '</tr>';
      });
      htmlTable += '</tbody></table>';
      $(idDivTable).html(htmlTable);
    })
    .fail(function (jqXHR) {
      alert(
        'Не удалось получить данные по выбранному фильтру\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let createTypeSawStockSendersStatsTable = (idDivTable) => {
  let senderId = $('input#senderId').val();
  $.post({
    cache: false,
    url: '/observer/data-stock-type-object-senders-stats-ajax',
    data: { senderId: senderId },
  })
    .done(function (dataTable) {
      let htmlTable =
        '<table class="table table-striped">' +
        '<thead>' +
        "<tr class='active'>";

      dataTable['headers'].forEach(function (header, key, dataTable) {
        htmlTable += '<th>' + header + '</th>';
      });

      htmlTable += '</tr>' + '</thead>' + '<tbody>';

      dataTable['values'].forEach(function (row, key, dataTable) {
        htmlTable += '<tr>';
        row.forEach(function (value, key, dataTable) {
          htmlTable += '<td>' + value + '</td>';
        });
        htmlTable += '</tr>';
      });
      htmlTable += '</tbody></table>';
      $(idDivTable).html(htmlTable);
    })
    .fail(function (jqXHR) {
      alert(
        'Не удалось получить данные по выбранному фильтру\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let createTypeCustomStockSendersStatsTable = (idDivTable) => {
  let senderId = $('input#senderId').val();
  $.post({
    cache: false,
    url: '/observer/get-data-table-types-senders-stats-ajax',
    data: { senderId: senderId },
  })
    .done(function (dataTable) {
      let htmlTable =
        '<table class="table table-striped">' +
        '<thead>' +
        "<tr class='active'>";

      dataTable['headers'].forEach(function (header, key, dataTable) {
        htmlTable += '<th>' + header + '</th>';
      });

      htmlTable += '</tr>' + '</thead>' + '<tbody>';

      dataTable['values'].forEach(function (row, key, dataTable) {
        htmlTable += '<tr>';
        row.forEach(function (value, key, dataTable) {
          htmlTable += '<td>' + value + '</td>';
        });
        htmlTable += '</tr>';
      });
      htmlTable += '</tbody></table>';
      $(idDivTable).html(htmlTable);
    })
    .fail(function (jqXHR) {
      alert(
        'Не удалось получить данные по выбранному фильтру\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let createSendSendersStatsTable = (idDivTable) => {
  let senderId = $('input#senderId').val();
  $.post({
    cache: false,
    url: '/observer/get-data-table-send-senders-stats-ajax',
    data: { senderId: senderId },
  })
    .done(function (dataTable) {
      let htmlTable =
        '<table class="table table-striped">' +
        '<thead>' +
        "<tr class='active'>";

      dataTable['headers'].forEach(function (header, key, dataTable) {
        htmlTable += '<th>' + header + '</th>';
      });

      htmlTable += '</tr>' + '</thead>' + '<tbody>';

      dataTable['values'].forEach(function (row, key, dataTable) {
        htmlTable += '<tr>';
        row.forEach(function (value, key, dataTable) {
          htmlTable += '<td>' + value + '</td>';
        });
        htmlTable += '</tr>';
      });
      htmlTable += '</tbody></table>';
      $(idDivTable).html(htmlTable);
    })
    .fail(function (jqXHR) {
      alert(
        'Не удалось получить данные по выбранному фильтру\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let removeSelectionSenderStat = () => {
  $('#generalStat td').removeClass('color-selected-cell-table');
  $('#sender-stock-stats-type-object-table-div td').removeClass(
    'color-selected-cell-table'
  );
  $('#sender-stock-stats-type-saw-table-div td').removeClass(
    'color-selected-cell-table'
  );
  $('#sender-stock-stats-type-custom-table-div td').removeClass(
    'color-selected-cell-table'
  );
  $('#sender-trips-stats-table-div td').removeClass(
    'color-selected-cell-table'
  );
};

let removeSelectionOwnerStat = () => {
  $('#generalStat td').removeClass('color-selected-cell-table');
  $('#owner-stock-stats-type-object-table-div td').removeClass(
    'color-selected-cell-table'
  );
  $('#owner-stock-stats-type-saw-table-div td').removeClass(
    'color-selected-cell-table'
  );
  $('#owner-stock-stats-type-custom-table-div td').removeClass(
    'color-selected-cell-table'
  );
  $('#owner-trips-stats-table-div td').removeClass('color-selected-cell-table');
};
//------------------END-Статистика отправителей--------------------------------------------

let rejectPreDeliveryRequest = () => {
  let aucId = $('#preRejectOpenModal').attr('data-aid'),
    reason = $('#reasonRejectInput').val();

  if (typeof aucId === 'undefined') reason = '';
  if (typeof reason === 'undefined') reason = '';

  if (reason === '') {
    $('div#modal-pre-delivery-reject div#reasonRejectDiv').addClass(
      'has-error'
    );
    $(
      'div#modal-pre-delivery-reject div#reasonRejectDiv span.help-block'
    ).removeClass('hide');
  } else {
    $.get({
      cache: false,
      url: '/logistic/pre-reject',
      data: { aid: aucId, rsn: reason },
    })
      .done(function (data) {
        switch (data['status']) {
          case 'success':
            $('div#modal-pre-delivery-reject div#reasonRejectDiv').removeClass(
              'has-error'
            );
            $(
              'div#modal-pre-delivery-reject div#reasonRejectDiv span.help-block'
            ).addClass('hide');
            //$("#modal-pre-delivery-reject").modal("hide");
            location.reload();
            break;
          case 'fail':
            alert('Ошибка. Ответ сервера: ' + data['msg']);
            break;
          default:
            alert('Неизвестная ошибка');
            break;
        }
      })
      .fail(function (jqXHR) {
        alert(
          'Произошла ошибка при попытке запроса к Cartrack\n' +
          'Статус: ' +
          jqXHR['statusText'] +
          '\n' +
          'Код статуса: ' +
          jqXHR['status'] +
          '\n' +
          'Ответ сервера: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      });
  }
};

let openModalCreateDeliveryRequest = (elem) => {
  let carId = $(elem).attr('data-carId'),
    sourceId = $(elem).attr('data-sourceId'),
    destinationId = $(elem).attr('data-destinationId'),
    trackNum = $(elem).attr('data-trackNum'),
    mark = $(elem).attr('data-mark'),
    maker = $(elem).attr('data-maker'),
    vin = $(elem).attr('data-vin'),
    owner = $(elem).attr('data-owner'),
    auction = $(elem).attr('data-auction'),
    location = $(elem).attr('data-location'),
    lot = $(elem).attr('data-lot');

  $('#modalCreateDeliveryRequest #carId').val(carId);
  $('#modalCreateDeliveryRequest #sourceId').val(sourceId);
  $('#modalCreateDeliveryRequest #destinationId').val(destinationId);
  $('#modalCreateDeliveryRequest #vin').text(vin);
  $('#modalCreateDeliveryRequest #objectInfo').html(
    'Владелец: ' +
    owner +
    '<br>Аукцион: ' +
    auction +
    '<br>Лот: ' +
    lot +
    '<br>Трек-номер: ' +
    trackNum +
    '<br>Объект: ' +
    maker +
    ' ' +
    mark +
    '<br>Местоположение ' +
    location +
    '<br><br>'
  );
  $('#modalCreateDeliveryRequest').modal('show');
};

let createDeliveryRequest = () => {
  let carId = $('#modalCreateDeliveryRequest #carId').val(),
    sourceId = $('#modalCreateDeliveryRequest #sourceId').val(),
    destinationId = $('#modalCreateDeliveryRequest #destinationId').val(),
    aucId = $('#modalCreateDeliveryRequest #aucId').val();

  $.get({
    cache: false,
    url: '/logistic/akebono-accept',
    data: { cid: carId, sid: sourceId, did: destinationId, aid: aucId },
  })
    .done(function (data) {
      switch (data['status']) {
        case 'success':
          location.reload();
          break;
        case 'fail':
          alert('Произошла ошибка при попытке создать заявку');
          break;
        default:
          alert('Неизвестная ошибка');
          break;
      }
    })
    .fail(function (jqXHR) {
      alert(
        'Произошла ошибка при попытке запроса к Cartrack\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let openModalPreDeliveryAccept = (elem) => {
  let aid = $(elem).attr('data-aid'),
    aucIdPos = $(elem).attr('data-auc-member');

  $('#modal-pre-delivery-accept #aid').val(aid);
  $('#modal-pre-delivery-accept #aucIdPos').val(aucIdPos);
  $('#modal-pre-delivery-accept').modal('show');
};

let acceptPreDeliveryRequest = () => {
  let aid = $('#modal-pre-delivery-accept #aid').val(),
    aucIdPos = $('#modal-pre-delivery-accept #aucIdPos').val();

  $.get({
    cache: false,
    url: '/logistic/pre-accept',
    data: { aid: aid, aucIdPos: aucIdPos },
  })
    .done(function (data) {
      switch (data['status']) {
        case 'success':
          location.reload();
          break;
        case 'fail':
          alert('Произошла ошибка при попытке создать заявку');
          break;
        default:
          alert('Неизвестная ошибка');
          break;
      }
    })
    .fail(function (jqXHR) {
      alert(
        'Произошла ошибка при попытке запроса к Cartrack\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let cancelDeliveryRequest = (id, reason, url, lang) => {
  $.post({
    cache: false,
    url: url,
    data: { id: id, reason: reason },
  })
    .done(function (data) {
      switch (data['status']) {
        case 'success':
          location.reload();
          break;
        case 'fail':
          if (lang == 'russian') {
            alert(
              'Произошла ошибка при отмене заявки. Ответ сервера: ' +
              data['msg']
            );
          } else {
            alert('Error. Server response: ' + data['msg']);
          }
          break;
      }
    })
    .fail(function (jqXHR) {
      if (lang == 'russian') {
        alert(
          'Произошла ошибка при попытке запроса к Cartrack\n' +
          'Статус: ' +
          jqXHR['statusText'] +
          '\n' +
          'Код статуса: ' +
          jqXHR['status'] +
          '\n' +
          'Ответ сервера: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      } else {
        alert(
          'Error. Cartrack unavailable\n' +
          'Status: ' +
          jqXHR['statusText'] +
          '\n' +
          'Status code: ' +
          jqXHR['status'] +
          '\n' +
          'Server response: ' +
          jqXHR['responseJSON']['name'] +
          '\n'
        );
      }
    });
};

let filterInputVin = (elem) => {
  let str = elem.value.substr(elem.value.length - 1),
    result = str.search(/[a-np-zA-NP-Z0-9-]{1}/);
  if (result === -1) {
    elem.value = elem.value.slice(0, -1);
  }
};

let createTable = (data, idDivTable, url) => {
  $.post({
    cache: false,
    url: url,
    data: data,
  })
    .done(function (dataTable) {
      let htmlTable =
        '<table class="table table-striped">' +
        '<thead>' +
        "<tr class='active'>";

      dataTable['headers'].forEach(function (header, key, dataTable) {
        htmlTable += '<th>' + header + '</th>';
      });

      htmlTable += '</tr>' + '</thead>' + '<tbody>';

      dataTable['body'].forEach(function (row, key, dataTable) {
        htmlTable += '<tr>';
        row.forEach(function (cell, key, dataTable) {
          if (typeof cell['objectId'] === 'undefined') {
            htmlTable += '<td>' + cell['value'] + '</td>';
          } else {
            htmlTable +=
              '<td><a href="/observer/object?id=' +
              cell['objectId'] +
              '" target="_blank">' +
              cell['value'] +
              '</a></td>';
          }
        });
        htmlTable += '</tr>';
      });
      htmlTable += '</tbody></table>';
      $(idDivTable).html(htmlTable);
    })
    .fail(function (jqXHR) {
      alert(
        'Не удалось получить данные по выбранному фильтру\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let changeDeliveryRoute = (url, data) => {
  $.post({
    cache: false,
    url: url,
    data: data,
  })
    .done(function (data) {
      switch (data['status']) {
        case 'success':
          location.reload();
          break;
        case 'fail':
          alert(
            'Произошла ошибка при попытке изменить маршрут. \nОтвет сервера: ' +
            data['msg']
          );
          break;
        default:
          alert('Неизвестная ошибка. Статус неизвестен.');
      }
    })
    .fail(function (jqXHR) {
      alert(
        'Произошла ошибка при попытке запроса к Cartrack\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let removeReminderFromUser = (
  id,
  elem,
  successAction = (response, elem) => {
    $(elem).siblings('.close').click();
  },
  failAction = (jqXHR) => {
    window.alert(
      'Execute action fail\n' +
      'Status: ' +
      jqXHR['statusText'] +
      '\n' +
      'Status code: ' +
      jqXHR['status'] +
      '\n' +
      'Server response: ' +
      jqXHR['responseText']
    );
  }
) => {
  $.post({
    cache: false,
    url: '/data/remove-reminder-from-user',
    data: { id: id },
  })
    .done(function (response) {
      successAction(response, elem);
    })
    .fail(function (jqXHR) {
      failAction(jqXHR);
    });
};

let removeReminder = (id, elem) => {
  $.post({
    cache: false,
    url: '/data/remove-reminder-ajax',
    data: { id: id },
  })
    .done(function (data) {
      switch (data['status']) {
        case 'success':
          $(elem).siblings('.close').click();
          break;
        case 'fail':
          alert(
            'Произошла ошибка при удалении напоминания. \nОтвет сервера: ' +
            data['msg']
          );
          break;
        default:
          alert('Неизвестная ошибка');
          break;
      }
    })
    .fail(function (jqXHR) {
      alert(
        'Произошла ошибка при попытке запроса к Cartrack\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let changeDeliveryComment = (deliveryId, comment) => {
  $.post({
    cache: false,
    url: '/logistic/change-comment-delivery-ajax',
    data: { deliveryId: deliveryId, comment: comment },
  })
    .done(function (data) {
      switch (data['status']) {
        case 'success':
          location.reload();
          break;
        case 'fail':
          alert(
            'Произвошла ошибка при попытке изменить комментарий. \nОтвет сервера: ' +
            data['msg']
          );
          break;
        default:
          alert('Неизвестная ошибка');
          break;
      }
    })
    .fail(function (jqXHR) {
      alert(
        'Произошла ошибка при попытке запроса к Cartrack\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let changeDeliveryDriver = (deliveryId, driverId) => {
  $.post({
    cache: false,
    url: '/logistic/change-driver-delivery-ajax',
    data: { deliveryId: deliveryId, driverId: driverId },
  })
    .done(function (data) {
      switch (data['status']) {
        case 'success':
          location.reload();
          break;
        case 'fail':
          alert(
            'Произвошла ошибка при попытке изменить комментарий. \nОтвет сервера: ' +
            data['msg']
          );
          break;
        default:
          alert('Неизвестная ошибка');
          break;
      }
    })
    .fail(function (jqXHR) {
      alert(
        'Произошла ошибка при попытке запроса к Cartrack\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let changeDeliveryDefaultCarriers = (url, data) => {
  $.post({
    cache: false,
    url: url,
    data: data,
  })
    .done(function (data) {
      switch (data['status']) {
        case 'success':
          location.reload();
          break;
        case 'fail':
          alert('Произвошла ошибка. \nОтвет сервера: ' + data['msg']);
          break;
        default:
          alert('Неизвестная ошибка');
          break;
      }
    })
    .fail(function (jqXHR) {
      alert(
        'Произошла ошибка при попытке запроса к Cartrack\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let moveToPort = () => {
  let objectId = $('#objectId').val(),
    planId = $('#planId').val(),
    stockId = $('#stockId').val();

  $.post({
    cache: false,
    url: '/watch/move-to-port',
    data: { objectId: objectId, planId: planId, stockId: stockId },
  })
    .done(function (response) {
      switch (response['status']) {
        case 'success':
          $('#modal-foundInPort').modal('hide');
          $('#openModalFoundInPort_' + objectId).hide();
          let icon = $('#notAllowWatchIcon_' + objectId);
          if (typeof icon !== 'undefined') {
            icon.hide();
          }
          break;
        case 'fail':
          alert(
            'Произвошла ошибка при попытке переместить в порт. \nОтвет сервера: ' +
            response['msg']
          );
          break;
        default:
          alert('Неизвестная ошибка');
          break;
      }
    })
    .fail(function (jqXHR) {
      alert(
        'Произошла ошибка при попытке запроса к Cartrack\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

let aucDocumentsReceived = (url, data) => {
  $.post({
    cache: false,
    url: url,
    data: data,
  })
    .done(function (response) {
      switch (response['status']) {
        case 'success':
          location.reload();
          break;
        case 'fail':
          alert('Error. Server response: ' + response['msg']);
          break;
        default:
          alert('Unkown error');
          break;
      }
    })
    .fail(function (jqXHR) {
      alert(
        'Error. Cartrack unavailable\n' +
        'Status: ' +
        jqXHR['statusText'] +
        '\n' +
        'Status code: ' +
        jqXHR['status'] +
        '\n' +
        'Server response: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    });
};

// $inputFiles - jquery collection input[type=file/files], urlPreSignedPostObject - source data pre-signed post object
let uploadToS3 = (
  $inputFiles,
  urlPreSignedPostObject,
  entityId,
  entityType,
  mediaType,
  successAction,
  failAction
) => {
  $.get({
    cache: false,
    url: '/system/check-entity',
    data: { entityId: entityId, entityType: entityType },
    success: function (response) {
      switch (response['status']) {
        case 'success':
          asyncUploadToS3(
            $inputFiles,
            urlPreSignedPostObject,
            entityId,
            entityType,
            mediaType,
            successAction,
            failAction
          );
          break;
        case 'fail':
          alert(
            'Произошла ошибка. \n' +
            'Загрузка файлов прервана. Обратитесь к администратору. \nОтвет сервера: ' +
            response['msg']
          );
          break;
        case 'unknown':
          alert(
            'Обнаружена неизвестная сущность. \n' +
            'Загрузка файлов прервана. Обратитесь к администратору.'
          );
          break;
        default:
          alert('Неизвестная ошибка. Загрузка прервана');
          break;
      }
    },
    error: function (jqXHR) {
      alert(
        'Произошла ошибка при попытке запроса к Cartrack\n' +
        'Статус: ' +
        jqXHR['statusText'] +
        '\n' +
        'Код статуса: ' +
        jqXHR['status'] +
        '\n' +
        'Ответ сервера: ' +
        jqXHR['responseJSON']['name'] +
        '\n'
      );
    },
  });
};

// $inputFiles - jquery collection input[type=file/files], urlPreSignedPostObject - source data pre-signed post object
let asyncUploadToS3 = (
  $inputFiles,
  urlPreSignedPostObject,
  entityId,
  entityType,
  mediaType,
  successAction,
  failAction
) => {
  let files = $inputFiles.prop('files'),
    fails = [],
    keysSuccess = [],
    promises = [],
    startTimestamp = Date.now(),
    uploadedSize = 0,
    totalSize = 0;

  $.each(files, function (index, fileValue) {
    let bucketType = '',
      contentType = fileValue.type;
    if (fileValue.type.indexOf('image') >= 0) {
      bucketType = 'IMAGE';
    } else if (fileValue.type.indexOf('video') >= 0) {
      bucketType = 'VIDEO';
    } else {
      bucketType = 'FILE';
    }
    totalSize += fileValue.size;
    promises.push(
      new Promise(function (resolve, reject) {
        $.get({
          cache: false,
          url: urlPreSignedPostObject,
          data: {
            filename: fileValue.name,
            bucketType: bucketType,
            contentType: contentType,
          },
          success: function (response) {
            let formData = new FormData();
            $.each(response['inputs'], function (index, value) {
              formData.append(index, value);
            });
            formData.append('file', fileValue);

            /*for (var [key, value] of formData.entries()) {
                            console.log(key, value);
                        }*/

            let promise = new Promise(function (resolve, reject) {
              $.ajax({
                cache: false,
                url: response['attr']['action'],
                type: response['attr']['method'],
                contentType: false,
                enctype: response['attr']['enctype'],
                processData: false,
                data: formData,
                success: function (xmlDoc) {
                  /* Response structure XML
                   * <PostResponse>
                   *     <Location>https://{BUCKET}.s3.amazonaws.com/{KEY}</Location>
                   *     <Bucket>{BUCKET}</Bucket>
                   *     <Key>{KEY}</Key>
                   *     <ETag>{ETAG}</ETag>
                   * </PostResponse> */

                  let $xml = $(xmlDoc),
                    bucket = $xml.find('Bucket').text(),
                    key = $xml.find('Key').text(),
                    response = {};

                  keysSuccess.push(key);
                  uploadedSize += fileValue.size;

                  response['status'] = 'success';
                  resolve(JSON.stringify(response));
                },
                error: function (jqXHR) {
                  fails.push(fileValue.name);
                  let response = {};
                  response['status'] = 'fail';
                  response['statusText'] = jqXHR['statusText'];
                  response['code'] = jqXHR['status'];
                  if (typeof jqXHR['responseJSON'] === 'undefined') {
                    response['serverResponse'] = '';
                  } else {
                    response['serverResponse'] = jqXHR['responseJSON']['name'];
                  }

                  resolve(JSON.stringify(response));
                },
              });
            }).then(
              function (value) {
                resolve(value);
              },
              function (value) {
                reject(value);
              }
            );
          },
          error: function (response) {
            reject(fileValue.name);
          },
        });
      })
    );
  });
  if (promises.length > 0) {
    Promise.all(promises).then(
      function (data) {
        let endTimestamp = Date.now();
        $.post({
          cache: false,
          url: '/system/associate-entity-and-files',
          data: {
            entityId: entityId,
            entityType: entityType,
            mediaType: mediaType,
            keysSuccess: JSON.stringify(keysSuccess),
            filenamesFails: JSON.stringify(fails),
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            uploadedSize: uploadedSize,
            totalSize: totalSize,
          },
        })
          .done(function (response) {
            switch (response['status']) {
              case 'success':
                let textError = '';
                if (fails.length == 0) {
                  successAction();
                } else {
                  let totalFilesCount =
                    Number(fails.length) + Number(keysSuccess.length);
                  textError =
                    response['data']['entityData'] +
                    ' Не загружено ' +
                    fails.length +
                    '/' +
                    totalFilesCount + '#' + JSON.stringify(response['data']);
                  /*textError += "\nСледующие файлы не были загружены: ";
                                    $.each(fails, function (index, value) {
                                        textError += (value+"\n");
                                    });
                                    textError += " страница будет перезагружена.\nПовторите попытку загрузки указанных файлов.";
                                    textError += "\nОтветы сервера: ";
                                    $.each(data, function (index, value) {
                                        let object = JSON.parse(value);
                                        if (object['status'] != "success" && value['serverResponse'] != "") {
                                            textError += (value['serverResponse']+", ");
                                        }
                                    });*/
                  failAction(textError);
                }
                break;
              case 'fail':
                alert(
                  'Ошибка при попытке привязать файлы. Ответ сервера: ' +
                  response['msg']
                );
                break;
              default:
                alert('Неизвестная ошибка. Файлы не были привязаны к объекту');
                break;
            }
          })
          .fail(function (jqXHR) {
            let textKeysSuccess = '';
            $.each(keysSuccess, function (index, value) {
              textKeysSuccess += value + ', ';
            });
            alert(
              'ВНИМАНИЕ! Указанные ниже файлы были загружены, но не привязаны к объекту.\n' +
              'Сообщите администратору названия файлов:\n' +
              textKeysSuccess +
              '\n\n' +
              'Произошла ошибка при попытке запроса к Cartrack\n' +
              'Статус: ' +
              jqXHR['statusText'] +
              '\n' +
              'Код статуса: ' +
              jqXHR['status'] +
              '\n' +
              'Ответ сервера: ' +
              jqXHR['responseJSON']['name'] +
              '\n'
            );
          });
      },
      function (data) {
        alert('Неизвестная ошибка. Статус: PROMISE_REJECT');
      }
    );
  }
};

let getDataTableCarsTypes = (data, url, resolve, reject) => {
  new Promise(function (resolve, reject) {
    $.post({
      cache: false,
      url: url,
      data: data,
    })
      .done(function (dataTable) {
        resolve(dataTable);
      })
      .fail(function (jqXHR) {
        let errorMsg =
          'Не удалось получить данные по выбранному фильтру\n' +
          'Статус: ' +
          jqXHR['statusText'] +
          '\n' +
          'Код статуса: ' +
          jqXHR['status'] +
          '\n' +
          'Ответ сервера: ' +
          jqXHR['responseJSON']['name'] +
          '\n';
        alert(errorMsg);
        reject(errorMsg);
      });
  }).then(
    function (value) {
      resolve(value);
    },
    function (value) {
      resolve(value);
    }
  );
};

let createTableCarsTypesStocks = (stocksIds, data, url, idDivTable, title) => {
  let promises = [];

  $.each(stocksIds, function (index, stockId) {
    let internalData = {
      stockId: stockId,
      senderId: data['senderId'],
      ownerId: data['ownerId'],
      countMinStorageDays: data['countMinStorageDays'],
    };
    promises.push(
      new Promise(function (resolve, reject) {
        getDataTableCarsTypes(internalData, url, resolve, reject);
      })
    );
  });
  if (promises.length > 0) {
    Promise.all(promises).then(
      function (data) {
        $(idDivTable).html('');
        let isErrorPartTable = false,
          i = 1,
          dataTable = [],
          htmlTable =
            '<h4 class="text-center">' +
            title +
            '</h4>' +
            '<table class="table table-striped">' +
            '<thead>' +
            "<tr class='active'>" +
            '<th>№</th>' +
            '<th>Трек-номер</th>' +
            '<th>Машина</th>' +
            '<th>Владелец</th>' +
            '<th>Склад</th>' +
            '<th>Сектор</th>' +
            '<th>Время хранения</th>' +
            '</tr>' +
            '</thead>' +
            '<tbody>';
        $.each(data, function (index, value) {
          if (Array.isArray(value)) {
            dataTable = dataTable.concat(value);
          } else {
            isErrorPartTable = true;
          }
        });
        if (isErrorPartTable) {
          alert(
            'Произошла ошибка при попытке загрузить часть таблицы. Попробуйте еще раз'
          );
        } else {
          dataTable.sort(function (a, b) {
            let param1 = a['storageDays'],
              param2 = b['storageDays'];
            if (a['storageDays'] === false) param1 = 999999999;
            if (b['storageDays'] === false) param2 = 999999999;

            return param2 - param1;
          });

          dataTable.forEach(function (row, key, dataTable) {
            htmlTable +=
              '<tr>' +
              '<td>' +
              i +
              '</td>' +
              '<td>' +
              row['trackNum'] +
              '</td>' +
              '<td>';
            if (row['isMore60days'] === true || row['storageDays'] === false) {
              htmlTable +=
                '<i class="far fa-clock color-red" title="Хранится больше 60 дней"></i> ';
            } else if (row['isMore30days'] === true) {
              htmlTable +=
                '<i class="far fa-clock color-warning" title="Хранится больше 30 дней"></i> ';
            }
            if (row['isBoundary'] === true) {
              htmlTable +=
                '<i class="fas fa-exclamation color-red" title="Пограничная"></i> ';
            }
            if (row['isCompleted'] === true) {
              htmlTable +=
                '<i class="fas fa-check-square color-warning standard-size-icon" title=\'Работа с машиной завершена\'></i> ';
            }
            if (row['isRemoved'] === true) {
              htmlTable +=
                '<i class="fas fa-times-circle color-red standard-size-icon" title=\'Машина удалена\'></i> ';
            }
            if (row['isDrivable'] !== true) {
              htmlTable +=
                '<i class="fas fa-truck-moving color-red standard-size-icon" title="Не ходовая"></i> ';
            }
            if (row['isDepartureTrip'] === true) {
              if (row['tripFullName'] === false) {
                htmlTable +=
                  '<i class="fas fa-ship color-green" title="Название рейса неизвестно"></i> ';
              } else {
                htmlTable +=
                  '<i class="fas fa-ship color-green" title="Погрузка: ' +
                  row['tripFullName'] +
                  '"></i> ';
              }
            }
            if (row['isRequestIssue'] === true) {
              htmlTable +=
                '<i class="fas fa-undo-alt color-green" title="Убывает к отправителю"></i> ';
            }
            htmlTable +=
              '<a href="/observer/object?id=' +
              row['carId'] +
              '">' +
              row['carName'] +
              '</a></td>';
            if (row['owner'].toLowerCase() == 'неопределенный владелец') {
              htmlTable +=
                '<td class="color-red">' + row['owner'].toUpperCase() + '</td>';
            } else {
              htmlTable += '<td>' + row['owner'].toUpperCase() + '</td>';
            }
            htmlTable += '<td>' + row['stock'] + '</td>';
            htmlTable += '<td>' + row['sector'] + '</td>';
            if (row['storageDays'] === false) {
              htmlTable += '<td class="color-red">Неизвестно</td>';
            } else {
              htmlTable += '<td>' + row['storageDays'] + ' дн.</td>';
            }
            htmlTable += '</tr>';
            i++;
          });

          htmlTable += '</tbody></table>';

          $(idDivTable).html(htmlTable);
          let top = $(idDivTable).offset().top;
          $('body,html').animate({ scrollTop: top - 50 }, 400);
        }
      },
      function (data) {
        alert('Неизвестная ошибка. Статус: PROMISE_REJECT');
      }
    );
  }
};

let isSupportUserMedia = () => {
  return (navigator.mediaDevices.getUserMedia =
    navigator.mediaDevices.getUserMedia ||
    navigator.mediaDevices.getUserMedia.webkitGetUserMedia ||
    navigator.mozGetUserMedia ||
    navigator.msGetUserMedia ||
    null);
};

let startVideoThread = (videoBoxSelector) => {
  return new Promise(function (resolve, reject) {
    if (isSupportUserMedia()) {
      let constraints = {
        video: {
          width: {
            min: 2592,
          },
          height: {
            min: 1944,
          },
        },
        audio: false,
      };

      let video = document.querySelector(videoBoxSelector);

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function (mediaStream) {
          video.srcObject = mediaStream;
          video.onloadedmetadata = function (e) {
            video.play().catch(function (err) {
              console.log(err);
              reject('HTMLMedia​ElementPlayError');
            });
          };
          resolve(video);
        })
        .catch(function (err) {
          console.log(err);
          reject('getUserMediaError');
        });
    } else {
      reject('NotSupportBrowserError');
    }
  });
};

let takeSnippetVideo = (videoObject, canvasBoxSelector) => {
  try {
    let canvas = document.querySelector(canvasBoxSelector);
    canvas.width = videoObject.videoWidth;
    canvas.height = videoObject.videoHeight;
    canvas.getContext('2d').drawImage(videoObject, 0, 0);
    let data = canvas.toDataURL('image/jpeg'); // image/webp
    return data;
  } catch (e) {
    return false;
  }
};

let urlToFile = (url, filename, mimeType) => {
  return fetch(url)
    .then(function (res) {
      return res.arrayBuffer();
    })
    .then(function (buf) {
      return new File([buf], filename, { type: mimeType });
    });
}; // return promise

let isValidValue = (value) => {
  return (
    typeof value !== 'undefined' &&
    value != 'undefined' &&
    value !== '' &&
    value !== null
  );
};

let defaultAjaxRequest = (
  method,
  url,
  data,
  isCancelActions = false,
  successAction = (response) => {
    location.reload();
  },
  failAction = (response) => {
    alert('Произошла ошибка. \nОтвет сервера: ' + response['msg']);
  },
  defaultAction = (response) => {
    alert('Неизвестная ошибка');
  },
  failAjaxAction = (jqXHR) => {
    let serverResponse = '';
    if (typeof jqXHR['responseJSON'] !== 'undefined') {
      serverResponse = jqXHR['responseJSON']['name'];
    }
    alert(
      'Произошла ошибка при попытке запроса к Cartrack\n' +
      'Статус: ' +
      jqXHR['statusText'] +
      '\n' +
      'Код статуса: ' +
      jqXHR['status'] +
      '\n' +
      'Ответ сервера: ' +
      serverResponse +
      '\n'
    );
  }
) => {
  return new Promise(function (resolve, reject) {
    $.ajax({
      cache: false,
      method: method,
      url: url,
      data: data,
    })
      .done(function (response) {
        if (!isCancelActions) {
          switch (response['status']) {
            case 'success':
              successAction(response);
              break;
            case 'fail':
              failAction(response);
              break;
            default:
              defaultAction(response);
          }
        }
        resolve(response);
      })
      .fail(function (jqXHR) {
        if (!isCancelActions) {
          failAjaxAction(jqXHR);
        }
        reject(jqXHR);
      });
  });
};

let stylingEmptyInput = (inputIds) => {
  $.each(inputIds, function (index, id) {
    $(document).on('blur', '#' + id, function () {
      if (isValidValue(this.value)) {
        $("label[for='" + this.id + "']").removeClass('color-red');
        $(this).removeClass('border-danger');
      } else {
        $("label[for='" + this.id + "']").addClass('color-red');
        $(this).addClass('border-danger');
      }
    });
  });
};

let addCommentBroken = ($checkboxIsBroken, $commentBlock) => {
  let comment = $commentBlock.val();
  if ($checkboxIsBroken.checked) {
    if (
      comment.toUpperCase().indexOf('БИТЫЙ') === -1 &&
      comment.toUpperCase().indexOf('БИТАЯ') === -1
    ) {
      $commentBlock.val('БИТЫЙ ' + comment);
    }
  } else {
    comment = comment.replace(/БИТЫЙ/gi, '').replace(/БИТАЯ/gi, '').trim();
    $commentBlock.val(comment);
  }
};

/**
 *
 * @param startDate
 * @param endDate
 */
let getDaysBetweenDates = (startDate, endDate) => {
  let dateFirst = new Date(startDate),
    dateSecond = new Date(endDate),
    result = Math.ceil(
      Math.abs(dateSecond.getTime() - dateFirst.getTime()) / (1000 * 3600 * 24)
    );

  if (isNaN(result)) {
    result = undefined;
  }

  return result;
};

let imageToPrint = (source, orientation = null) => {
  let style = '';
  if (orientation === 'portrait') {
    style = '<style>@media print{@page {size:portrait}}</style>';
  } else if (orientation === 'landscape') {
    style = '<style>@media print{@page {size:landscape}}</style>';
  }
  return (
    '<html><head>' +
    style +
    '<script>function step1(){\n' +
    "setTimeout('step2()', 10);}\n" +
    'function step2(){window.print();window.close()}\n' +
    "</script></head><body onload='step1()'>\n" +
    "<img src='" +
    source +
    "' /></body></html>"
  );
};

/**
 *
 * @param source
 * @param orientation (portrait, landscape, null)
 */
let printImage = (source, orientation = null) => {
  var Pagelink = 'about:blank';
  var pwa = window.open(Pagelink, '_new');
  pwa.document.open();
  pwa.document.write(imageToPrint(source, orientation));
  pwa.document.close();
};

let deliveryDriveToPortAdd = (
  objectId,
  planId,
  successAction = (response) => {
    location.reload();
  },
  failAction = (jqXHR) => {
    let serverResponse = '';
    if (typeof jqXHR['responseJSON'] !== 'undefined') {
      serverResponse = jqXHR['responseJSON']['name'];
    }
    alert(
      'Ошибка при попытке выполнить действие\n' +
      'Статус: ' +
      jqXHR['statusText'] +
      '\n' +
      'Код статуса: ' +
      jqXHR['status'] +
      '\n' +
      'Текст: ' +
      jqXHR['responseText'] +
      '\n' +
      'Ответ сервера: ' +
      serverResponse +
      '\n'
    );
  }
) => {
  let data = { objectId: objectId, planId: planId };

  $.post({ cache: false, url: '/navis/delivery-to-port-add', data: data })
    .done(function (response) {
      successAction(response);
    })
    .fail(function (jqXHR) {
      failAction(jqXHR);
    });
};

let deliveryDriveToPortRemove = (
  objectId,
  planId,
  successAction = (response) => {
    let htmlLink =
      "<a href='' class='addDeliveryDriveToPort' data-object_id='" +
      objectId +
      "' data-plan_id='" +
      planId +
      "' data-object_name='" +
      objectName +
      "' data-object_vin='" +
      objectVin +
      "'>Доставить</a>";

    $(`#dlv-${objectId}`).html(htmlLink);
    $(`#dlv-check-${objectId} i`).remove();
  },
  failAction = (jqXHR) => {
    let serverResponse = '';
    if (typeof jqXHR['responseJSON'] !== 'undefined') {
      serverResponse = jqXHR['responseJSON']['name'];
    }
    alert(
      'Ошибка при попытке выполнить действие\n' +
      'Статус: ' +
      jqXHR['statusText'] +
      '\n' +
      'Код статуса: ' +
      jqXHR['status'] +
      '\n' +
      'Текст: ' +
      jqXHR['responseText'] +
      '\n' +
      'Ответ сервера: ' +
      serverResponse +
      '\n'
    );
  }
) => {
  let data = { objectId: objectId, planId: planId };

  $.post({ cache: false, url: '/navis/delivery-to-port-remove', data: data })
    .done(function (response) {
      successAction(response);
    })
    .fail(function (jqXHR) {
      failAction(jqXHR);
    });
};

let cancelObjectFromPlan = (
  objectId,
  planId,
  reasonId,
  successAction = (response) => {
    location.reload();
  },
  failAction = (jqXHR) => {
    let serverResponse = '';
    if (typeof jqXHR['responseJSON'] !== 'undefined') {
      serverResponse = jqXHR['responseJSON']['name'];
    }
    alert(
      'Ошибка при попытке выполнить действие\n' +
      'Статус: ' +
      jqXHR['statusText'] +
      '\n' +
      'Код статуса: ' +
      jqXHR['status'] +
      '\n' +
      'Текст: ' +
      jqXHR['responseText'] +
      '\n' +
      'Ответ сервера: ' +
      serverResponse +
      '\n'
    );
  }
) => {
  let data = { objectId: objectId, planId: planId, reasonId: reasonId };

  if (isValidValue(reasonId) && reasonId !== 0) {
    $.post({ cache: false, url: '/navis/remove', data: data })
      .done(function (response) {
        successAction(response);
      })
      .fail(function (jqXHR) {
        failAction(jqXHR);
      });
  } else {
    alert('Выберите причину снятия');
  }
};

let moveobjectFromPlanToNewPlan = (
  objectId,
  currentPlanId,
  newPlanId,
  reasonId,
  successAction = (response) => {
    location.reload();
  },
  failAction = (jqXHR) => {
    let serverResponse = '';
    if (typeof jqXHR['responseJSON'] !== 'undefined') {
      serverResponse = jqXHR['responseJSON']['name'];
    }
    alert(
      'Ошибка при попытке выполнить действие\n' +
      'Статус: ' +
      jqXHR['statusText'] +
      '\n' +
      'Код статуса: ' +
      jqXHR['status'] +
      '\n' +
      'Текст: ' +
      jqXHR['responseText'] +
      '\n' +
      'Ответ сервера: ' +
      serverResponse +
      '\n'
    );
  }
) => {
  let data = { objectId: objectId, currentPlanId: currentPlanId, newPlanId: newPlanId, reasonId: reasonId };

  if (currentPlanId != 0 && newPlanId !== 0 && reasonId != 0) {
    $.post({ cache: false, url: "/navis/move", data: data })
      .done(function (response) {
        successAction(response);
      })
      .fail(function (jqXHR) {
        failAction(jqXHR);
      });
  } else {
    window.alert("Не все параметры получены");
  }
};

let changeObjectVin = (
  objectId,
  newVin,
  successAction = (response) => {
    location.reload();
  },
  failAction = (jqXHR) => {
    let serverResponse = '';
    if (typeof jqXHR['responseJSON'] !== 'undefined') {
      serverResponse = jqXHR['responseJSON']['name'];
    }
    alert(
      'Ошибка при попытке выполнить действие\n' +
      'Статус: ' +
      jqXHR['statusText'] +
      '\n' +
      'Код статуса: ' +
      jqXHR['status'] +
      '\n' +
      'Текст: ' +
      jqXHR['responseText'] +
      '\n' +
      'Ответ сервера: ' +
      serverResponse +
      '\n'
    );
  }
) => {
  let data = { new_vin: newVin };

  $.post({ cache: false, url: '/object/change-vin?id=' + objectId, data: data })
    .done(function (response) {
      successAction(response);
    })
    .fail(function (jqXHR) {
      failAction(jqXHR);
    });
};

$(document).on('click', '.action_url', function (event) {
  event.preventDefault();
  const actionUrl = $(this).data('action-url');
  fetch(actionUrl)
    .then(x => x.json())
    .then((data) => {
      if (data.error !== null && data.error !== undefined) {
        throw data.error;
      }
      const cellId = $(this).data('id');
      if (cellId === null || cellId === undefined) {
        return;
      }
      const cell = $(`#${cellId}`);
      if (cell === null || cell === undefined) {
        return;
      }
      cell.html('<i style="color:green" class="fas fa-check"></i>');
    })
    .catch(alert);
});
$(document).on('click', '#cancel_modal_alien-delivery-list', function (event) {
  event.preventDefault();
  $('#modalMainFrame').modal('hide');
});
